// Payment Handlers
var fundingAccountGatewayHandler_CC;
var fundingAccountGatewayHandler_ACH;

var default_TimeOfAppointment = "",
  default_DateOfAppointment = "";

// Retry counters for tidewater ecomm - values set in submitOrderCaptureSF()
var getScheduleRetries = 0,
    getTaxesRetries    = 0,
    sendPaymentRetries = 0;

// Checkout steps
var orderStep = 1,
  orderStepMax = 0,
  cookieLabel_product_selection = "lumos_product_selection",
  creditCheckAmount = 0,
  creditCheckDepositAmount = 0,
  creditCheckType = "",
  isProcessingOrder = false,
  ns_ecomm_session_id_name = "",
  nsTimer = 0,
  scheduleTries = 0,
  orderaccountid = -1,
  orderserviceid = -1,
  orderStreet = "",
  orderCity = "",
  orderState = "",
  orderZIP = "",
  usernameCreated = "",
  passwordCreated = "",
  tokenExpiry = 0,
  currentProduct = '';

var server_environment = "live"; // server environment var set in loadEcom

var hasClickedContinueShopping = false;
var phonesMasks = [{ mask: "(###) ###-####" }];

var checkTokenInterval = {};
var countdownTimerInterval = {};


const originalSetItem = localStorage.setItem;

localStorage.setItem = function(key, value) {
  const event = new Event('itemInserted');

  event.value = value; // Optional..
  event.key = key; // Optional..

  document.dispatchEvent(event);

  originalSetItem.apply(this, arguments);
};


var serviceChecked = false; // Flag to check if service is checked

jQuery(document).ready(function ($) {

  //push page load type
  const observer = new PerformanceObserver((list) => {
    list.getEntries().forEach((entry) => {
      var data = {
        event: 'shop_page_load',
        shop_page_load_entry: entry.name,
        shop_page_load_type: entry.type,
      };
      
      window.dataLayer.push(data);
    });
  });

  observer.observe({ type: "navigation", buffered: true });

  pushStoredFEACData(); //push any data waiting for shop page

  //confirmation for page nav off, does not work for mobile safari
  window.onbeforeunload = function() { return true; };

  document.addEventListener("itemInserted", function(e) {
    if(e.key == cookieLabel_product_selection) {

      var payloadJSON =  JSON.stringify(JSON.parse(e.value), null, 2);

      $('#lumos-debug-payload-output').text("/\/\ Lumos Product Payload: \n" + payloadJSON );
      // prettyPrint();
    }
  })

  // Scheduling switching
  $('#scheduling-i-need-help').click(function() {
    $('#schedule-installation-form-wrap').addClass('hide');
    $('#schedule-installation-manual-form-wrap').removeClass('hide');
  });
  $('#scheduling-back-to-automatic-scheduling').click(function() {
    $('#schedule-installation-form-wrap').removeClass('hide');
    $('#schedule-installation-manual-form-wrap').addClass('hide');
  });



  $('#lumos-debug-console-button').click(function() {
    $('#lumos-debug-console').toggleClass('hide');
  })

  $('#termsConditionsModal a[href*="#"]').click(function(e) {
    e.preventDefault();

    var target = $(this).attr('href');

    $('#termsConditionsModal').animate({
        scrollTop: $(target).offset().top - 200
    }, 1000);
  })

  $('#termsConditionsModal a:not([href*="#"]').each(function() {
    $(this).attr('target', '_blank');
  });


  $('input[name="checkout-payment-selection"]').change(function () {
    var checkedID = $('input[name="checkout-payment-selection"]:checked').val();
    // console.log(checkedID);
    $("#payment-tabs .tab-pane").each(function () {
      $(this).removeClass("show").removeClass("active");
    });
    $('#payment-tabs .tab-pane[data-content-for="' + checkedID + '"]')
      .addClass("show")
      .addClass("active");

    if (checkedID == "cc") {
      initPaymentSF_cc();
    } else {
      initPaymentSF_ach();
    }
  });

  // Set up elements for lazy scroll
  lazyScroll();
});

// (function($) {

// on load we push tech_stack to the dataLayer to populate w/ events
$(document).ready(function() {
  // envConsoleLog("lumos_address_tech_stack", localStorage.getItem("lumos_address_tech_stack"));
  if (localStorage.getItem("lumos_address_tech_stack") !== null) {
      var data = {
          tech_stack: localStorage.getItem("lumos_address_tech_stack"),
      };
      
      window.dataLayer.push(data);
  }

});


// Load product listing template
// reloadEcommProducts();
// var step2Details = $(".order-step-indicator [data-step='2']");
// function toggleStep2(action) {
//   if (action == "remove") {
//     $(".order-step-indicator [data-step='2']").addClass("hide");
//     $(".mobile-step-indicator [data-step='2']").addClass("hide");
//     // $(".order-step-indicator  .data-step-number") for each of these except 1, reduce the number
//     let stepNumbers = $(".order-step-indicator .data-step-number");
//
//     if(stepNumbers[stepNumbers.length - 1].innerText == 5){
//       for (let i = 1; i < stepNumbers.length; i++) {
//         if(i > 1){
//           stepNumbers[i].innerText = i;
//         }
//       }
//     }
//
//     // set step2 button label to be Customize Package
//     $(".order-step[data-order-step='1'] .next-step").text("Step 2: Customize Package");
//     // for the other next-step buttons, decrease step by 1 by finding substr Step # and replacing
//     $(".order-step[data-order-step='3'] .next-step").text("Step 3: Your Details");
//     $(".order-step[data-order-step='4'] .next-step").text("Step 4: Review Order");
//   }
//   if (action == "add") {
//     $(".order-step-indicator [data-step='2']").removeClass("hide");
//     $(".mobile-step-indicator [data-step='2']").removeClass("hide");
//
//     let stepNumbers = $(".order-step-indicator .data-step-number");
//
//     // if the highest number is not already 5
//     if(stepNumbers && stepNumbers[stepNumbers.length - 1].innerText != 5){
//       for (let i = 1; i < stepNumbers.length; i++) {
//         if(i > 1){
//           stepNumbers[i].innerText = i + 1;
//         }
//       }
//     }
//
//     $(".order-step[data-order-step='1'] .next-step").text("Step 2: Wi-Fi Experience");
//     $(".order-step[data-order-step='2'] .next-step").text("Step 3: Customize Package");
//     $(".order-step[data-order-step='3'] .next-step").text("Step 4: Your Details");
//     $(".order-step[data-order-step='4'] .next-step").text("Step 5: Review Order");
//   }
// }
// Check if the current market is within the disabled markets
async function initShop() {

  const currentMarket = localStorage.getItem("lumos_address_tech_stack")?.toLowerCase();
  const disabledMarkets = $(".wf-shopfiber-v3").attr("data-disable-market")?.toLowerCase().split(" ");
  const marketIsDisabled = (currentMarket && disabledMarkets && disabledMarkets.includes(currentMarket));

  envConsoleLog("Market disabled? ", marketIsDisabled);

  await updatePageProducts();

  if (marketIsDisabled) {
    $('.shop-now-button').addClass('disabled');
    $('[data-ecomm-loading]').addClass('hide');
    $('[data-ecomm-set-address]').removeClass('hide');
    $('[data-ecomm-container]').addClass('hide');
    $('.order-step-column').removeClass('shadow');
    if ($('#addressCheckerModal').hasClass('show')) {
      // Wait for #addressCheckerModal to close
      $('#addressCheckerModal').on('hidden.bs.modal', function () {
        $('#disable-market-modal-trigger').click();
      });
    } else {
      // If #addressCheckerModal is not open, open modal immediately
      $('#disable-market-modal-trigger').click();
    }
    return;
  } else {
    // Load product listing template if market is enabled
    reloadEcommProducts();
    // envConsoleLog("Market is enabled", currentMarket);
  }
}

$(document).ready(initShop);

// Only perform actions when ecomm element is available
if ($("#order-info").length) {
  console.log("lets do ecomm");

  // Phone Number Input Mask
  $("#account_service_contact_phone").inputmask({
    mask: phonesMasks,
    greedy: false,
    definitions: { "#": { validator: "[0-9]", cardinality: 1 } },
  });

  $("#account_service_contact_mobile_phone").inputmask({
    mask: phonesMasks,
    greedy: false,
    definitions: { "#": { validator: "[0-9]", cardinality: 1 } },
  });

  // if lumos_address_email is set in localstorage, set the email address
  if (localStorage.getItem("lumos_address_email")) {
    $("#account_service_contact_email").val(
      localStorage.getItem("lumos_address_email")
    );
    $("#account_service_contact_email").trigger("change");
    if ($("#account_service_email_address_use_contact").prop("checked")) {
      $("#account_service_email_address").val(localStorage.getItem("lumos_address_email"));
      $("#account_service_email_address").trigger("change");
    }
    $("#service_email_final").text(localStorage.getItem("lumos_address_email"));
  }

  // Schedule installation for non-api customers
  var availableDatesNonAPI = [];

  var startDateOffset = 5;
  var stopDateOffset = 10;

  var startDate = new Date();
  startDate.setHours(0, 0, 0, 0);
  // console.log(startDate);

  // console.log(holidays);

  while (startDateOffset > 0) {
    if (startDate.getDay() % 6) {
      startDateOffset--;
    }
    startDate = new Date(startDate.setDate(startDate.getDate() + 1));
  }

  // console.log('Start Date:' + startDate);

  var stopDate = new Date(startDate);
  stopDate.setDate(stopDate.getDate() + 1);
  stopDate.setHours(0, 0, 0, 0);

  while (stopDateOffset > 0) {
    if (stopDate.getDay() % 6 && !holidays.includes(stopDate.getTime())) {
      var dateOptions = {
        weekday: "long",
        year: "numeric",
        month: "short",
        day: "numeric",
      };
      availableDatesNonAPI.push(
        stopDate.toLocaleDateString("en-us", dateOptions)
      );
      stopDateOffset--;
    }
    stopDate = new Date(stopDate.setDate(stopDate.getDate() + 1));
  }

  // console.log("Available Dates: ", availableDatesNonAPI);

  $.each(availableDatesNonAPI, function (key, value) {
    $("#ns-installation-date-nonapi").append("<option>" + value + "</option>");
  });

  $("#ns-installation-date-nonapi").change(function () {
    $("#service_installation_date_nonapi").text($(this).val());
  });

  $("#ns-installation-time-nonapi").change(function () {
    $("#service_installation_time_nonapi").text($(this).val());
  });

  $("#ns-installation-instructions-nonapi").bind("keyup blur", function () {
    $("#service_installation_instructions_nonapi").text($(this).val());
    if ($(this).val()) {
      $("#service-installation-instructions-nonapi-container").removeClass(
        "hide"
      );
    } else {
      $("#service-installation-instructions-nonapi-container").addClass("hide");
    }
  });

  // Order Status Modal
  var $orderModal = $("#orderSubmitModal");
  var $orderModal_SFAPI = $("#orderSubmitModal-sfapi");
  var $orderModal_NonAPI = $("#orderSubmitModal-nonapi");

  // Set up sorting grid w/ Isotope
  // var $product_grid = $("#ns_available_products").isotope({
  //   itemSelector: ".product-row",
  //   getSortData: {
  //     price: function (itemElem) {
  //       var price = $(itemElem).attr("data-product-price");
  //       return parseFloat(price.replace(/[\(\)]/g, ""));
  //     },
  //   },
  // });

  window.addEventListener("beforeunload", (event) => {
    if (isProcessingOrder) {
      event.returnValue = "We haven't completed processing your order. Are you sure you want to leave?";
    }
  });

  $("#account_service_check_address").change(function () {
    if ($(this).val()) {
      $("#account_service_check_address").text("Change Address");
    }
  });

  // Open/Close mobile price tray
  // $("[data-expand-mobile-price]").click(function (e) {
  //   e.preventDefault();
  //   // $("#pricing-detail-accordion").foundation("toggle", $("#price-detail"));
  //   // $('.mobile-bottom-price .expand-button').toggleClass('closed');
  // });

  // Control for the accordion button state (up)
  // $("#pricing-detail-accordion").on("up.zf.accordion", function () {
  //   $(".mobile-bottom-price-new .expand-button").addClass("closed");
  //   $(".reveal-overlay[data-mobile-bottom-price-overlay]").hide();
  // });

  // Control for the accordion button state (down)
  $("#pricing-detail-accordion").on("down.zf.accordion", function () {
    $(".mobile-bottom-price-new .expand-button").removeClass("closed");
    $(".reveal-overlay[data-mobile-bottom-price-overlay]").show();
  });

  // $(".reveal-overlay[data-mobile-bottom-price-overlay]").click(function () {
  //   // $("#pricing-detail-accordion").foundation("up", $("#price-detail"));
  // });

  // Credit check payment form
  $(
    "#credit-check-deposit-cancel, #ns-credit-check-bank-payment-cancel, #ns-credit-check-cc-payment-cancel"
  ).click(function (e) {
    cancelOrder();
  });

  $("#credit-check-deposit-continue").click(function (e) {
    $("#credit-check-deposit").addClass("hide");
    $("#credit-check-payment").removeClass("hide");
  });

  $("#ns-credit-check-cc-cardmonth, #ns-credit-check-cc-cardyear").change(
    function () {
      $("#ns-credit-check-cc-cardexp").val(
        $("#ns-credit-check-cc-cardyear").val() +
          $("#ns-credit-check-cc-cardmonth").val()
      );
    }
  );

  // Credit Check CC Payment
  $("form#ns-credit-check-cc-payment").submit(function (e) {
    e.preventDefault();
  });

  $("form#ns-credit-check-cc-payment").bind(
    "formvalid.zf.abide",
    function (e, target) {
      // logNSEvent("ecomm - order processing - Run Credit Check: Submit Payment (Processing Step 4)");
      e.preventDefault();
      // $(this).find('.full-loader').removeClass('hide');

      // hide form
      $("#credit-check-payment").addClass("hide");

      // timeline spinner
      $("#orderSubmitModal .submission-indicator li")
        .eq(2)
        .removeClass("alert-ns");
      $("#orderSubmitModal .submission-indicator li").eq(2).addClass("current");

      var formData = $(this).serializeArray();
      var formDataObj = {};
      $(formData).each(function (index, obj) {
        formDataObj[obj.name] = obj.value;
      });
      formDataObj.action = "ns_make_payment_cc";
      formDataObj.FirstName = formDataObj.NameOnAccount.split(" ")
        .slice(0, -1)
        .join(" ");
      formDataObj.LastName = formDataObj.NameOnAccount.split(" ")
        .slice(-1)
        .join(" ");

      var paymentDate = new Date();
      formDataObj.PaymentDate = formatDateAPI(paymentDate);
      formDataObj.sessionId = localStorage.getItem(ns_ecomm_session_id_name);

      formDataObj.ExpirationDate = formDataObj.CardMonth + formDataObj.CardYear;

      // console.log(formDataObj);

      var $formElem = $(this);

      var serviceOrderID = $("#ns-credit-check-cc-serviceid").val();

      formDataObj.stepLabel = "Step3.3-Error-ns_make_payment_cc";

      ajaxCall(
        formDataObj,
        function (result) {
          // console.log(result);
          var response = $.parseJSON(result);

          if (response.Status == "success") {
            // NS GTM Timer End
            sendNSTimer(
              "Step3.3-ns_make_payment_cc"
            );

            // logNSEvent("ecomm - order processing - Run Credit Check: Submit Payment: Payment Success (Processing Step 4)");
            var additionalInfo =
              "Credit Check Results: $" +
              creditCheckAmount +
              " via " +
              creditCheckType +
              "";

            ajaxCall(
              {
                action: "set_service_comments",
                serviceOrderID: serviceOrderID,
                comment: additionalInfo,
                sessionId: localStorage.getItem(ns_ecomm_session_id_name),
                stepLabel: "Step3.4-Error-set_service_comments",
              },
              function (result) {
                var response = $.parseJSON(result);
                if (response.Status === "success") {
                  // NS GTM Timer End
                  sendNSTimer(
                    "Step3.4-set_service_comments"
                  );
                  // scheduleInstallation(serviceID, serviceOrderID);
                  scheduleInstallation(
                    $("#ns-credit-check-cc-serviceid").val(),
                    $("#ns-credit-check-cc-serviceorderid").val()
                  );
                } else {
                  // NS GTM Timer End
                  sendNSError(
                    "Step3.4-Error-set_service_comments-APIError:" +
                      response.Message
                  );
                  scheduleInstallation(
                    $("#ns-credit-check-cc-serviceid").val(),
                    $("#ns-credit-check-cc-serviceorderid").val()
                  );
                }
              },
              function (request, status, error) {
                scheduleInstallation(
                  $("#ns-credit-check-cc-serviceid").val(),
                  $("#ns-credit-check-cc-serviceorderid").val()
                );
              },
            );
          } else {
            // NS GTM Timer End
            sendNSError(
              "Step3.3-Error-ns_make_payment_cc-APIError: " +
                response.Message
            );

            // logNSEvent("ecomm - order processing - Error: Run Credit Check: Submit Payment: Payment Error - "+response.Message+" (Processing Step 4)");

            $("#orderSubmitModal .submission-indicator li")
              .eq(2)
              .removeClass("current");
            $("#orderSubmitModal .submission-indicator li")
              .eq(2)
              .addClass("alert-ns");

            $("#credit-check-payment").removeClass("hide");

            $formElem
              .find("[data-abide-error]")
              .text("We encountered the following error: " + response.Message);
            $formElem.find("[data-abide-error]").show();
            // $formElem.find('.full-loader').addClass('hide');
          }
        },
        function (request, status, error) {

          $("#orderSubmitModal .submission-indicator li")
            .eq(2)
            .removeClass("current");
          $("#orderSubmitModal .submission-indicator li")
            .eq(2)
            .addClass("alert-ns");

          $("#credit-check-payment").removeClass("hide");

          $formElem
            .find("[data-abide-error]")
            .text(
              "We encountered an error. Please try again later or you may contact our customer support at " + getSupportNumber() + "."
            );
          $formElem.find("[data-abide-error]").show();
        },
      );
    }
  );

  $("form#ns-schedule-install-manual").submit(function (e) {
    e.preventDefault();
    envConsoleLog("Schedule Installation Form Contact Submitted");

    // Hide error if not hidden
    $("form#ns-schedule-install-manual")
      .find("[data-abide-error]")
      .hide();

    var schedulingForm = document.querySelectorAll("#ns-schedule-install-manual")[0];

    if(!schedulingForm.checkValidity() || $("form#ns-schedule-install-manual .is-invalid").length) {
      // Form Invalid
    } else {
      scheduleTries++;

      // Form Validated
      $("#orderSubmitModal .submission-indicator li").eq(2).addClass("current");
      $("#orderSubmitModal .submission-indicator li")
        .eq(2)
        .removeClass("error");
      $("#orderSubmitModal .submission-indicator li")
        .eq(2)
        .removeClass("alert-ns");

      $("#schedule-installation-date").addClass("hide");
      $("form#ns-schedule-install")
        .find("[data-abide-error]")
        .hide();
    }

    var formData = $(this).serializeArray();
    var formDataObj = {};
    formDataObj.action = "schedule_service_installation_contact";
    formDataObj.sessionId = localStorage.getItem(ns_ecomm_session_id_name);
    formDataObj.ScheduleItem = {
      // "Id": null, // Auto populated on the backend.
  //     "RequestDate": null, // Auto populated on the backend.
      "ServiceOrderID": $("#ns-schedule-install-service-order-id-manual").val(),
      "AccountID": $("#ns-schedule-install-account-id-manual").val(),
      "ScheduleDateTimeRequested": $('#ns-installation-date-manual').val()+" 8am",
      "Note": $('#ns-installation-instructions-manual').val(),
  //     "Status": null // Auto populated on the backend.  Will be set to Open on insert then Scheduled after scheduling.
    };

    // console.log(formDataObj);

    refreshSession("Step4.3.1", function(){
      formDataObj.sessionId = localStorage.getItem(ns_ecomm_session_id_name);
      formDataObj.stepLabel = 'Step4.3-schedule_service_installation_contact';

      ajaxCall(
        formDataObj,
        function (result) {
          envConsoleLog("schedule_service_installation_contact", result);

          var response = $.parseJSON(result);

          if (response.Status == "success") {
            // NS GTM Timer End
            if (scheduleTries > 0) {
              sendNSTimer(
                "Step4.3-schedule_service_installation_contact-Attempt:" +
                  scheduleTries
              );
            } else {
              sendNSTimer(
                "Step4.3-schedule_service_installation_contact"
              );
            }

            $("#submitOrderCollapseButton").trigger("click"); // Hide the slide down for install before proceeding
            orderComplete();
          }
        },
        function (request, status, error) {
          // NS GTM Timer End
          if (scheduleTries > 0) {
            sendNSError(
              "Step4.4-Error-set_service_comments_contact-APICommError-Attempt:" +
                scheduleTries +
                ":" + request.responseText
            );
          } else {
            sendNSError(
              "Step4.4-Error-set_service_comments_contact-APICommError:" + request.responseText
            );
          }
          // stopNSTimer();

          // logNSEvent("ecomm - order processing - Error: Schedule Installation: Cannot Move Order Forward Alt - API Error, Sent To Order Complete Screen (Processing Step 4)");
          // console.log("service comments err");
          $("#submitOrderCollapseButton").trigger("click");
          orderComplete();
        }
      );

    });

  });

  // Schedule Installation
  $("form#ns-schedule-install").submit(function (e) {
    e.preventDefault();
    envConsoleLog("Schedule Installation Form Submitted");

    // Hide error if not hidden
    $("form#ns-schedule-install")
      .find("[data-abide-error]")
      .hide();

    var schedulingForm = document.querySelectorAll("#ns-schedule-install")[0];

    if (
      !schedulingForm.checkValidity() ||
      $("form#ns-schedule-install .is-invalid").length
    ) {
      // Form Invalid
    } else {
      // Form Validated
      scheduleTries++; // Add 1 to try counter

      $("#orderSubmitModal .submission-indicator li").eq(2).addClass("current");
      $("#orderSubmitModal .submission-indicator li")
        .eq(2)
        .removeClass("error");
      $("#orderSubmitModal .submission-indicator li")
        .eq(2)
        .removeClass("alert-ns");

      $("#schedule-installation-date").addClass("hide");
      $("form#ns-schedule-install")
        .find("[data-abide-error]")
        .hide();

      var formData = $(this).serializeArray();
      var formDataObj = {};
      $(formData).each(function (index, obj) {
        formDataObj[obj.name] = obj.value;
      });
      formDataObj.action = "schedule_service_installation";
      formDataObj.sessionId = localStorage.getItem(ns_ecomm_session_id_name);

      // console.log(formDataObj);

      refreshSession("Step4.3.0", function(){
        formDataObj.sessionId = localStorage.getItem(ns_ecomm_session_id_name);
        formDataObj.stepLabel = "Step4.3-Error-schedule_service_installation";
        ajaxCall(
          formDataObj,
          function (result) {
            envConsoleLog("schedule_service_installation", result);
            // logNSEvent("ecomm - order processing - Schedule Installation: Install Service Scheduled (Processing Step 4)");
            // console.log(result);
            var response = $.parseJSON(result);

            if (response.Status == "success") {
              // NS GTM Timer End
              if (scheduleTries > 0) {
                sendNSTimer(
                  "Step4.3-schedule_service_installation-Attempt:" +
                    scheduleTries
                );
              } else {
                sendNSTimer(
                  "Step4.3-schedule_service_installation"
                );
              }

              // Add service install comment
              ajaxCall(
                {
                  action: "set_service_comments",
                  serviceOrderID: $(
                    "#ns-schedule-install-service-order-id"
                  ).val(),
                  comment:
                    "Special Installation Instructions: " +
                    $("#ns-installation-instructions").val(),
                  sessionId: localStorage.getItem(ns_ecomm_session_id_name),
                  stepLabel: "Step4.4-Error-set_service_comments",
                },
                function (result) {
                  // NS GTM Timer End
                  if (scheduleTries > 0) {
                    sendNSTimer(
                      "Step4.4-set_service_comments-Attempt:" +
                        scheduleTries
                    );
                  } else {
                    sendNSTimer(
                      "Step4.4-set_service_comments"
                    );
                  }

                  // console.log(result);

                  $("#submitOrderCollapseButton").trigger("click"); // Hide the slide down for install before proceeding
                  orderComplete();
                },
                function (request, status, error) {
                  // NS GTM Timer End
                  if (scheduleTries > 0) {
                    sendNSError(
                      "Step4.4-Error-set_service_comments-APICommError-Attempt:" +
                        scheduleTries +
                        ":" + request.responseText
                    );
                  }

                  orderComplete();
                },
              );
            } else {
              // NS GTM Timer End
              if (scheduleTries > 0) {
                sendNSError(
                  "Step4.3-Error-schedule_service_installation-APIError:" +
                    response.Message +
                    "-Attempt: " +
                    scheduleTries
                );
              } else {
                sendNSError(
                  "Step4.3-Error-schedule_service_installation-APIError:" +
                    response.Message
                );
              }
              // stopNSTimer();

              // logNSEvent("ecomm - order processing - Error: Schedule Installation: API Error - " +response.Message+ " (Processing Step 4)");

              // Only display eror if this is not the second try
              if (scheduleTries < 2) {
                // Show error
                $("form#ns-schedule-install")
                  .find("[data-abide-error]")
                  .text(
                    "The date/time selected is no longer available. Please select another date/time below."
                  )
                  .show();

                // $("form#ns-schedule-install").find("[data-abide-error]").show();
                // re-fetch Available Dates
                // getScheduleDateTime($('#ns-schedule-install-service-id').val());
                getFacilitySplitterCheck(
                  $("#ns-schedule-install-service-id").val()
                );

                // $('#schedule-installation-date').removeClass('hide');
              } else {
                sessionStorage.setItem("lumos_auto_schedule_failure", 1);

                ajaxCall(
                  {
                    action: "set_service_comments",
                    serviceOrderID: $(
                      "#ns-schedule-install-service-order-id"
                    ).val(),
                    comment:
                      "Auto Scheduling Failed - Requested Date & Time: " +
                      $("#ns-installation-date").val() +
                      " " +
                      $("#ns-installation-time")
                        .find(
                          'option[value="' +
                            $("#ns-installation-time").val() +
                            '"]:first'
                        )
                        .text(),
                    sessionId: localStorage.getItem(ns_ecomm_session_id_name),
                    stepLabel: "Step4.7-Error-set_service_comments",
                  },
                  function (result) {
                    sendNSTimer(
                      "Step4.7-set_service_comments-Attempt:" +
                        scheduleTries
                    );
                    orderComplete();
                  },
                  function (request, status, error) {
                    sendNSError(
                      "Step4.7-Error-set_service_comments-APICommError-Attempt:" +
                        scheduleTries +
                        ":" + request.responseText
                    );
                    orderComplete();
                  },
                );
              }
            }
          },
          function (request, status, error) {
            ajaxCall(
              {
                action: "set_service_comments",
                serviceOrderID: $("#ns-schedule-install-service-order-id").val(),
                comment:
                  "Auto Scheduling Failed - Could not retrieve available dates from website API.",
                sessionId: localStorage.getItem(ns_ecomm_session_id_name),
                stepLabel: "Step4.7-Error-set_service_comments"
              },
              function (result) {
                sendNSTimer(
                  "Step4.7-set_service_comments-Attempt:" +
                    scheduleTries
                );
                orderComplete();
              },
              function (request, status, error) {
                sendNSError(
                  "Step4.7-Error-set_service_comments-APICommError-Attempt:" +
                    scheduleTries +
                    ":" + request.responseText
                );
                orderComplete();
              },
            );
          }
        )
      });
    }

    schedulingForm.classList.add("was-validated");
  });

  $("form#ns-schedule-install").bind(
    "formvalid.zf.abide",
    function (e, target) {
      e.preventDefault();
      envConsoleLog("Schedule Installation Form Validated");

      scheduleTries++; // Add 1 to try counter

      $("#orderSubmitModal .submission-indicator li").eq(2).addClass("current");
      $("#orderSubmitModal .submission-indicator li")
        .eq(2)
        .removeClass("error");
      $("#orderSubmitModal .submission-indicator li")
        .eq(2)
        .removeClass("alert-ns");

      $("#schedule-installation-date").addClass("hide");
      $("form#ns-schedule-install").find("[data-abide-error]").hide();

      var formData = $(this).serializeArray();
      var formDataObj = {};
      $(formData).each(function (index, obj) {
        formDataObj[obj.name] = obj.value;
      });
      formDataObj.action = "schedule_service_installation";

      // console.log(formDataObj);

      refreshSession("Step4.3.0", function(){
        formDataObj.sessionId = localStorage.getItem(ns_ecomm_session_id_name);
        formDataObj.stepLabel = "Step4.3-Error-schedule_service_installation";
        ajaxCall(
        formDataObj,
          function (result) {
            // logNSEvent("ecomm - order processing - Schedule Installation: Install Service Scheduled (Processing Step 4)");
            // console.log(result);
            var response = $.parseJSON(result);

            if (response.Status == "success") {
              // NS GTM Timer End
              if (scheduleTries > 0) {
                sendNSTimer(
                  "Step4.3-schedule_service_installation-Attempt:" +
                    scheduleTries
                );
              } else {
                sendNSTimer(
                  "Step4.3-schedule_service_installation"
                );
              }

              // Add service install comment
              ajaxCall(
                {
                  action: "set_service_comments",
                  serviceOrderID: $(
                    "#ns-schedule-install-service-order-id"
                  ).val(),
                  comment:
                    "Special Installation Instructions: " +
                    $("#ns-installation-instructions").val(),
                  sessionId: localStorage.getItem(ns_ecomm_session_id_name),
                },
                function (result) {
                  // NS GTM Timer End
                  if (scheduleTries > 0) {
                    sendNSTimer(
                      "Step4.4-set_service_comments-Attempt:" +
                        scheduleTries
                    );
                  } else {
                    sendNSTimer(
                      "Step4.4-set_service_comments"
                    );
                  }

                  // Move Order Forward
                  ajaxCall(
                    {
                      action: "move_order_forward_alt",
                      serviceOrderId: $(
                        "#ns-schedule-install-service-order-id"
                      ).val(),
                      sessionId: localStorage.getItem(ns_ecomm_session_id_name),
                    },
                    function (result) {
                      // NS GTM Timer End
                      if (scheduleTries > 0) {
                        sendNSTimer(
                          "Step4.5-move_order_forward_alt-Attempt:" +
                            scheduleTries
                        );
                      } else {
                        sendNSTimer(
                          "Step4.5-move_order_forward_alt"
                        );
                      }

                      ajaxCall(
                        {
                          action: "move_order_forward",
                          serviceOrderId: $(
                            "#ns-schedule-install-service-order-id"
                          ).val(),
                          sessionId: localStorage.getItem(
                            ns_ecomm_session_id_name
                          ),
                        },
                        function (result) {
                          // NS GTM Timer End
                          if (scheduleTries > 0) {
                            sendNSTimer(
                              "Step4.6-move_order_forward-Attempt:" +
                                scheduleTries
                            );
                          } else {
                            sendNSTimer(
                              "Step4.6-move_order_forward"
                            );
                          }

                          // logNSEvent("ecomm - order processing - Schedule Installation: Move Order Forward (Processing Step 4)");
                          // console.log(
                          //   "move order forward",
                          //   $("#ns-schedule-install-service-order-id").val(),
                          //   result
                          // );
                          orderComplete();
                        },
                        function (request, status, error) {
                          // NS GTM Timer End
                          if (scheduleTries > 0) {
                            sendNSTimer(
                              "Step4.6-Error-move_order_forward-API Comm Error-Attempt:" +
                                scheduleTries +
                                ":" + request.responseText
                            );
                          } else {
                            sendNSTimer(
                              "Step4.6-Error-move_order_forward-APICommError:" + request.responseText
                            );
                          }
                          // stopNSTimer();

                          // logNSEvent("ecomm - order processing - Error: Schedule Installation: Cannot Move Order Forward, Sent To Order Complete Screen (Processing Step 4)");
                          // console.log(
                          //   "move order forward-err",
                          //   $("#ns-schedule-install-service-order-id").val(),
                          //   result
                          // );
                          orderComplete();
                        },
                      );
                    },
                    function (request, status, error) {
                      // NS GTM Timer End
                      if (scheduleTries > 0) {
                        sendNSError(
                          "Step4.5-Error-move_order_forward_alt-APICommError-Attempt:" +
                            scheduleTries +
                            ":" + request.responseText
                        );
                      }

                      orderComplete();
                    },
                  );
                },
                function (request, status, error) {
                  // NS GTM Timer End
                  if (scheduleTries > 0) {
                    sendNSError(
                      "Step4.4-Error-set_service_comments-APICommError-Attempt:" +
                        scheduleTries +
                        ":" + request.responseText
                    );
                  }

                  orderComplete();
                },
              );
            } else {
              // NS GTM Timer End
              if (scheduleTries > 0) {
                sendNSError(
                  "Step4.3-Error-schedule_service_installation-APIError:" +
                    response.Message +
                    "-Attempt:" +
                    scheduleTries
                );
              } else {
                sendNSError(
                  "Step4.3-Error-schedule_service_installation-APIError:" +
                    response.Message
                );
              }
              // stopNSTimer();

              // logNSEvent("ecomm - order processing - Error: Schedule Installation: API Error - " +response.Message+ " (Processing Step 4)");

              // Only display eror if this is not the second try
              if (scheduleTries < 2) {
                // Show error
                $("form#ns-schedule-install")
                  .find("[data-abide-error]")
                  .text(
                    "The date/time selected is no longer available. Please select another date/time."
                  );
                $("form#ns-schedule-install")
                  .find("[data-abide-error]")
                  .removeClass("hide");
                $("form#ns-schedule-install").find("[data-abide-error]").show();
                // re-fetch Available Dates
                // getScheduleDateTime($('#ns-schedule-install-service-id').val());
                getFacilitySplitterCheck(
                  $("#ns-schedule-install-service-id").val()
                );

                // $('#schedule-installation-date').removeClass('hide');
              } else {
                sessionStorage.setItem("lumos_auto_schedule_failure", 1);

                ajaxCall(
                  {
                    action: "set_service_comments",
                    serviceOrderID: $(
                      "#ns-schedule-install-service-order-id"
                    ).val(),
                    comment:
                      "Auto Scheduling Failed - Requested Date & Time: " +
                      $("#ns-installation-date").val() +
                      " " +
                      $("#ns-installation-time")
                        .find(
                          'option[value="' +
                            $("#ns-installation-time").val() +
                            '"]:first'
                        )
                        .text(),
                    sessionId: localStorage.getItem(ns_ecomm_session_id_name),
                  },
                  function (result) {
                    sendNSTimer(
                      "Step4.7-set_service_comments-Attempt:" +
                        scheduleTries
                    );
                    orderComplete();
                  },
                  function (request, status, error) {
                    orderComplete();
                  },
                );
              }
            }
          },
          function (request, status, error) {

            ajaxCall(
              {
                action: "set_service_comments",
                serviceOrderID: $("#ns-schedule-install-service-order-id").val(),
                comment:
                  "Auto Scheduling Failed - Could not retrieve available dates from website API.",
                sessionId: localStorage.getItem(ns_ecomm_session_id_name),
                stepLabel: "Step4.7-Error-set_service_comments"
              },
              function (result) {
                sendNSTimer(
                  "Step4.7-set_service_comments-Attempt:" +
                    scheduleTries
                );
                orderComplete();
              },
              function (request, status, error) {
                orderComplete();
              },
            );
          },
        );
      });

    }
  );

  $("#orderSubmitModal .close-reveal-modal").click(function () {
    // logNSEvent("ecomm - button click - Order Processing Button: "+$(this).text());
    // $orderModal.foundation("close");
    // $orderModal_NonAPI.foundation("close");
  });

  // Set delay and relayout Isotope when expandin accordion
  // $("#ns_available_products .accordion-item").click(function (e) {
  //   setTimeout(function () {
  //     $product_grid.isotope("layout");
  //   }, 200);
  // });

  // Price sorting update grid
  // $("#lumos_product_sort_price").on("change", function () {
  //   switch ($(this).val()) {
  //     case "asc":
  //       $product_grid.isotope({
  //         sortBy: "price",
  //         sortAscending: true,
  //       });
  //       break;
  //     case "desc":
  //       $product_grid.isotope({
  //         sortBy: "price",
  //         sortAscending: false,
  //       });
  //       break;
  //     default:
  //       break;
  //   }
  // });

  // Service filter actions
  $("#lumos_product_filter_services input[type=checkbox]").on(
    "change",
    function () {
      var servicesSortValues = [];

      $("#lumos_product_filter_services input[type=checkbox]:checked").each(
        function () {
          servicesSortValues.push($(this).attr("data-filter"));
        }
      );

      // $product_grid.isotope({
      //   filter: servicesSortValues.join(", "),
      // });
    }
  );

  // Update fiber indictor/sort on change
  $("#fiber_speed").change(updateFiberSpeedSort);

  // Sort Actions
  $(".fiber-sort input").change(function () {
    if ($(this).is(":checked")) {
      $(this).parents("label").addClass("highlight");
    } else {
      $(this).parents("label").removeClass("highlight");
    }
  }); // end $('.fiber-sort input').change

  $(
    '#account_service_check_address, label[for="address_service_geocoded"], #address_service_geocode_mask'
  ).click(function () {
    $("#address-checker").toggleClass("open");
    $("#street1").focus();
    // logNSEvent('ecomm - button click - Open Address Checker from Form');
  });

  $(
    "#account_service_prefix, #account_service_first_name, #account_service_middle_name, #account_service_last_name, #account_service_suffix"
  ).on("change keyup", function () {
    // var accountName = $('#account_service_prefix').val() + ' ' + $('#account_service_first_name').val() + ' ' + $('#account_service_middle_name').val() + ' ' + $('#account_service_last_name').val() + ' ' + $('#account_service_suffix').val();
    var accountName =
      $("#account_service_first_name").val() +
      " " +
      $("#account_service_last_name").val();
    $("#service_account_final").text(accountName);
  });

  $("#account_service_contact_phone, #account_service_contact_phone_ext").on(
    "change keyup",
    function () {
      // $('#service_contact_final').text($('#account_service_contact_phone').val() + ' ' + $('#account_service_contact_phone_ext').val());
      $("#service_contact_final").text(
        $("#account_service_contact_phone").val()
      );
    }
  );

  $('#account_service_contact_mobile_phone').on(
    "change keyup",
    function () {
      // $('#service_contact_final').text($('#account_service_contact_phone').val() + ' ' + $('#account_service_contact_phone_ext').val());
      $("#service_mobile_final").text(
        $("#account_service_contact_mobile_phone").val()
      );

      if($("#account_service_contact_mobile_phone").val() == "") {
        $('[data-mobile-number-row]').each(function() {
          $(this).addClass('hide');
        });
      } else {
        $('[data-mobile-number-row]').each(function() {
          $(this).removeClass('hide');
        });
      }
    }
  )

  $("#account_service_contact_email").on("change keyup", function () {
    if ($("#account_service_email_address_use_contact").prop("checked")) {
      $("#account_service_email_address").val($(this).val());
      $("#account_service_email_address").trigger("change");
    }
    $("#service_email_final").text($(this).val());
  });

  $("#account_service_pin_va").bind("keyup mouseup", function () {
    $("#service_pin_final").text($(this).val());
    // console.log('pin change');
  });

  $("#sms-carrier-select").change(function () {
    if ($(this).val() === "Other") {
      $("#other-carrier").show();
    } else {
      $("#other-carrier").hide();
      $("#sms_carrier_final").text($(this).val());
    }
    // console.log("carrier change");
  });
  $("#other-carrier").on("change keyup", function () {
    $("#sms_carrier_final").text("Other - " + $("#other-carrier").val());
    // console.log("carrier change");
  });

  // Step 1 validation
  $('.order-step input[name="schedule-availability"]').change(function () {
    if ($(this).val() === "schedule") {
      $("#schedule-availability-date-day").prop("required", true);
      $("#schedule-availability-date-time").prop("required", true);
      $("#schedule-availability-date-day").prop("disabled", false);
      $("#schedule-availability-date-time").prop("disabled", false);
    } else {
      $("#schedule-availability-date-day").prop("required", false);
      $("#schedule-availability-date-time").prop("required", false);
      $("#schedule-availability-date-day").prop("disabled", true);
      $("#schedule-availability-date-time").prop("disabled", true);
      updateInstallationSchedule("At the first available time.");
    }
  });

  $("#schedule-availability-date-day, #schedule-availability-date-time").change(
    function () {
      var installText =
        "On a " +
        $("#schedule-availability-date-day").find("option:selected").text() +
        " " +
        $("#schedule-availability-date-time").find("option:selected").text();
      updateInstallationSchedule(installText);
    }
  );

  $("#order-schedule-installation").bind(
    "formvalid.zf.abide",
    function (e, target) {
      orderAdvance();
    }
  );

  // Step 2 validation
  // $("#order-customer-info").bind("forminvalid.zf.abide", function (e, target) {
  function customerFormValidate() {
    var customerInfoForm = document.querySelectorAll("#order-customer-info")[0];

    // console.log(customerInfoForm);

    if (
      !customerInfoForm.checkValidity() ||
      $("#order-customer-info .is-invalid").length
    ) {
      logNSEvent(
        "ecomm - form validation error - Correct Customer Info (Step 2) "
      );

      customerInfoForm.classList.add("was-validated");

      $([document.documentElement, document.body]).animate(
        {
          scrollTop:
            // $("#order-info").offset().top - ($(".top-nav").outerHeight() || 0),
            // $('#order-info').prevAll('.wf-floating-address-check').offset().top - ($("#header").outerHeight() || 0),
            // $('#order-customer-info').offset().top - ($("#header").outerHeight() || 0)
            $(
              "#order-customer-info *:invalid, #order-customer-info .is-invalid"
            )
              .first()
              .offset().top - ($("#header").outerHeight() || 0),
        },
        400
      );
    } else {
      $("[data-ecomm-working]").removeClass("hide");

      var $customerServiceAddress = $("#account_service_email_address");

      if ($customerServiceAddress.prop("required")) {
        ajaxCall(
          {
            action: "check_username",
            username: $customerServiceAddress.val().trim(),
            stepLabel: "Step-Error-check_username",
          },
          function (result) {
            // console.log(result);
            var response = jQuery.parseJSON(result);
            // console.log(response);
            if (response.Status === "success") {
              if (response.Data) {
                // Username Already Exists
                $customerServiceAddress
                  .addClass("is-invalid")
                  .removeClass("is-valid")
                  .next()
                  .text("This username already exists in our system");
                usernameStatus = false;
              } else {
                // Username Does not exist and can be registered
                $customerServiceAddress
                  .addClass("is-valid")
                  .removeClass("is-invalid")
                  .next()
                  .text(
                    $("#account_service_contact_email").attr(
                      "data-message-orig"
                    )
                  );

                usernameStatus = true;
              }
            } else {
              $customerServiceAddress
                .addClass("is-invalid")
                .removeClass("is-valid")
                .next()
                .text(
                  $("#account_service_contact_email").attr("data-message-orig")
                );
              usernameStatus = false;
            }

            if (!usernameStatus) {
              $([document.documentElement, document.body]).animate(
                {
                  scrollTop:
                    $(
                      "#order-customer-info *:invalid, #order-customer-info .is-invalid"
                    )
                      .first()
                      .offset().top - ($("#header").outerHeight() || 0),
                },
                400
              );
            } else {
              // Proceed...
              setFinalCheckoutScreen();
            }

            $("[data-ecomm-working]").addClass("hide");

            customerInfoForm.classList.add("was-validated");
          },
          function (request, status, error) {
            $("#account_service_contact_email")
              .addClass("is-invalid")
              .removeClass("is-valid")
              .next()
              .text(
                $("#account_service_contact_email").attr("data-message-orig")
              );

            $([document.documentElement, document.body]).animate(
              {
                scrollTop:
                  $(
                    "#order-customer-info *:invalid, #order-customer-info .is-invalid"
                  )
                    .first()
                    .offset().top - ($("#header").outerHeight() || 0),
              },
              400
            );

            $("[data-ecomm-working]").addClass("hide");
          },
        );
      } else {
        if (customerInfoForm.checkValidity()) {
          setFinalCheckoutScreen();
        }
        customerInfoForm.classList.add("was-validated");
      }
    }
  } // customerFormValidate()

  function setFinalCheckoutScreen() {
    // $('#account_service_email_address').val($('#account_service_contact_email').val());
    if ($("#account_service_email_address_use_contact").prop("checked")) {
      $("#account_service_email_address").val(
        $("#account_service_contact_email").val()
      );
    }

    $("[data-ecomm-working]").removeClass("hide");

    // Set service address
    $("#service_address_final_visible").text(
      $("#account_service_geocoded_visible").val()
    );
    $("#service_address_final").text($("#account_service_geocoded").val());

    // Set billing address
    if ($("#address_service_billing_same").prop("checked")) {
      $("#service_billing_final").text($("#account_service_geocoded").val());
      $("#service_billing_final_visible").text(
        $("#account_service_geocoded_visible").val()
      );
    } else {
      var billAddress =
        $("#address_service_billing_different_city").val() +
        " " +
        $("#address_service_billing_different_zip").val();

      if ($("#address_service_billing_physical").prop("checked")) {
        var aptNumber = "";
        if ($("#address_service_billing_different_apartment").val().length) {
          aptNumber = $("#address_service_billing_different_apartment").val();
        }
        billAddress =
          $("#address_service_billing_different_street_number").val() +
          " " +
          $("#address_service_billing_different_street_name").val() +
          " " +
          aptNumber +
          " " +
          billAddress;
      } else {
        billAddress =
          "PO Box " +
          $("#address_service_billing_different_pobox").val() +
          " " +
          billAddress;
      }

      $("#service_billing_final_visible").text(billAddress);
      $("#service_billing_final").text(billAddress);
    }

    // Set account information
    $("#service_username_final").text(
      $("#account_service_email_address").val()
    );
    $("#service_question_final").text(
      $("#account_service_security_question").val()
    );
    $("#service_answer_final").text(
      $("#account_service_security_answer").val()
    );

    $("[data-ecomm-working]").addClass("hide");
    orderAdvance();

    if (!$("#price-drawer-content").hasClass("show")) {
      $("#price-drawer-content-label button").click();
      // $("#price-drawer-content-label-mobile button").click(); //trigger the #price-drawer-content-mobile accordion using bs5 instead of button
    }

    // instead of opening the content for mobile we will now hide the mobile accordion, copy the html, and append it to the end of .product-wrap.product-review
    // $("#price-drawer-mobile").addClass("hide");
    let htmlContent = $("#price-drawer-mobile").prop('outerHTML');
    // remove price-drawer-mobile
    $("#price-drawer-mobile").addClass('d-none');
    $("#price-drawer-mobile").addClass('pre-checkout');

    $(".product-wrap.product-review").after(
      htmlContent
    );
    $("#price-drawer-content-label-mobile button").click();

    $("#price-drawer-content-label").addClass("invisible");
    // $("#price-drawer-content-label-mobile").addClass("invisible");

    $(".special-notification-terms").removeClass("hide");
  } // setFinalCheckoutScreen()

  // NS ID Email Address checkbox
  $("#account_service_email_address_use_contact").change(function () {
    if ($(this).prop("checked")) {
      $("#account_service_email_address").val(
        $("#account_service_contact_email").val()
      );
      $("#account_service_email_address").prop("readonly", true);
      $("#account_service_email_address").trigger("change");
    } else {
      $("#account_service_email_address").val("");
      $("#account_service_email_address").prop("readonly", false);
    }
  });

  // Step validation

  // sync terms check boxes, validated in case 5 below
  $(document).on('change', "input#termsconditions, input#termsconditions-mobile", function () {
    var tcID = $(this).attr("ID");
    var termsChecked = $(this).prop("checked");
    $("input#termsconditions, input#termsconditions-mobile").each(function () {
      if ($(this).attr("ID") !== tcID) {
        $(this).prop("checked", termsChecked);
      }
    });
  });

  // Next button actions
  $(
    ".order-step button.next-step, .mobile-bottom-price button.next-step, .mobile-bottom-price-new button.next-step"
  ).click(function () {
    // console.log("Step", $(this).parent(".order-step").attr("data-order-step"));
    envConsoleLog("Step", $(this).parent(".order-step").attr("data-order-step"));
    switch ($(this).parent(".order-step").attr("data-order-step")) {
      case "1":
        // Auto Select Wifi
        pushGA4EcommData("ecommerce_choose_your_plan_selection");
        if (
          $("#feature_3925_1").length &&
          $("#feature_3925_1").prop("checked") == false
          // &&
          // ($("#feature__2").prop("checked") == false ||
          //   $("#feature__3").prop("checked") == false ||
          //   $("#feature__4").prop("checked") == false)
        ) {
          $("#feature_3925_1").click();
          // console.log($("#feature_3925_1"));
        }

        // Free Wi-fi Default
        if (
          $("#feature_3925_2").length &&
          $("#feature_3925_2").prop("checked") == false
          // &&
          // ($("#feature__2").prop("checked") == false ||
          //   $("#feature__3").prop("checked") == false ||
          //   $("#feature__4").prop("checked") == false ||
          //   $("#feature__5").prop("checked") == false)
        ) {
          $("#feature_3925_2").click();
          // console.log($("#feature_3925_1"));
        }
        orderAdvance();
        break;
      case "2":
        pushGA4EcommData("ecommerce_wifi_experience_selection");
        orderAdvance();
        break;
      case "3":
        pushGA4EcommData("ecommerce_customize_package_selection");
        //$('#order-schedule-installation').foundation("validateForm");
        $("[data-ecomm-working]").removeClass("hide");
        var feature_stash = $.parseJSON(
          localStorage.getItem(cookieLabel_product_selection)
        );

        if (!uses_nsapi) {
          // console.log("does not use api");
          $("[data-ecomm-working]").addClass("hide");

          orderAdvance();
        } else {
          // console.log("uses api");
          ajaxCall(
            {
              action: "get_fees",
              productID: feature_stash.product_ns_id,
              stepLabel: "Step-Error-get_fees"
            },
            function (result) {
              var response = $.parseJSON(result);

              // console.log("Success", response, result);

              if (response.Status === "success") {
                $("#additionalCharges").text("");

                $("#serviceFeesModal span[data-fee-cost]").each(function () {
                  $(this).text("");
                  $(this).parents("[data-service-fee-row]").addClass("hide");
                });

                var ns_fees = 0;
                var hasVoice = $("#feature_4246_1").prop("checked");
                var hasVideo = $("#feature_00001_3").prop("checked");

                for (var i = 0; i < response.Data.length; i++) {
                  if (response.Data[i].Type == "Voice" && !hasVoice) {
                    continue;
                  }
                  if (response.Data[i].FeatureSubTypeId == 14 && !hasVideo) {
                    continue;
                  }

                  // Grab only positive and Active
                  if (
                    response.Data[i].Price > 0 &&
                    response.Data[i].Active == 1
                  ) {
                    ns_fees += response.Data[i].Price;

                    var formattedFee = "";

                    if (response.Data[i].Price !== 0) {
                      formattedFee =
                        "( $" +
                        parseFloat(response.Data[i].Price).toFixed(2) +
                        " )";
                    }
                    switch (response.Data[i].Name) {
                      // case "RES ACCESS RECOVERY CHARGE-FIBER":
                      //   break;
                      case "LTV Broadcast Surcharge":
                      case "Broadcast Surcharge":
                        $("#broadcastSurcharge span[data-fee-cost]").text(
                          formattedFee
                        );
                        $("#broadcastSurcharge").removeClass("hide");
                        break;
                      case "LTV Video Recovery Fee":
                      case "Video Recovery Fee":
                        $("#videoRecoveryFee span[data-fee-cost]").text(
                          formattedFee
                        );
                        $("#videoRecoveryFee").removeClass("hide");
                        break;
                      case "Internet Recovery Fee":
                        $("#internetRecoveryFee span[data-fee-cost]").text(
                          formattedFee
                        );
                        $("#internetRecoveryFee").removeClass("hide");
                        break;
                      case "LTV FCC Regulatory Fee":
                      case "FCC Regulatory Fee":
                        $("#fccRegulatoryFee span[data-fee-cost]").text(
                          formattedFee
                        );
                        $("#fccRegulatoryFee").removeClass("hide");
                        break;
                      default:
                        if (response.Data[i].Price !== 0) {
                          $("#additionalCharges").append(
                            '<div><h2 class="fs-3">' +
                              response.Data[i].Name +
                              " - " +
                              response.Data[i].Type +
                              " <span data-fee-cost>" +
                              formattedFee +
                              "</span></h2></div>"
                          );
                        }
                        break;
                    }
                  }
                }
                $("#ns-regulatory-fees").val(ns_fees);
                $("#ns-regulatory-fees").attr("data-price", ns_fees);

                if (ns_fees > 0) {
                  $(".disclaimer.fees span[data-fee-total]").text(
                    ns_fees.toFixed(2)
                  );

                  $(".disclaimer.nofees").addClass("hide");
                  $(".disclaimer.fees:not(.wifi):not(.install)").removeClass(
                    "hide"
                  );

                  $("[data-fees-row]").removeClass("hide");
                } else {
                  $(".disclaimer.nofees").removeClass("hide");
                  $(".disclaimer.fees:not(.wifi):not(.install)").addClass(
                    "hide"
                  );

                  $("[data-fees-row]").addClass("hide");
                }

                if (
                  $(
                    ".product-wrap.product-select input[type=radio][data-waive-installation-fee]:checked"
                  ).length
                ) {
                  $(".disclaimer.fees.install").addClass("hide");
                  // $('[data-fees-row]').addClass('hide');
                } else {
                  $(".disclaimer.fees.install").removeClass("hide");
                  // $('[data-fees-row]').removeClass('hide');
                }

                updatePrice();
              }
              $("[data-ecomm-working]").addClass("hide");

              orderAdvance();
            },
            function (request, status, error) {
              $("[data-ecomm-working]").addClass("hide");
              orderAdvance();
            },
          );
        }
        break;
      case "4":
        pushGA4EcommData("ecommerce_your_details_selection");
        // $("#order-customer-info").foundation("validateForm");
        // Validate customer information
        customerFormValidate();
        break;
      case "5":

        // terms and conditions validation check
        let tcSelector = '#termsconditions';
        let scrollSelector = "#pricing-sticky";
        let heightAdjuster = 0;
        let distanceForScroll = 0;

        function getTermsHeightAdjuster(){
          envConsoleLog('getting height adjuster');
          if($('#termsconditions').is(':visible')){
            tcSelector = "#termsconditions";
            heightAdjuster = $(scrollSelector).outerHeight();
          }else {
            tcSelector = "#termsconditions-mobile";
            scrollSelector = "#termsconditions-mobile";
            heightAdjuster = $('#pricing-sticky').outerHeight() + $("#price-drawer-content-label-mobile > button").outerHeight() + $(tcSelector).closest('.termsconditions-wrap').outerHeight();
          }
        }
        getTermsHeightAdjuster(); //set selector

        var termsChecked = $(tcSelector).prop("checked");
        if (!termsChecked) {
            envConsoleLog('terms not checked');
            // Show popover
            if($(tcSelector).data('bs.popover') == undefined && tcSelector == "#termsconditions") {
              $(tcSelector).popover({
                  content: "Please read and agree to the terms and conditions.",
                  placement: "top",
                  trigger: "manual",
                  customClass: "d-md-block d-none",
              }).popover('show');
              // Hide popover after a delay
              setTimeout(function() {
                  $(tcSelector).popover('hide');
              }, 10000);

              // if the user clicks toggles termsconditions to checked hide the popover
              $(tcSelector).change(function() {
                  if($(this).prop('checked')) {
                    $(tcSelector).popover('hide');
                  }
              });

              $(".special-notification-terms button").click(function() {
                $(tcSelector).popover('hide');
              });
            }else if(tcSelector == "#termsconditions-mobile") {
              envConsoleLog('terms not checked mobile');

              // add invalid class for styles
              try{
                let wrapper = $(tcSelector).closest('p').addClass('is-invalid');
                $(tcSelector).change(function() {
                  if($(this).prop('checked')) {
                    wrapper.removeClass('is-invalid');
                  }else{
                    wrapper.addClass('is-invalid');
                  }
                });
              }catch(e){
                envConsoleLog('error adding invalid class to mobile terms');
              }

              // if mobile drawer is closed, open it
              try{
                envConsoleLog('button collapsed ',$("#price-drawer-content-label-mobile .accordion-button").hasClass('collapsed'));
                if($("#price-drawer-content-label-mobile .accordion-button").hasClass('collapsed')) {
                  envConsoleLog('mobile drawer closed');
                  $("#price-drawer-content-label-mobile .accordion-button").click();
                }
              }catch(e){
                envConsoleLog('error opening mobile drawer');
              }
            }

              // scroll to the element
              getTermsHeightAdjuster(); //adjust for changed heights
              distanceForScroll = $(scrollSelector).offset().top - $(window).height() + heightAdjuster;
              $('html, body').animate({
                scrollTop: distanceForScroll
              }, 250);
            return;
        }

        pushGA4EcommData("ecommerce_submit_your_order_selection");
        //   $('#order-account-info').foundation("validateForm");
        //   break;
        // case "4":

        // sessionStorage.setItem('lumos_orderstreet', localStorage.getItem('lumos_address_street'));
        // sessionStorage.setItem('lumos_ordercity', localStorage.getItem('lumos_address_city'));
        // sessionStorage.setItem('lumos_orderstate', localStorage.getItem('lumos_address_state'));
        // sessionStorage.setItem('lumos_orderzip', localStorage.getItem('lumos_address_zip'));

        $('html, body').addClass('processing-order');

        if (!uses_nsapi) {
          if (uses_sfapi) {
            submitOrderCaptureSF();
          } else {
            submitOrderCapture();
          }
        } else {
          createAccount();
        }
        break;
      default:
        orderAdvance();
    }
  });

  // Service billing
  $('input[name="address_service_billing"]').change(function () {
    if ($("#address_service_billing_diff").prop("checked")) {
      $("#address_service_billing_different").removeClass("hide");

      $("#address_service_billing_different_zip").prop("required", true);
      $("#address_service_billing_different_city").prop("required", true);

      $("#address_service_billing_different_street_name").prop(
        "required",
        true
      );
      $("#address_service_billing_different_street_number").prop(
        "required",
        true
      );
    } else {
      $("#address_service_billing_different").addClass("hide");

      $("#address_service_billing_different_zip").prop("required", false);
      $("#address_service_billing_different_city").prop("required", false);

      $("#address_service_billing_different_street_name").prop(
        "required",
        false
      );
      $("#address_service_billing_different_street_number").prop(
        "required",
        false
      );

      $("#address_service_billing_different_pobox").prop("required", false);

      // $('#service_billing_final').text(localStorage.getItem('lumos_address_full_address'));
      $("#service_billing_final").text(
        localStorage.getItem("lumos_address_street") +
          " " +
          localStorage.getItem("lumos_address_state") +
          ", " +
          localStorage.getItem("lumos_address_city") +
          " " +
          localStorage.getItem("lumos_address_zip")
      );

      $("#service_billing_final_visible").text(
        localStorage.getItem("lumos_address_street") +
          " " +
          localStorage.getItem("lumos_address_state") +
          ", " +
          localStorage.getItem("lumos_address_city") +
          " " +
          localStorage.getItem("lumos_address_zip")
      );
    }
  }); // end $('input[name="address_service_billing"]').change

  $('input[name="address_service_type"]').change(function () {
    if ($("#address_service_billing_physical").prop("checked")) {
      $("#address_service_billing_physical_form").removeClass("hide");
      $("#address_service_billing_pobox_form").addClass("hide");

      $("#address_service_billing_different_street_name").prop(
        "required",
        true
      );
      $("#address_service_billing_different_street_number").prop(
        "required",
        true
      );

      $("#address_service_billing_different_pobox").prop("required", false);
    } else {
      $("#address_service_billing_physical_form").addClass("hide");
      $("#address_service_billing_pobox_form").removeClass("hide");

      $("#address_service_billing_different_street_name").prop(
        "required",
        false
      );
      $("#address_service_billing_different_street_number").prop(
        "required",
        false
      );

      $("#address_service_billing_different_pobox").prop("required", true);
    }
  }); // end $('input[name="address_service_type"]').change

  // Go to a specific step
  $("[data-order-step-indicator] li a").click(function (e) {
    // console.log($(this));
    // e.preventDefault();

    var isStepAllowed = $(this).parent("li").hasClass("complete") ||
                        $(this).parent("li").hasClass("current");
    //if user has clicked on something not complete or the current tab we want absolutely nothing to happen
    if (!isStepAllowed) {
        e.preventDefault();
        return;
    }
    var gotoStep = $(this).attr("data-goto-step");
    // logNSEvent("ecomm - button click - Go Back To Step: " + $(this).text());
    if (parseInt(gotoStep) == 1) {
      reloadEcommProducts();
    }
    orderToStep(parseInt(gotoStep));

  }); // end $('.order-step-indicator li a').click

  $("#ecommerce-flow-nav button").click(function (e) {
    // console.log($(this));
    e.preventDefault();
    var gotoStep = $(this).attr("data-goto-step");
    // logNSEvent("ecomm - button click - Go Back To Step: " + $(this).text());
    window.location.hash = "step-" + gotoStep;
    orderToStep(parseInt(gotoStep));
  });

  $("#review-package button, #review-schedule button").click(function () {
    // logNSEvent('ecomm - button click - Edit Package (Step 4)');
    orderToStep(1);
  });

  $("#review-phone button").click(function () {
    orderToStep(3);
  });

  $("#review-contact button, #review-billing button").click(function () {
    // logNSEvent('ecomm - button click - Edit Contact/Billing Info (Step 4)');
    orderToStep(4);
  });

  $(
    "#review-account button, #review-account-information button, #review-schedule button"
  ).click(function () {
    // logNSEvent('ecomm - button click - Edit Account Info (Step 4)');
    orderToStep(4);
  });
}

function loadProductEvents() {
  if ($("#transfer-help").length) {
    // var phonehelp = new Foundation.Dropdown($("#transfer-help"), {});
  }

  // Call to order button
  // Phone Number Reveal Button
  $("a[data-reveal-number]").click(function () {
    var origButtonText = $(this).text();
    var origButtonNumber = $(this)
      .attr("href")
      .replace("tel:", "")
      .replace(/(\d{3})(\d{3})(\d{4})/, "$1.$2.$3");
    if (
      typeof $(this).attr("data-orig-num") == "undefined" ||
      $(this).attr("data-orig-num") == false
    ) {
      $(this).attr("data-orig-num", origButtonText);
    }
    $(this).text("Call: " + origButtonNumber);
  });

  // Hide multigig things
  $("[data-show-for-cookie]").each(function () {
    var dataCookie = $(this).attr("data-show-for-cookie");

    if (
      localStorage.getItem(dataCookie) &&
      localStorage.getItem(dataCookie) !== "null" &&
      localStorage.getItem(dataCookie) !== "0"
    ) {
      $(this).removeClass("hide");
      // Alert
      $('[data-cookie-alert="' + dataCookie + '"]').addClass("hide");
    } else {
      $(this).addClass("hide");
      if ($(this).find("input").prop("checked")) {
        if ($(this).prev().find("input").length) {
          $(this).prev().find("input").prop("checked", true).change();
        }
        // Alert
        $('[data-cookie-alert="' + dataCookie + '"]').removeClass("hide");
      }
    }
  });

  // Checkout Actions
  $(
    ".product-wrap.product-select input, .product-wrap.product-select select"
  ).change(function () {
    // console.log("change product");

    // Hide Alert
    $("[data-product-alert]").addClass("hide");

    // Adjust WiFi for MultiGig
    if ($('[data-product-feature-id="4197"]').prop("checked")) {
      $("#feature__6").find('option[value="0"]').addClass("hide");

      if ($("#feature__6").val() == "0") {
        $("#feature__6").val("1");
        // console.log('reset to 1');
      }
      // Shows wifi-multigig notice
      if (!localStorage.getItem("lumos_address_multigig")) {
        $("[data-multigig-notice]").removeClass("hide");
      }

      $('label[for="feature__2"]').addClass("hide"); // Hide the No-Wifi option

      if ($("#feature__2").prop("checked")) {
        // $('#feature_3925_1').click(); // Select Total WiFi
        $("#feature__2").prop("checked", false);
      }
      $(".product-desc-promo .total-home-message").removeClass("hide");
    } else {
      $('label[for="feature__2"]').removeClass("hide"); // Show the No-Wifi option
      $(".product-desc-promo .total-home-message").addClass("hide");

      $("#feature__6").find('option[value="0"]').removeClass("hide");
      // Hide wifi-multigig notice
      $("[data-multigig-notice]").addClass("hide");
    }

    // Wifi messaging

    // Update Sub Type Categories
    updateSubTypes();
    // console.log('subtypes');
    // Update selection cookie
    // Update Price bubble
    updatePrice();
    // console.log('updateprice');
    updateProductOrderCookie();

    // console.log('productordercookie');
    // Update Input styles
    updateInputStyle();
    // console.log('updateinputstyle');
    // setTimeout(function () {
    //   console.log("update sticky");
    //   $("#pricing-sticky .price-bar-sticky").css({ top: "auto", bottom: 0 });
    // }, 50);
  }); // end $('.product-wrap.product-select input, .product-wrap.product-select select').change

  $("#voice_comments input[type=radio]").change(function () {
    // console.log("changed");
    if ($("#transfer_number_no").prop("checked")) {
      $("#transfer_number_container").addClass("hide");
      // $('#transfer_number_phone').addClass('hide');
      // $('#transfer_number_carrier').addClass('hide');
      // $('#transfer_number_account').addClass('hide');
      $("#review-phone").addClass("hide");
    }
    if ($("#transfer_number_yes").prop("checked")) {
      $("#transfer_number_container").removeClass("hide");
      // $('#transfer_number_phone').removeClass('hide');
      // $('#transfer_number_carrier').removeClass('hide');
      // $('#transfer_number_account').removeClass('hide');
      $("#review-phone").removeClass("hide");
    }
  });
}

function sendNSPopupConversion() {
  if (hasClickedContinueShopping) {
    window.dataLayer.push({
      event: "exitPopUpConversion",
    });
    // console.log("GTM: exitPopUpConversion");
  }
}

function startNSTimer() {
  nsTimer = new Date().getTime();
  envConsoleLog("GTM Timer Start: " + nsTimer);
}

function stopNSTimer() {
  nsTimer = new Date().getTime();
  envConsoleLog("GTM Timer Stop: " + nsTimer);
}

function sendNSTimer(stepLabel) {
  var endTime = new Date().getTime();
  var elapsedtime = endTime - nsTimer;

  // envConsoleLog("GTM Timer Send - Step: " + stepLabel);
  // envConsoleLog("GTM Timer Send - Start: " + nsTimer);
  // envConsoleLog("GTM Timer Send - End: " + endTime);
  // envConsoleLog("GTM Timer Send - Elapsed Time: " + elapsedtime);

  // Report response
  
  window.dataLayer.push({
    event: "checkoutProcessingStepComplete",
    stepLabel: stepLabel,
    stepElapsedTime: elapsedtime,
  });
  // console.log("GTM: " + stepLabel, elapsedtime);

  // Response greater than 30 seconds
  if(elapsedtime > 30000) {
    
    window.dataLayer.push({
      event: "APIResponseTime>30s",
      stepLabel: stepLabel,
      stepElapsedTime: elapsedtime,
    });
    // envConsoleLog("nsTimer: ", nsTimer);
    // envConsoleLog("end time: ", endTime);
    envConsoleLog("GTM Timer Send - Over 30: " + stepLabel, elapsedtime);
    // console.log("GTM Response Time: " + stepLabel, elapsedtime);
  }

  nsTimer = new Date().getTime();
}

function sendNSError(errorLabel) {
  var endTime = new Date().getTime();
  var elapsedtime = endTime - nsTimer;

  envConsoleLog("GTM Error Send - Step: " + errorLabel);
  // envConsoleLog("GTM Error Send - Start: " + nsTimer);
  // envConsoleLog("GTM Error Send - End: " + endTime);
  // envConsoleLog("GTM Error Send - Elapsed Time: " + elapsedtime);

  // Report response
  
  window.dataLayer.push({
    event: "checkoutProcessingStepError",
    stepLabel: errorLabel,
    stepElapsedTime: elapsedtime,
  });
  // console.log("GTM: " + errorLabel, elapsedtime);

  // Response greater than 30 seconds
  if(elapsedtime > 30000) {
    
    window.dataLayer.push({
      event: "APIResponseTime>30s",
      stepLabel: errorLabel,
      stepElapsedTime: elapsedtime,
    });
    envConsoleLog("GTM Error Send - Over 30: " + errorLabel, elapsedtime);
    // console.log("GTM Response Time: " + errorLabel, elapsedtime);
  }

  nsTimer = new Date().getTime();
}

function reloadEcommProducts() {
  var $ = jQuery;

  envConsoleLog("reloadEcommProducts");

  // if(checkStack() == "legacy"){
  //   toggleStep2('remove');
  // }else{
  //   toggleStep2('add');
  // }

  $("[data-ecomm-products]").empty();
  $(".order-step-column").addClass("shadow");
  $("[data-ecomm-loading]").removeClass("hide");

  $("[data-ecomm-set-address]").addClass("hide");
  $("[data-ecomm-container ]").removeClass("hide");

  // console.log(localStorage.getItem("lumos_address_market"));

  $(".plan-finder-tool").appendTo("body");

  if (localStorage.getItem("lumos_address_tech_stack") !== null) {
    var data = {
        tech_stack: localStorage.getItem("lumos_address_tech_stack"),
    };
    
    window.dataLayer.push(data);
  }

  if (localStorage.getItem("lumos_address_market")) {
    ajaxCall(
      {
        customer_segment: localStorage.getItem("lumos_address_market"),
        block_id: $(".wf-shopfiber-v3").attr("id"),
        stepLabel: "Step-Error-get_template",
      },
      function (response) {
        $("[data-ecomm-products]").append(response);
        $(".order-step-column").removeClass("shadow");
        $("[data-ecomm-loading]").addClass("hide");
        $("[data-ecomm-set-address]").addClass("hide");

        loadEcomm();
        loadProductEvents();

        // Input mask for transfer phone
        $("#transfer_number_phone").inputmask({
          mask: phonesMasks,
          greedy: false,
          definitions: { "#": { validator: "[0-9]", cardinality: 1 } },
        });

        $("#transfer_number_phone").on("keyup", function () {
          $("#service_transfer_number_phone_final").text($(this).val());
        });

        $("#transfer_number_carrier").on("keyup", function () {
          $("#service_transfer_number_carrier_final").text($(this).val());
        });

        $("#transfer_number_account").on("keyup", function () {
          $("#service_transfer_number_account_final").text($(this).val());
        });

        $("#service-transfer-number-message-container").addClass("hide");
        $("#transfer_number_message").bind("keyup blur", function () {
          $("#service_transfer_number_message_final").text($(this).val());
          if ($(this).val()) {
            $("#service-transfer-number-message-container").removeClass("hide");
          } else {
            $("#service-transfer-number-message-container").addClass("hide");
          }
        });

        $(".sticky.order-step-column")
          .removeClass("is-at-bottom")
          .addClass("is-at-top");

        if ($(".product-slider").length) {
          // console.log("set slider");
          // Move the hidden modifier elements to a separate container so we don't goof out the slider selector
          $('<span class="product-modifiers"></span>').insertAfter(
            ".product-slider"
          );
          $(
            ".product-slider .fieldset-container label.perma-hide, .product-slider .fieldset-container label.hide"
          ).each(function () {
            $(this).appendTo(".product-modifiers");
          });

          // Set up the slider selector
          var productSlickOptions = {
            infinite: false,
            slidesToShow: 3,
            slidesToScroll: 1,
            arrows: true,
            dots: false,
            // initialSlide: 1,
            responsive: [
              {
                breakpoint: 1250,
                settings: {
                  slidesToShow: 2,
                  arrows: true,
                  slidesToScroll: 1,
                  dots: true,
                  centerMode: false,
                  variableWidth: false,
                  initialSlide: 1,
                },
              },
              {
                breakpoint: 992,
                settings: {
                  slidesToShow: 1,
                  arrows: false,
                  slidesToScroll: 1,
                  dots: true,
                  centerMode: true,
                  centerPadding: "5px",
                  variableWidth: true,
                  initialSlide: 1,
                },
              },
              {
                breakpoint: 540,
                settings: {
                  slidesToShow: 1,
                  arrows: false,
                  slidesToScroll: 1,
                  dots: true,
                  centerMode: true,
                  centerPadding: "50px",
                  variableWidth: false,
                  initialSlide: 1,
                },
              },
            ],
          };

          if (
            (localStorage.getItem("lumos_address_multigig") &&
            localStorage.getItem("lumos_address_multigig") == 1) || localStorage.getItem("lumos_address_market") == 'va'
          ) {
            productSlickOptions.initialSlide = 0;
            productSlickOptions.slidesToScroll = 1;

            productSlickOptions.responsive[0].settings.initialSlide = 0;
            productSlickOptions.responsive[0].settings.slidesToScroll = 1;

            productSlickOptions.responsive[1].settings.initialSlide = 1;
            productSlickOptions.responsive[1].settings.slidesToScroll = 1;

            productSlickOptions.responsive[2].settings.initialSlide = 1;
            productSlickOptions.responsive[2].settings.slidesToScroll = 1;
          }
          if(localStorage.getItem("selected_feature_slide")) {
            productSlickOptions.initialSlide = localStorage.getItem("selected_feature_slide");
            productSlickOptions.slidesToScroll = 1;

            productSlickOptions.responsive[0].settings.initialSlide = localStorage.getItem("selected_feature_slide");
            productSlickOptions.responsive[0].settings.slidesToScroll = 1;

            productSlickOptions.responsive[1].settings.initialSlide = localStorage.getItem("selected_feature_slide");
            productSlickOptions.responsive[1].settings.slidesToScroll = 1;

            productSlickOptions.responsive[2].settings.initialSlide = localStorage.getItem("selected_feature_slide");
            productSlickOptions.responsive[2].settings.slidesToScroll = 1;

            localStorage.removeItem("selected_feature_slide");
          }

          // console.log(productSlickOptions);
          var $productSlider = $(".product-slider .fieldset-container");

          $productSlider.slick(productSlickOptions);
          $productSlider.slick("slickFilter", ":not(.hide):not(.perma-hide)");

          var $tabHeading = $(".wf-speed-cards.shop-fiber .tab-headings");
          $tabHeading.find(".tab-heading").remove();
          $productSlider.find(".slick-slide").each(function () {
            $tabHeading.append(
              '<li class="tab-heading active" data-slide="' +
                $(this).attr("data-slick-index") +
                '">' +
                $(this).find(".speed").text() +
                "</li>"
            );
          });
          var $tabHeadings = $(
            ".wf-speed-cards.shop-fiber .tab-headings .tab-heading"
          );

          function setCardArrows() {
            // console.log('setCardArrows');
            var $productSlider = $(".product-slider .fieldset-container");

            var currentSlide = $productSlider.slick("slickCurrentSlide");
            var totalSlides = $productSlider.slick("getSlick").slideCount;
            var slidesToShow = $productSlider.slick(
              "slickGetOption",
              "slidesToShow"
            );

            $(".product-slider .arrow-container").find(".prev-slide").remove();
            $(".product-slider .arrow-container").find(".next-slide").remove();

            $(".product-slider .arrow-container").append(
              '<button class="prev-slide" aria-label="Previous" type="button" aria-disabled="false"><svg width="86" height="86" viewBox="0 0 86 86" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="43" cy="43" r="41.5" transform="matrix(-1 0 0 1 86 0)" fill="white" stroke="#B003D3" stroke-width="3"/><path d="M50.5883 43H36.9294" stroke="#290350" stroke-width="2" stroke-linecap="round"/><path d="M43.0255 36.853L36.9294 42.949L43.0255 49.045" stroke="#290350" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg><span class="sr-only">Previous Slide</span></button>'
            );
            $(".product-slider .arrow-container").append(
              '<button class="next-slide" aria-label="Next" type="button" aria-disabled="false"><svg width="86" height="86" viewBox="0 0 86 86" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="43" cy="43" r="41.5" transform="matrix(-1 0 0 1 86 0)" fill="white" stroke="#B003D3" stroke-width="3"/><path d="M35.4117 43H49.0706" stroke="#290350" stroke-width="2" stroke-linecap="round"/><path d="M42.9745 36.853L49.0705 42.949L42.9745 49.045" stroke="#290350" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg><span class="sr-only">Next Slide</span></button>'
            );

            $(".product-slider .arrow-container")
              .find(".prev-slide")
              .click(function () {
                $productSlider.slick("slickPrev");
              });

            $(".product-slider .arrow-container")
              .find(".next-slide")
              .click(function () {
                $productSlider.slick("slickNext");
              });

            var prevButton = $(".product-slider .arrow-container .prev-slide");
            var nextButton = $(".product-slider .arrow-container .next-slide");

            if (currentSlide === 0) {
              prevButton.attr("aria-disabled", true).addClass("disabled");
            }
            if (currentSlide >= totalSlides - slidesToShow) {
              nextButton.attr("aria-disabled", true).addClass("disabled");
            }

            if (totalSlides <= slidesToShow) {
              prevButton.attr("aria-disabled", true).addClass("disabled");
              nextButton.attr("aria-disabled", true).addClass("disabled");
            }
          }
          setCardArrows();
          $productSlider.on("setPosition", setCardArrows);

          $productSlider.on(
            "beforeChange",
            function (event, slick, currentSlide, nextSlide) {
              var prevButton = $(
                ".product-slider .arrow-container .prev-slide"
              );
              var nextButton = $(
                ".product-slider .arrow-container .next-slide"
              );

              if (nextSlide === 0) {
                prevButton.attr("aria-disabled", true).addClass("disabled");
              } else {
                prevButton.attr("aria-disabled", false).removeClass("disabled");
              }

              if (nextSlide === slick.slideCount - 1) {
                nextButton.attr("aria-disabled", true).addClass("disabled");
              } else {
                nextButton.attr("aria-disabled", false).removeClass("disabled");
              }

              //if all slides are visible
              if (currentSlide == nextSlide) {
                nextButton.attr("aria-disabled", true).addClass("disabled");
                prevButton.attr("aria-disabled", true).addClass("disabled");
              }

              $tabHeadings.removeClass("active");
              $($tabHeadings[nextSlide]).addClass("active");
            }
          );


          $tabHeadings.on("click", function () {
            var slideIndex = $(this).data("slide");
            $productSlider.slick("slickGoTo", slideIndex);
            $productSlider.find(".feature-label[data-slick-index='" + slideIndex + "'] input").click();
            $(".pricing-sticky").addClass("closed");
            $tabHeadings.removeClass("active");
            $(this).addClass("active");
          });

          $productSlider.on(
            "afterChange",
            function (event, slick, currentSlide) {
              $tabHeadings.removeClass("active");
              $($tabHeadings[currentSlide]).addClass("active");
            }
          );

          // listener for .shop-now-button
          $(".shop-now-button").click(function () {
            // show our sticky pricing drawer
            $(".pricing-sticky").removeClass("closed");
          });

          setTimeout(function () {
            setDefaultProduct();
          }, 500);

          var promoZoneCookieValue = getCookie("STYXKEY_lumos_promo_option");

          var isAnyCardMatchingPromo = false;

          $(".card input[data-promo-zone]").each(function () {
            if ($(this).attr("data-promo-zone") === promoZoneCookieValue && promoZoneCookieValue != "null") {
              isAnyCardMatchingPromo = true;
              return false;
            }
          });

          if (isAnyCardMatchingPromo) {
            $(".flash-sale-info").addClass("hide");
            // $(".product-slider .card").removeClass("flattop");
            $(".product-slider .card .featured-feature-callout").addClass("hide");
          }

          var hasFlashSale = false;
          var hasFeatured = false;

          // Adjust card exclusive offer heights on load to be the same
          function setEqualShopCardExclusive() {
            $(".card .additional-section.exclusive-offers").css("height", '');
            var tallest = 0;
            var tallestWrapper = 0;
            try{
              $(".card .additional-section.exclusive-offers").each(function () {
                var $this = $(this);
                var thisHeight = $this.outerHeight();
                if (thisHeight > tallest) {
                  tallest = thisHeight;
                }
              });
              $(".card .label-content-wrapper").each(function () {
                var $this = $(this);
                var thisHeight = $this.outerHeight();
                if (thisHeight > tallestWrapper) {
                  tallestWrapper = thisHeight;
                }
              });

              $(".card .additional-section.exclusive-offers").css("height", tallest);
              $(".card .additional-section.exclusive-offers").css("margin-top", "auto");
              $(".card .label-content-wrapper").css("height", tallestWrapper);
            } catch(e) {
              envConsoleLog(e);
            }
          }
          $(window).resize(setEqualShopCardExclusive);
          setEqualShopCardExclusive();

          $(".card").each(function () {
            // console.log('checking cards');
            var $thisCard = $(this);
            var $flashSaleInfo = $thisCard.find('.flash-sale-info');
            var $featuredFeatureCallout = $thisCard.find('.featured-feature-callout:not(.hide)');

            if($flashSaleInfo.length > 0) {
              hasFlashSale = true;
            }

            if ($featuredFeatureCallout.length > 0) {
                // $thisCard.addClass('flattop');
                hasFeatured = true;
            } else {
                // $thisCard.removeClass('flattop');
            }
            // console.log('hasFeatured', hasFeatured);

          });

          // update upi data based on api response
          refreshUPIData();

          function getCookie(name) {
            var value = "; " + document.cookie;
            var parts = value.split("; " + name + "=");
            if (parts.length == 2) return parts.pop().split(";").shift();
          }

          if(hasFeatured){
            // console.log('hasFeatured adding spacing');
            $(".product-slider .card.feature-label").addClass("default_spacing");
          }

          if(hasFlashSale) {
            setEqualShopCardHeight();// some adjustments for flash-sale banner and spacing
          }

          // custom dropdown listener
          $(".broadband-label .custom-dropdown").on("click", function () {
            console.log("clicked");
            $(this).find(".dropdown-section").toggle();
            $(this).find(".dropdown-icon").toggleClass("rotate");
            // Close all other dropdowns
            $(".custom-dropdown").not(this).find(".dropdown-section").hide();
          });

          // prevent link clicks from closing dropdown
          $(".custom-dropdown").on("click", "a, button", function(event) {
            event.stopPropagation();
          });

          // resize footer padding on mobile so it fits the fixed pricing drawer
          function resizeFooterPadding() {
            if ($(window).width() < 768) {
              let pricingStickyHeight = $("#pricing-sticky").outerHeight();
              let priceDrawerContentLabelMobileHeight = $("#price-drawer-content-label-mobile").outerHeight();
              let totalHeight = pricingStickyHeight + priceDrawerContentLabelMobileHeight;
              $("footer").css("padding-bottom", totalHeight + "px");
            } else {
              $(".footer").css("padding-bottom", 0);
            }
          }
          resizeFooterPadding();
          // window resize listener
          $(window).resize(resizeFooterPadding());

        }
      },
      function (response) {
        // console.log(response);
        envConsoleLog(response);
      },
      "/wp-content/themes/lumos-tidewater/parts/ecommtemplates/content-product-order-step-one-two-three-v3.php",
    );
  } else {
    $("[data-ecomm-loading]").addClass("hide");
    $("[data-ecomm-set-address]").removeClass("hide");
    $("[data-ecomm-container ]").addClass("hide");
    // planBlockSliderInit();
    $(".order-step-column").removeClass("shadow");
  }

  // product terms change listener
  $('#productTerms').on('change', function() {
    if (currentProduct) {

      envConsoleLog(currentProduct);

      // update acceptance
      $(currentProduct).attr('data-terms-accepted', $(this).is(':checked'));

      // trigger step progression
      if ($(this).is(':checked')) {
        enableStepProgression();
      } else {
        disableStepProgression();
      }
    }
  });
}

// Set default internet seleciton if one has been chosen by the picker
function setDefaultProduct() {
  // console.log("set default");

  if (localStorage.getItem("lumos_default_product")) {
    // console.log(localStorage.getItem("lumos_default_product"));
    $(
      ".feature-desc[data-legacy-name='" +
        localStorage.getItem("lumos_default_product") +
        "']"
    )
      // .siblings('input')
      // .parent(".pricing-row") this was too specific with new input on internet cards
      .closest(".card")
      .find("input")
      .click();

    var sliderIndex = $(
      ".feature-desc[data-legacy-name='" +
        localStorage.getItem("lumos_default_product") +
        "']"
    )
      .parents("label")
      .index();

    $(".product-slider .fieldset-container").slick(
      "slickGoTo",
      sliderIndex,
      true
    );

    orderToStep(0);
    orderToStep(1); //need to re-init some things in step1 after setting default product for closer promo

    updatePrice();
  }
}

function loadEcomm() {
  var $ = jQuery;

  if ($(".wf-shopfiber-v3").data("server-env") === "live") {
    server_environment = 'live';
  }else {
    server_environment = 'test';
  }

  orderToStep(1);

  // Old cookie name. Kill it if it's there.
  if (localStorage.getItem("lumos_ecomm_session_id")) {
    localStorage.removeItem("lumos_ecomm_session_id");
  }

  // console.log(
  //   "support vid bool" + localStorage.getItem("lumos_address_supportsvideo")
  // );

  if (
    localStorage.getItem("lumos_address_supportsvideo") != undefined &&
    localStorage.getItem("lumos_address_supportsvideo") != null &&
    localStorage.getItem("lumos_address_supportsvideo") == "0"
  ) {
    $('[data-feature-sub-type="3"]').addClass("perma-hide");
  } else {
    $('[data-feature-sub-type="3"]').removeClass("perma-hide");
  }

  // Credit Check CC Date actions
  $("#ns-credit-check-cc-cardexp").val(
    $("#ns-credit-check-cc-cardyear").val() +
      $("#ns-credit-check-cc-cardmonth").val()
  );

  // $('#order-step-column').foundation('_destroy');

  // Product Selection Actions
  if ($("#ns_available_products").length) {
    // On initial load, trigger default price sorting
    $("#lumos_product_sort_price").trigger("change");

    // Set fiber indicator on load
    updateFiberSpeedIndicator();
  } // endif - Product Selection Actions

  // update on page load
  updateSubTypes();

  // Product order feature selection action
  if ($("#order-info").length) {
    // logNSEvent('ecomm - entry - Open Ecommerce Page');

    // console.log('remove sticky');

    $(".top-nav").addClass("non-sticky");
    $(".top-nav-spacer").addClass("non-sticky");

    // Hide promo banner
    $("#address-checker .promo-space").addClass("hide");

    // Load Product selection
    // loadProductSelection();

    if (!localStorage.getItem("lumos_address_full_address")) {
      $("#account_service_check_address").text("Set Address");
    }



    updatePrice();
    // Set cookie for product Selection
    updateProductOrderCookie();

    // console.log('first call');

    // Set service address if set
    if (
      $("#account_service_geocoded").length &&
      localStorage.getItem("lumos_address_full_address") &&
      localStorage.getItem("lumos_address_check_decline") !== "1"
    ) {
      $("#account_service_geocoded").val(
        localStorage.getItem("lumos_address_full_address")
      );
      $("#account_service_geocoded_visible").val(
        localStorage.getItem("lumos_address_street") +
          " " +
          localStorage.getItem("lumos_address_state") +
          ", " +
          localStorage.getItem("lumos_address_city") +
          " " +
          localStorage.getItem("lumos_address_zip")
      );
    }

    // Set max order sequence
    orderStepMax = $(".order-step-column .order-step").length;

    updateInputStyle();
  } // endif - product feature selection action
}

// Update the fiber speed sort indicator
function updateFiberSpeedIndicator() {
  var $ = jQuery;

  var speedVal = $("#fiber_speed").val(),
    gigaBit = " Gbps",
    megaBit = " Mbps",
    displayVal = "";

  if (speedVal > 999) {
    displayVal = speedVal / 1000;
    displayVal += gigaBit;
  } else {
    displayVal = speedVal + megaBit;
  }

  $(".price_option[data-fiber-speed]").hide();
  $(".price_option[data-fiber-speed=" + speedVal + "]").show();

  // $product_grid.isotope("layout");

  $("#fiber_speed_indicator").text(displayVal);
}

// Update the fiber speed sort
function updateFiberSpeedSort() {
  // TODO: Adjust price depending on speed selected
  updateFiberSpeedIndicator();
}

// Set enable/disable sub types
function updateSubTypes() {
  // Sub Types:
  //  Internet Main (1) - Internet Feature (2)
  //  Video Main (3) - Video Feature (5)
  //  Voice Main (8) - Voice Feature (9)
  var $ = jQuery;

  $(".product-wrap.product-select label").each(function () {
    var $featureCheckbox = $(this).find("input"),
      sub_type_id = "";

    switch ($(this).attr("data-feature-sub-type")) {
      case "8": // Voice Main
        sub_type_id = "9";
        break;
    }

    if (sub_type_id.length) {
      var $sub_elem = $(
        'label[data-feature-sub-type="' + sub_type_id + '"] input'
      );

      if ($(this).find("input").prop("checked")) {
        $sub_elem.prop("disabled", false);
        $("#voice_comments").removeClass("hide");
      } else {
        $sub_elem.prop("disabled", true);
        $sub_elem.prop("checked", false);
        // $sub_elem.parent('label').removeClass('highlight');
        $("#voice_comments").addClass("hide");
      }
    }
  });
} // end updateSubTypes()

function clearFinalScreenProducts() {
  var $ = jQuery;

  $("#product_selected_features li").each(function () {
    $(this).remove();
  });
}

function updateFinalScreenProducts(qty, feature_label) {
  var $ = jQuery;

  // console.log("final screen", qty, feature_label);

  if (qty > 0) {
    var qtyMarker = "";
    if (qty > 1) {
      qtyMarker = "<span>(" + qty + ") </span>";
    }
    var $featureItem = $("<li>" + qtyMarker + feature_label + "</li>");
    $featureItem.find(".button.call").remove();
    $featureItem.find("a").contents().unwrap();
    $("#product_selected_features").append($featureItem);
  }
}

$("input[data-paperless-bill-seletion]").change(function () {
  // console.log($(this).prop("checked"));
  var paperlessBillOptin = $(this).prop("checked");
  var $this = $(this);

  $("input[data-paperless-bill-seletion]").each(function () {
    if (!$(this).is($this)) {
      $(this).prop("checked", paperlessBillOptin);
    }
  });

  updatePrice();
});

function updatePrice() {
  // update price is ran on product select & step select

  var $ = jQuery;

  var totalPrice = 0,
    start_price = parseFloat($("[data-price-figure]").attr("data-start-price")),
    additional_amount = 0;

  clearFinalScreenProducts();

  // console.log("Order Step " + orderStep);

  // Factor Paperless Bill
  if (
    !$("[data-paperless-bill-seletion]").prop("checked") &&
    orderStep >= 2 &&
    (localStorage.getItem("lumos_address_market") == "nc" || localStorage.getItem("lumos_address_market") == "va")
  ) {
    $("[data-paper-price]").removeClass("strikethrough");
    start_price += Number($("#ns-paper-fees").val());
  } else {
    $("[data-paper-price]").addClass("strikethrough");
  }

  $(
    ".product-wrap.product-select h3, .product-wrap.product-select p, .product-wrap.product-select input[type=checkbox], .product-wrap.product-select input[type=radio], .product-wrap.product-select select"
  ).each(function () {
    // console.log($(this).attr('data-dependent-on'));

    // Show/Hide voice popout
    if (
      typeof $(this).attr("data-group-type") !== "undefined" &&
      $(this).attr("data-group-type") == "voice" &&
      $(this).attr("data-feature-group-sub_type") == "8"
    ) {
      // console.log("voice selected");
      if ($(this).prop("checked")) {
        $("#accordionVoicePopout").removeClass("hide");
      } else {
        $("#accordionVoicePopout").addClass("hide");
      }
    }

    // data is default check outside hide/show rules.
    if (
      $(this).attr("data-is-default") === "1" &&
      !$(this).prop("checked") &&
      $(this).attr("data-default-set") !== "1"
    ) {
      $(this).prop("checked", true);
      $(this).attr("data-default-set", "1");
    }

    // flag for dependency check so hide-for does not override dependent-on hiding
    var isDependencyMet = false;

    // Show/Hide based on dependents
    if (
      typeof $(this).attr("data-dependent-on") !== "undefined" &&
      $(this).attr("data-dependent-on").length
    ) {
      // get all field dependents
      var fieldDependents = $(this).attr("data-dependent-on").split(" ");
      // console.log('fieldDependents', fieldDependents);

      // Modified section to use data-faux-id for specific patterns
      var selectors = fieldDependents.map(function(dependent) {
        // Check if the dependent starts with 000 and ends with 02
        // if (/^000.*02$/.test(dependent)) {
        //   return "input[data-faux-id='" + dependent + "']:checked";
        // } else {
        //   return "input[data-product-feature-id='" + dependent + "'][data-faux-id='']:checked, input[data-product-feature-id='" + dependent + "']:not([data-faux-id]):checked";
        // }

        // now instead of using product feature id we are checking the always unique and static data-product-id
        return "input[data-product-id='" + dependent + "']:checked";
      });

      // if this field should be displayed dependent on another field
      if (fieldDependents.length > 0) {
        var selectorString = selectors.join(',');

        // Check for dependents with the updated selector string
        if ($(selectorString).length) {
          isDependencyMet = true;
            if ($(this).is("h3") || $(this).is("p")) {
              $(this).removeClass("hide");
            }
            if (
              $(this).attr("data-is-default") === "1" &&
              !$(this).prop("checked") &&
              $(this).parents("label").hasClass("hide")
            ) {
              $(this).prop("checked", true);
            }
            $(this).parents("label").removeClass("hide");

        } else {
          if ($(this).is("h3") || $(this).is("p")) {
            $(this).addClass("hide");
          }
          if ($(this).is("select")) {
            $(this).val($(this).find("option:first").val());
          } else {
            $(this).prop("checked", false);
          }
          $(this).parents("label").addClass("hide");
        }
      }

    }else{
      // If no dependency, then it's met
      isDependencyMet = true;
    }

    // Show/Hide based on hide-for rules
    if (
      isDependencyMet &&
      typeof $(this).attr("data-hide-for") !== "undefined" &&
      $(this).attr("data-hide-for").length
    ) {
      var fieldHideFor = $(this).attr("data-hide-for").split(" ");

      if (
        // $(
        //   "input[data-product-feature-id='" +
        //     fieldHideFor.join("']:checked,input[data-product-feature-id='") +
        //     "']:checked"
        // ).length
        $(
          "input[data-product-id='" +
            fieldHideFor.join("']:checked,input[data-product-id='") +
            "']:checked"
        ).length
      ) {
        if ($(this).is("h3") || $(this).is("p")) {
          $(this).addClass("hide");
        }
        // $(this).prop('checked', false);
        if ($(this).is("select")) {
          $(this).val($(this).find("option:first").val());
        } else {
          $(this).prop("checked", false);
        }
        $(this).parents("label").addClass("hide");
      } else {
        if ($(this).is("h3") || $(this).is("p")) {
          $(this).removeClass("hide");
        }
        if (
          $(this).attr("data-is-default") === "1" &&
          !$(this).prop("checked") &&
          $(this).parents("label").hasClass("hide")
        ) {
          $(this).prop("checked", true);
        }
        $(this).parents("label").removeClass("hide");
      }
    }
  });

  // update dependent on for popouts
  $('.product-group-popout').each(function() {
    var $this = $(this);
    var dependentOn = $this.attr('data-dependent-on');
    // envConsoleLog('popout dependentOn', dependentOn);
    if (dependentOn) {
      var dependentOnSelector = dependentOn.split(' ').map(function(dependent) {
        return "input[data-product-id='" + dependent + "']:checked";
      }).join(',');
      // envConsoleLog('dependentOnSelector', dependentOnSelector);
      if ($(dependentOnSelector).length > 0) {
        $this.removeClass('hide');
      } else {
        $this.addClass('hide');
      }
    }
  });

  // Input & select field
  var priceBubbleTermChanged = false;

  var internetTotal = 0;
  var internetOrig = 0;
  var internetwifiQty = 0;
  var internetwifiTotal = 0;

  var wifiTotal = 0;
  var tvTotal = 0;
  var voiceTotal = 0;

  var oneTimeTotal = 0;

  // $("[data-price-details] [data-wifi-row]").addClass("hide");
  $("[data-price-details] [data-tv-row]").addClass("hide");
  $("[data-price-details] [data-voice-row]").addClass("hide");

  var waiveInstallationFee = false;
  // Review fields
  $(
    ".product-wrap.product-select input[type=checkbox]:checked, .product-wrap.product-select input[type=radio]:checked, .product-wrap.product-select select, #ns-regulatory-fees"
  ).each(function () {

    var productSelection = JSON.parse(
      localStorage.getItem(cookieLabel_product_selection)
    );

    if (typeof $(this).attr("data-waive-installation-fee") !== "undefined") {

      waiveInstallationFee = true;
    }

    if (typeof $(this).attr("data-doesnt-change-total") === "undefined") {
      if ($(this).is("input")) {
        // input
        if ($(this).attr("data-update-base-price") === "true") {
          start_price = parseFloat($(this).attr("data-price"));

        } else {
          var addonPrice = parseFloat($(this).attr("data-price"));
          if (!isNaN(addonPrice)) {
            additional_amount += addonPrice;

          }
        }

        if ($(this).attr("data-promo-duration-alt")) {

          var promoDurationAlt = "";
          if ($(this).attr("data-promo-duration-alt")) {
            promoDurationAlt = decodeURIComponent(
              $(this).attr("data-promo-duration-alt").replace(/\+/g, " ")
            );
          }
          $(".price-bubble .pricing-term").text(promoDurationAlt);
          $(".mobile-bottom-price .price-container .pricing-term").text(
            promoDurationAlt
          );
          $(".mobile-bottom-price-new .price-container .pricing-term").text(
            promoDurationAlt
          );
          priceBubbleTermChanged = true;
        } else if (!priceBubbleTermChanged) {
          $(".price-bubble .pricing-term").text("per month");
          $(".mobile-bottom-price .price-container .pricing-term").text(
            "per month"
          );
          $(".mobile-bottom-price-new .price-container .pricing-term").text(
            "per month"
          );
        }

        if (
          $(this).attr("name") !== "transfer_number" &&
          !$(this).parents("label").hasClass("perma-hide")
        ) {

          var addToFinalScreen = true;
          // if (
          //   $(this).attr("data-group-type") === "wifi" &&
          //   $(this).attr("data-price") === "0.00"
          // ) {
          //   addToFinalScreen = false;
          // }

          if (
            $(this).attr("data-group-type") === "tv" &&
            $(this).attr("data-price") === "0.00"
          ) {
            addToFinalScreen = false;
          }

          if($(this).attr("data-feature-group-type") == 4){
            addToFinalScreen = true;
          }

          if( $(this).attr("data-add-to-screen-details") === "false" ){
            addToFinalScreen = false;
          }

          console.log('add to final screen:', addToFinalScreen);

          if (addToFinalScreen) {
            var productListItem = $(this).parents("label").find(".feature-desc").html();

            if ($(this).parents("label").find(".feature-desc").length) {
              var productSelectionName = $(this)
                .parents("label")
                .find(".feature-desc")
                .html()
                .replace(/<\/span>|<\/strong>|<\/div>/gi, " ")
                .replace(/<span[^>]*>|<strong[^>]*>|<div[^>]*>/gi, ""); //explicitly remove span and strong tags to preserve <sup> tags

              var productItemContents =
                '<div class="product-title">' + productSelectionName + "</div>";

              if ($(this).parents("label").find(".product-desc-promo").length) {
                productItemContents +=
                  '<div class="product-desc">' +
                  $(this)
                    .parents("label")
                    .find(".product-desc-promo")
                    .html()
                    .replace(/(<br\s*\/?\s*>\s*)+$/, "")
                    .replace("<hr>", "")
                    .replace(/Included Free\*/g, "") +
                  "</div>";
              }

              productListItem =
                '<div class="selected_feature_desc ' +
                $(this).attr("data-group-type") +
                '">' +
                productItemContents +
                "</div>";
            }

            if (
              productListItem !== null &&
              typeof productListItem !== "undefined"
            ) {
              updateFinalScreenProducts(1, productListItem.trim());
            }
          }
        }
      } else {
        // select
        var selectPrice = parseFloat($(this).attr("data-price"));
        additional_amount += selectPrice * $(this).val();

        if ($(this).val() > 0) {
          $(this).parents("label").addClass("highlight");
        } else {
          $(this).parents("label").removeClass("highlight");
        }

        if ($(this).parents('label').find(".feature-desc").length) {
          // console.log($(this).next('.feature-desc'), $(this).next('.feature-desc').html());

          updateFinalScreenProducts(
            $(this).val(),
            $(this)
              .parents('label')
              .find(".feature-desc")
              .html()
              .replace(/<\/span>/gi, "</span> ")
              .replace(/<[^>]*>?/gm, "")
              .trim()
          );
        }
      }
    } else {
      // Add items that don't change the total to the review screen
      if ($(this).is("input")) {
        if (
          $(this).attr("name") !== "transfer_number" &&
          $(this).attr("data-add-to-screen-details")
        ) {

          var addToFinalScreen = true;

          if (
            $(this).attr("data-group-type") === "wifi" &&
            $(this).attr("data-price") === "0.00"
          ) {
            addToFinalScreen = false;
          }
          if (
            $(this).attr("data-group-type") === "tv" &&
            $(this).attr("data-price") === "0.00"
          ) {
            addToFinalScreen = false;
          }
          if (addToFinalScreen) {
            var productListItem = $(this).parents('label').find(".feature-desc").html();

            if ($(this).parents('label').find(".feature-desc").length) {
              var productSelectionName = $(this)
                .parents('label')
                .find(".feature-desc")
                .html()
                .replace(/<\/span>|<\/strong>/gi, " ")
                .replace(/<span[^>]*>|<strong[^>]*>/gi, ""); //explicitly remove span and strong tags to preserve <sup> tags

              var productItemContents =
                '<div class="product-title">' + productSelectionName + "</div>";

              if ($(this).parents("label").find(".product-desc-promo").length) {
                productItemContents +=
                  '<div class="product-desc">' +
                  $(this)
                    .parents("label")
                    .find(".product-desc-promo")
                    .html()
                    .replace(/(<br\s*\/?\s*>\s*)+$/, "")
                    .replace("<hr>", "")
                    .replace(/Included Free\*/g, "") +
                  "</div>";
              }

              productListItem =
                '<div class="selected_feature_desc ' +
                $(this).attr("data-group-type") +
                '">' +
                productItemContents +
                "</div>";
            }

            // console.log("productListItem");
            // console.log(productListItem);

            if (
              productListItem !== null &&
              typeof productListItem !== "undefined"
            ) {
              updateFinalScreenProducts(1, productListItem.trim());
            }
          }
        }
      } else {
        if ($(this).parents('label').find(".feature-desc").length) {
          updateFinalScreenProducts(
            $(this).val(),
            $(this)
              .parents('label')
              .find(".feature-desc")
              .html()
              .replace(/<\/span>/gi, "</span> ")
              .replace(/<[^>]*>?/gm, "")
              .trim()
          );
        }
      }
    }

    if (
      $(this).is('input:not([name="transfer_number"])') ||
      ($(this).is('select:not([name="transfer_number"])') &&
        $(this).val() !== "0")
    ) {

      // envConsoleLog("Building Mobile Details for " + $(this).attr("data-product-feature-id"));

      // build mobile details - internet
      if (
        $(this).parents(".order-step").attr("data-group-type") === "internet"
      ) {
        if ($(this).parents("label").attr("data-feature-sub-type") == 1) {
          var desc = $(this)
            .parents("label")
            .find(".feature-desc")
            .find(".speed")
            .text();
          // desc = desc
          //   .replace("<br>", " - ")
          //   .replace(/<\/?[^>]+(>|$)/g, "")
          //   .replace("Symmetrical", "");
          // desc = desc.split(" - ")[0];
          // desc = desc.replace(/\s*\(.*?\)\s*/g, "");

          // console.log(desc);

          var currPrice = $(this).attr("data-price");
          var originalPrice = $(this).attr("data-original-price");
          var promoDuration = "";
          var promoDurationAlt = "";
          var includedMessaging = $(this).attr("data-included-messaging");
          if (includedMessaging === undefined) {
            includedMessaging = "";
          }
          // envConsoleLog($(this))
          // envConsoleLog("includedMessaging", includedMessaging);

          if ($(this).attr("data-promo-duration")) {
            promoDuration = decodeURIComponent(
              $(this).attr("data-promo-duration").replace(/\+/g, " ")
            );
          }

          if ($(this).attr("data-promo-duration-alt")) {
            promoDurationAlt = decodeURIComponent(
              $(this).attr("data-promo-duration-alt").replace(/\+/g, " ")
            );
          }

          // console.log(promoDurationAlt);

          if (typeof originalPrice === "undefined" || originalPrice === false) {
            originalPrice = 0;
          }

          $(".selection-highlights [data-detail-name]").html(
            desc.replace(/\d+/g, ' <span class="big-number">$&</span>')
          );
          $("[data-internet-row] [data-detail-name]").html(
            desc.replace(/\d+/g, " <span>$&</span>")
          );

          $(".selection-highlights [data-promo-duration]").text(promoDuration);

          if (promoDuration && promoDuration.trim().length) {
            $(".selection-highlights [data-promo-duration]").removeClass(
              "hide"
            );
          } else {
            $(".selection-highlights [data-promo-duration]").addClass("hide");
          }

          $(".selection-highlights [data-promo-duration-alt]").html(
            promoDurationAlt
          );

          if (promoDurationAlt && promoDurationAlt.trim().length) {
            $(".selection-highlights [data-promo-duration-alt]").removeClass(
              "hide"
            );
          } else {
            $(".selection-highlights [data-promo-duration-alt]").addClass(
              "hide"
            );
          }

          $(
            "[data-price-details] [data-internet-row] [data-detail-includes]"
          ).html(includedMessaging);

          if ($(this).attr("data-promo-duration")) {
            $("[data-term-duration]").html(promoDuration);
          } else {
            $("[data-term-duration]").html("");
          }

          internetTotal += Number(currPrice);
          internetOrig += Number(originalPrice);
          // console.log(currPrice, internetOrig);
        }
      }

      // console.log($(this).parents('.order-step').attr('data-group-type'), $(this));

      // build mobile details - wifi
      var buildWifiDetails = debounce(
        function(context){
          // envConsoleLog('Building wifi details');
          // before building wifi details, remove any rows that are not in the product selection
          $("[data-price-details] [data-wifi-row]:not(.hide)").each(function() {
            // envConsoleLog('Checking wifi row', $(this).attr("data-item-id"));
            var featureId = $(this).attr("data-item-id");
            var featureExists = false;


          // check if any checked item == the featureId instead of product stash
          $(
            ".product-wrap.product-select label:not(.hide) input[type=checkbox]:checked, .product-wrap.product-select label:not(.hide) input[type=radio]:checked, .product-wrap.product-select select, #ns-regulatory-fees"
          ).each(function() {
            // envConsoleLog('Checking feature', $(this).attr("data-product-feature-id"));
            if($(this).attr("data-product-feature-id") == featureId){
              featureExists = true;
            }
          });
            if (!featureExists) {
              $(this).remove();
            }
          });

          if (
            $(context).parents(".order-step").attr("data-group-type") === "wifi" &&
            $(context).attr("data-add-to-screen-details") == 1 &&
            $(context).attr("data-feature-group-type") != 4 &&
            currentStep >= 2
          ) {
            // envConsoleLog('Adding wifi details');
            if ($(context).attr("data-price")) {
              var itemTotal = Number($(context).attr("data-price"));

              if ($(context).is("select")) {
                itemTotal *= Number($(context).val());
              }

              wifiTotal += itemTotal;
              internetOrig += itemTotal;

              var featureId = $(context).attr("data-product-feature-id");
              var existingRow = $("[data-price-details] [data-item-id='" + featureId + "']");

              // Only clone and append if there isn't an existing row with the same data-item-id
              if (existingRow.length === 0) {
                var wifiRow = $("[data-price-details] [data-wifi-row]").clone();

                wifiRow.attr("data-item-id", featureId);
                // wifiRow.find("[data-detail-name]").text($(context).attr("name"));
                // get the name from the ancestor .pricing-row [data-legacy-name] & strip html
                wifiRow.find("[data-detail-name]").text($(context).parents(".pricing-row").find('[data-legacy-name]').attr("data-legacy-name").replace(/<\/?[^>]+(>|$)/g, ""));
                let formattedTotal = itemTotal % 1 === 0 ? itemTotal.toFixed(0) : itemTotal.toFixed(2);
                wifiRow.find("[data-detail-price]>[data-detail-current-price]").text(formattedTotal);
                if($(context).attr("data-original-price") !== undefined && $(context).attr("data-original-price") != 0){
                  let originalPrice = parseFloat($(context).attr("data-original-price")).toFixed(2);
                  wifiRow.find("[data-detail-price] [data-detail-original-price]").text(originalPrice);
                  wifiRow.find("[data-detail-price]>.old-price").removeClass("hide");
                }
                wifiRow.removeClass("hide");

                $("[data-price-details] [data-wifi-row]:last").after(wifiRow[0]);
                // envConsoleLog('Wifi row added', featureId);
              } else {
                // envConsoleLog('Duplicate row not added', featureId);
              }
            }
          }
        }, 300
      );

      buildWifiDetails(this);


      // build mobile details - tv
      if ($(this).parents(".order-step").attr("data-group-type") === "tv" &&
      $(this).attr("data-feature-group-type") != 4 && currentStep >= 3) {
        $("[data-price-details] [data-tv-row]").removeClass("hide");
        if ($(this).attr("data-price") && (!$(this).attr("data-doesnt-change-total") == true)) {
          tvTotal += Number($(this).attr("data-price"));
          if ($(this).attr("data-one-time-charge") == "1") {
            oneTimeTotal += Number($(this).attr("data-price"));
          } else {
            internetOrig += Number($(this).attr("data-price"));
          }
          // console.log(internetOrig, tvTotal);
        }
      }

      // build mobile details - voice
      if ($(this).parents(".order-step").attr("data-group-type") === "voice" &&
      $(this).attr("data-feature-group-type") != 4 && currentStep >= 3) {
        $("[data-price-details] [data-voice-row]").removeClass("hide");
        if ($(this).attr("data-price")) {
          // voiceTotal += Number($(this).attr("data-price"));
          var itemTotal = Number($(this).attr("data-price"));

          if ($(this).attr("data-one-time-charge") == "1") {
            oneTimeTotal += Number($(this).attr("data-price"));
          } else {
            internetOrig += Number($(this).attr("data-price"));
          }

          if ($(this).attr("data-one-time-charge") !== "1") {
            voiceTotal += itemTotal;
          }

          // console.log(internetOrig);
        }
      }

    }

    if ($(this).is('select[data-logic-override="special-wifi-logic"]')) {
      internetwifiQty = $(this).val();
      if ($("#feature_3925_7").prop("checked")) {
        internetwifiTotal += parseInt($("#feature_3925_7").attr("data-price"));
      }
      if ($("#feature_3929_8").val() !== "0") {
        internetwifiTotal +=
          parseInt($("#feature_3929_8").val()) *
          parseInt($("#feature_3929_8").attr("data-price"));
      }

      internetTotal += internetwifiTotal;
      internetOrig += internetwifiTotal;
      // console.log(internetwifiTotal);
    }

    // if item has terms text set on this step
    if($(this).attr('data-terms-modal-text') ){
      if($(this).parents('.order-step').attr('data-order-step') == orderStep){
        // update modal & checkbox
        $('#productTermsModal [data-product-terms-content]').html($(this).attr('data-terms-modal-text'));
        $('[data-product-terms-check]').removeClass('hide');
        $('[data-product-terms-check]').addClass('d-block');

        // if item is not accepted, disable progression
        if($(this).attr('data-terms-accepted') != 'true'){
          currentProduct = $(this);
          // disable step select
          disableStepProgression();
        }
      }
    }



  }); // end each


  // have to loop through not checked to remove terms checkbox if no items on step
  $(
    ".product-wrap.product-select input[type=checkbox]:not(:checked), .product-wrap.product-select input[type=radio]:not(:checked)"
  ).each(function(){
    if($(this).attr('data-terms-modal-text') ){
      if($(this).parents('.order-step').attr('data-order-step') == orderStep){
        $('[data-product-terms-check]').addClass('hide');
        enableStepProgression();
      }
    }
  });

  $("[data-installation-fee]").text(
    "$" + $("#order-step-one").attr("data-installation-fee-total")
  );

  if (waiveInstallationFee) {
    $("[data-waived-install-fee]").removeClass("hide");
    $("[data-show-install-fee]").addClass("hide");
  } else {
    $("[data-waived-install-fee]").addClass("hide");
    $("[data-show-install-fee]").removeClass("hide");
  }

  // console.log("Installation Fee Waived: " + waiveInstallationFee);

  // Set pre-fee price
  $("[data-price-details] [data-pre-fee-price]").text(
    Number(internetTotal + wifiTotal + tvTotal + voiceTotal).toFixed(2)
  );

  // Update price bubble
  console.log('pricing', start_price, additional_amount);

  var separatePrice = Number(start_price + additional_amount)
    .toFixed(2)
    .split(".");

  $("[data-total-price]").html(
    separatePrice[0] + "<sup>." + separatePrice[1] + "</sup>"
  );
  // $('.mobile-bottom-price .price-container .price').text(Number(start_price + additional_amount).toFixed(2));

  if (internetwifiQty > 0) {
    $("[data-price-details] [data-detail-wifi] [data-wifi-qty]").text(
      internetwifiQty
    );
    $("[data-price-details] [data-detail-wifi] [data-wifi-price]").text(
      internetwifiTotal
    );
    if (internetwifiQty > 1) {
      $("[data-price-details] [data-detail-wifi] [data-wifi-point]").text(
        "points"
      );
    } else {
      $("[data-price-details] [data-detail-wifi] [data-wifi-point]").text(
        "point"
      );
    }
    $("[data-price-details] [data-detail-wifi]").removeClass("hide");
  } else {
    $("[data-price-details] [data-detail-wifi] ").addClass("hide");
  }

  if (oneTimeTotal > 0) {
    $("[data-one-time-charges]").removeClass("hide");
    $("[data-price-one-time]").text(Number(oneTimeTotal).toFixed(2));
  } else {
    $("[data-one-time-charges]").addClass("hide");
    $("[data-price-one-time]").text(Number(0).toFixed(2));
  }

  $("[data-price-details] .price-container .price").text(
    Number(start_price + additional_amount).toFixed(2)
  );
  $("[data-price-details] [data-internet-row] [data-detail-price] span").text(
    Number(internetTotal).toFixed(2)
  );
  // $("[data-price-details] [data-wifi-row] [data-detail-price] span").text(
  //   Number(wifiTotal).toFixed(2)
  // );
  $("[data-price-details] [data-tv-row] [data-detail-price] span").text(
    Number(tvTotal).toFixed(2)
  );
  $("[data-price-details] [data-voice-row] [data-detail-price] span").text(
    Number(voiceTotal).toFixed(2)
  );

  if (internetOrig - additional_amount > 0) {
    $('.product-total-price-strikethrough').removeClass('hide');
    $('[data-total-price-strikethrough]').text(Number(internetOrig).toFixed(0));

    $("[data-price-details] [data-monthly-row] [data-old-price]").text(
      Number(internetOrig).toFixed(2)
    );
    $("[data-price-details] [data-monthly-row] [data-old-price]")
      .parent()
      .removeClass("hide");
  } else {
    $('.product-total-price-strikethrough').addClass('hide');
    $('[data-total-price-strikethrough]').text('');
    $("[data-price-details] [data-monthly-row] [data-old-price]")
      .parent()
      .addClass("hide");
    $("[data-price-details] [data-monthly-row] [data-old-price]").text(
      Number(0).toFixed(2)
    );
  }

  $("[data-price-details] [data-monthly-row] [data-sale-price]").text(
    Number(start_price + additional_amount).toFixed(2)
  );

  if ($("[data-fee-total]").is(":visible")) {
    $("[data-price-details] [data-monthly-row] [data-old-price]").text(
      Number(internetOrig + Number($("[data-fee-total]:first").text())).toFixed(
        2
      )
    );
  }

  // check if data promo duratiuon alt has content
  $("#pricing-sticky .promo-duration[data-promo-duration-alt]").each(function () {
    // envConsoleLog($(this));
    // envConsoleLog($(this).text());
    // envConsoleLog($(this).text().length);
    if ($(this).text().length > 0) {
      // envConsoleLog($(this).closest(".price-bar-sticky").find(".price-term"));
      $(this).closest(".price-bar-sticky").find(".price-term").addClass("hide");
    }else{
      // envConsoleLog($(this).closest(".price-bar-sticky").find(".price-term"));
      $(this).closest(".price-bar-sticky").find(".price-term").removeClass("hide");
    }
  });
  // console.log(internetTotal, wifiTotal, tvTotal, voiceTotal, internetOrig, additional_amount);
}

function updateInputStyle() {
  var $ = jQuery;
  $(".product-wrap.product-select input").each(function () {
    if ($(this).prop("checked")) {
      $(this).parents("label").addClass("highlight");

      // if product is a slider card, update the tab heading
      if ($(this).parents(".feature-label.card.slick-slide").length) {
        var slideIndex = $(this).parents(".feature-label.card.slick-slide").attr("data-slick-index");
        $(".tab-headings .tab-heading").removeClass("active");
        $(".tab-headings .tab-heading[data-slide='" + slideIndex + "']").addClass("active");
      }
    } else {
      $(this).parents("label").removeClass("highlight");
    }
  });
}

function updateInstallationSchedule(scheduleText) {
  var $ = jQuery;
  $("#product_service_install_final").text(scheduleText);
}

function updateProductOrderCookie() {
  var $ = jQuery;

  var product_ns_id = $(".product-select").attr("data-ns-product-id"),
    product_ns_promotion_id = [],
    product_features = [];
  var productSelection = JSON.parse(
    localStorage.getItem(cookieLabel_product_selection)
  );

  // console.log('product_ns_id', product_ns_id);

  // Update Product ID if feature changes product ID
  var useAlternateFeature = false;
  $("input[data-changes-product]:checked").each(function () {
    // console.log($('input[data-changes-product]:checked').attr('value'));
    if (
      $(this).attr("data-changes-product") !== "" &&
      typeof $(this).attr("data-changes-product") !== "undefined"
    ) {
      product_ns_id = $(this).attr("data-changes-product");
      // console.log('product_ns_id', product_ns_id);
      $("#product-selection").attr("data-ns-product-id", product_ns_id);
      useAlternateFeature = true;
      return false;
    } else {
      product_ns_id = $("#product-selection").attr("data-ns-product-id-orig");
      // console.log('product_ns_id', product_ns_id);
      $("#product-selection").attr(
        "data-ns-product-id",
        $("#product-selection").attr("data-ns-product-id-orig")
      );
    }
  });

  // Iterate through product features
  $(
    '#order-info .order-step[data-order-step="1"] input, #order-info .order-step[data-order-step="1"] select, #order-info .order-step[data-order-step="2"] input, #order-info .order-step[data-order-step="2"] select, #order-info .order-step[data-order-step="3"] input, #order-info .order-step[data-order-step="3"] select'
  ).each(function () {
    var product_feature_id = $(this).attr("data-product-feature-id"),
      uat_product_feature_id = $(this).attr("data-uat-feature-id"),
      product_feature_checked = false,
      product_feature_qty = 1,
      product_feature_name = "",
      product_feature_price = 0,
      product_feature_type = "",
      has_promo_zone = false;

      if ($(this).attr("data-promo-zone") && $(this).attr("data-promo-zone") !== "null") {
        has_promo_zone = true;
    }

    if ($(this).prop("checked")) {
      if (
        $(this).attr("data-product-promotion-id") &&
        !useAlternateFeature &&
        !has_promo_zone
      ) {
        product_ns_promotion_id.push({
          id: $(this).attr("data-product-promotion-id"),
        });
      }
    }

    if (
      useAlternateFeature &&
      $(this).attr("data-product-alt-feature-for-ns-id") == product_ns_id &&
      !has_promo_zone
    ) {
      product_feature_id = $(this).attr("data-product-alt-feature-id");
      if ($(this).prop("checked")) {
        if ($(this).attr("data-product-alt-promotion-id")) {
          product_ns_promotion_id.push({
            id: $(this).attr("data-product-alt-promotion-id"),
          });
        }
      }
    }

    var validFeatureIDs = '';
    if(typeof closer_popup_accepted_ids == Array){
    validFeatureIDs = closer_popup_accepted_ids.map(item => item.closer_popup_accepted_feature_id);}

    // update order details for closer promo in updateProductOrderCookie since we can check the product selection here
    if( productSelection != null &&
    !productSelection.product_feature_selection.some((feature) =>
      validFeatureIDs.includes(feature.product_feature_id)
    )  && closerPromoAccepted){
      // closer accepted but user no longer has item in cart? remove from order details slideout
      $("[data-additional-row='closer_promo']").remove();
    }

    //build complimentary details if it is present in the selection
    // loop through product selection to add items or remove them, usable with 1 complimentary item
    if(productSelection != null && productSelection.product_feature_selection.some((feature) =>
    {
      return feature.product_feature_type === "Complimentary";
    } ))
    {
      productSelection.product_feature_selection.forEach((feature) => {
        if (feature.product_feature_type === "Complimentary") {
            let $featureEl = $("[data-product-feature-id='" + feature.product_feature_id + "']");
            let itemLabel = $featureEl.parents("label").find(".feature-desc>div").text();

            if (!$("[data-additional-row='" + feature.product_feature_id + "']").length) {
                var complimentaryRow = $("[data-other-row]").first().clone();
                complimentaryRow.attr("data-complimentary-row", true);
                complimentaryRow.attr("data-additional-row", feature.product_feature_id);
                complimentaryRow.find("[data-detail-name]").text(itemLabel);
                complimentaryRow.find("[data-detail-includes]").text("Limited time offer");
                complimentaryRow.find("[data-detail-price]>span").text($featureEl.attr("data-price"));
                complimentaryRow.removeClass("hide");
                $("[data-price-details] .product-selection-details>tbody").append(complimentaryRow);
            }
        }
    });
    }else{
      $("[data-complimentary-row]").remove();
    }

    let addrCity = localStorage.getItem("lumos_address_city");

    if (addrCity !== null) {
      addrCity = addrCity.toUpperCase();
    } else {
      addrCity = "";
    }

    if (
      $(this).attr("data-old-market") &&
      (localStorage.getItem("lumos_address_iqport") == "0" ||
        addrCity == "KERNERSVILLE") &&
      !has_promo_zone
    ) {
      product_feature_id = $(this).attr("data-old-market");
    }

    if ($(this).is("select")) {
      product_feature_qty = parseInt($(this).val());
      if (product_feature_qty > 0) {
        product_feature_checked = true;
      }
    } else {
      product_feature_checked = $(this).prop("checked");
    }

    product_feature_name = $(this)
      .parents("label")
      .find(".feature-desc")
      .text()
      .replace(/^\s+|\s+$/g, "")
      .replace(/(<([^>]+)>)/gi, "");
    if (
      typeof $(this)
        .parents("label")
        .find(".feature-desc")
        .attr("data-legacy-name") !== "undefined" &&
      $(this).parents("label").find(".feature-desc").attr("data-legacy-name")
        .length
    ) {
      product_feature_name = $(this)
        .parents("label")
        .find(".feature-desc")
        .attr("data-legacy-name")
        .replace(/^\s+|\s+$/g, "")
        .replace(/(<([^>]+)>)/gi, "");
    }

    if ($(this).parents("label").find("[data-product-price]").length) {
      product_feature_price = $(this)
        .parents("label")
        .find("[data-product-price]")
        .text();
    }

    product_feature_type = $(this).attr("data-group-type");

    // if data-feature-group-type is set to 4 then is is a complimentary feature, not of it's grouped type
    if ($(this).attr("data-feature-group-type") === "4") {
      product_feature_type = "Complimentary";
    }

    // Check if environment is UAT, if it is use UAT product feature ID if available
    if (!(server_environment === "live")) {
      if (uat_product_feature_id && uat_product_feature_id.length) {
        product_feature_id = uat_product_feature_id;
      }
    }

    if (product_feature_id) {
      let modified_product_feature_id = product_feature_id;
      //this is our special feature id to add the original to the cart
      // envConsoleLog("Product Feature ID: " + product_feature_id);
      if (product_feature_id.startsWith("000") && product_feature_id.endsWith("09")) {
        product_feature_id = product_feature_id.slice(3, -2);
        // envConsoleLog("Sliced Product Feature ID: " + product_feature_id);
      }

      if (product_feature_id.startsWith("000") && product_feature_id.endsWith("404")) {
        product_feature_checked = false;
      }

      if (product_feature_checked) {
        product_features.push({
          product_feature_id: product_feature_id,
          product_feature_checked: product_feature_checked,
          product_feature_qty: product_feature_qty,
          product_feature_name: product_feature_name,
          product_feature_price: parseFloat(product_feature_price),
          product_feature_type: product_feature_type,
        });
      }
    }
  });

  var productSelection = {
    product_ns_id: product_ns_id,
    product_feature_selection: product_features,
  };

  if (product_ns_promotion_id.length) {
    productSelection.product_ns_promotion_id = product_ns_promotion_id;
  }

  // console.log("Product Selection", productSelection);
  // console.log(JSON.stringify(productSelection));

  localStorage.setItem(
    cookieLabel_product_selection,
    JSON.stringify(productSelection)
  );
} // end updateProductOrderCookie()

function loadProductSelection() {
  var $ = jQuery;

  if (localStorage.getItem(cookieLabel_product_selection)) {
    var productSelection = JSON.parse(
      localStorage.getItem(cookieLabel_product_selection)
    );

    if (
      $("#product-selection").attr("data-ns-product-id") ===
      productSelection.product_ns_id
    ) {
      var feature_selection = productSelection.product_feature_selection;

      for (var i = 0; i < feature_selection.length; i++) {
        // console.log(feature_selection[i], $('#feature_'+feature_selection[i].product_feature_id).attr('id'));
        // console.log(
        //   '[value="' + feature_selection[i].product_feature_id + '"]',
        //   $('[value="' + feature_selection[i].product_feature_id + '"]')
        // );

        if (
          feature_selection[i].product_feature_checked &&
          typeof $("#feature_" + feature_selection[i].product_feature_id)[0] !==
            "undefined"
        ) {
          // console.log('feature selection id', i, feature_selection[i].product_feature_id);
          $(
            '[value="' + feature_selection[i].product_feature_id + '"]'
          )[0].click();
          $(
            '[value="' + feature_selection[i].product_feature_id + '"]'
          ).trigger("change");
        }
        if (feature_selection[i].product_feature_qty > 0) {
          $('[value="' + feature_selection[i].product_feature_id + '"]').val(
            feature_selection[i].product_feature_qty
          );
          $(
            '[value="' + feature_selection[i].product_feature_id + '"]'
          ).trigger("change");
        }
      }
    } // endif
  } // endif

  if (
    urlParamNS("feature_selected") !== null &&
    urlParamNS("feature_selected").length
  ) {
    $("#feature_" + urlParamNS("feature_selected"))[0].click();
    // $('#feature_'+urlParamNS('feature_selected')).trigger('change');
  }
}

// Advance to step
function orderAdvance() {
  // console.log("order advance to:", orderStep + 1);
  orderToStep(orderStep + 1);
} // end orderAdvance()

window.addEventListener("popstate", function (e) {
  if ($("#order-info").length) {
    console.log("In Ecommerce Flow");
    if (window.location.hash && window.location.hash.includes("step-")) {
      var hashStep = Number(window.location.hash.split("-")[1]);
      if (hashStep > 0 && hashStep <= orderStep) {
        // console.log("Go To Step: ", hashStep);
        orderStep = hashStep;
        orderToStep(hashStep);
      }
    } else {
      orderStep = 1;
      orderToStep(1);
      // console.log("Go To Start");
    }
  }
  // console.log(location.hash.slice(1));
});

var hasPromoActionsBeenTriggered = false;
var closerPromoAccepted = false;
var closerTimer = null;
var dismissCloserPopup = false;
var stepReached = 1;
var currentStep = 1;
localStorage.setItem("showCloserPopup", "true"); // set to true on load so all users get the promo
var closerStep = 1; // step to show the closer promo
if(typeof closer_popup_step != "undefined"){
  closerStep = closer_popup_step;
}

// console.log("closerStep", closerStep);

// Go to a specific step
function orderToStep(stepIndex) {
  var $ = jQuery;
  var productSelection = JSON.parse(
    localStorage.getItem(cookieLabel_product_selection)
  );

  // hide terms check on each step
  $('[data-product-terms-check]').addClass('hide');
  enableStepProgression();
  // if the user is going back a step, clear out the appropriate price details in data-row and selection
  if (stepIndex < currentStep) {
    if(stepIndex == 1){
      productSelection.product_feature_selection.forEach((feature) => {
        if(feature.product_feature_type === "wifi") {
          productSelection.product_feature_selection = productSelection.product_feature_selection.filter((item) => item.product_feature_id !== feature.product_feature_id);
          localStorage.setItem(cookieLabel_product_selection, JSON.stringify(productSelection));
        }
      });
      $("[data-price-details] [data-wifi-row]:not(.hide)").remove();
    }
  }

  currentStep = stepIndex;
  $("#price-drawer-content-label").removeClass("invisible");
  $("#price-drawer-content-label-mobile").removeClass("invisible");

  $(".special-notification-terms").addClass("hide");

  // console.log('Go To Step: ' + stepIndex, 'Current Step: '+orderStep);
  // envConsoleLog("Go To Step: " + stepIndex, "Current Step: " + orderStep);
  let hasStep2 = true;
  // let hasStep2 = checkStack() !== 'legacy';
  // if(!hasStep2 && stepIndex == 2){
  //   orderToStep(3);
  //   return;
  // }
  if(stepIndex == 2 && stepReached < 2 && hasStep2){
    // console.log('send vwo event on step 2');
    // send vwo event on step 2
    window.VWO = window.VWO || [];
    VWO.event = VWO.event || function () {VWO.push(["event"].concat([].slice.call(arguments)))};

    VWO.event("wifiStepClickBoolean", {
      "wifiStepClickBoolean": true
    });
  }

  if(stepReached < stepIndex){
    stepReached = stepIndex;
  }


  // $('#order-step-one').attr('data-order-step', stepIndex);

  /*
    Logic for promo popup when idling on step, add gift card product to order
  */
    // clear time if we go to a different step
  if (stepIndex !== closerStep && closerTimer !== null) {
    clearTimeout(closerTimer);
    closerTimer = null;
    hasPromoActionsBeenTriggered = false;
  }

  // array of feature IDs that trigger popup (500mbps+ legacy)
  var validFeatureIDs = '';
  if(typeof closer_popup_accepted_ids == Array){
   validFeatureIDs = closer_popup_accepted_ids.map(item => item.closer_popup_accepted_feature_id);}

  var showCloserPopup = localStorage.getItem("showCloserPopup"); // this is set when vwo sends user
  var minTime = typeof closer_popup_timing != "undefined" ? closer_popup_timing : 2;
  var productSelection = JSON.parse(
    localStorage.getItem(cookieLabel_product_selection)
  );
  var selectionValid = false;
  if(productSelection != null){
    selectionValid = productSelection.product_feature_selection.some((feature) => validFeatureIDs.includes(feature.product_feature_id));
  }
  // console.log("productSelection", productSelection);
  // Legacy, correct step, has valid feature IDs, popup set to show, and promo actions have not been triggered
  if (
    stepIndex == closerStep &&
    !hasPromoActionsBeenTriggered &&
    !dismissCloserPopup &&
    document.getElementById("closerModal") !== null &&
    selectionValid &&
    showCloserPopup
    )
  {
      hasPromoActionsBeenTriggered = true;
      // start timer
      closerTimer = setTimeout(function () {
          $('#closer-promo-cta').one('click', function() {
            // user has accepted offer
            localStorage.setItem("showCloserPopup", "false");
            closerPromoAccepted = true;
            updateOrderCloserPromo(productSelection, cookieLabel_product_selection);
            $(".closer-promo-disclaimer").removeClass("hide");
            // Add in a new other row for the closer popup if it has been added
            // duplicate the data-other-row, change data-other-row to data-additional-row
            if ($('[data-additional-row="closer_promo"]').length === 0) {
              var $newOtherRow = $("[data-other-row]:not([data-complimentary-row])").first().clone();
              $newOtherRow.removeAttr("data-other-row").attr("data-additional-row", "closer_promo");
              $newOtherRow.removeClass("hide");
              $newOtherRow.find("[data-detail-name]").text("$" + active_popup['closer_gift_card_price'] + " Gift Card");
              $newOtherRow.find("[data-detail-includes]").text("Complimentary with your order");
              $("[data-other-row]:not([data-complimentary-row])").before($newOtherRow);
                          }
            
            window.dataLayer.push({
              event: "select_promotion",
              ecommerce: {
                promotion_name: "50DollarPromoV2"
              }
            });
          });

          $("#closer-promo-no").on("click", function() {
            $(".closer-promo-disclaimer").addClass("hide");
            dismissCloserPopup = true;
          });
          $("#closerModal .btn-close").on("click", function() {
            $(".closer-promo-disclaimer").addClass("hide");
          });

          // trigger popup
          document.querySelector("#closerModalTrigger").click();
          // sned popupShown event ga
          let data = {
            event: 'popupShown'
          };

          
          window.dataLayer.push(data);

          window.dataLayer.push({
            event: "view_promotion",
            ecommerce: {
              promotion_name: "50DollarPromoV2"
            }
          });
          // show disclaimer
          $(".closer-promo-disclaimer").removeClass("hide");

    }, minTime * 1000);


  }

  // readd closer promo details since cart is built with selections if user goes back
  if(
    productSelection != null &&
    closerPromoAccepted &&
    productSelection.product_feature_selection.some((feature) =>
      validFeatureIDs.includes(feature.product_feature_id)
    )) {
    // console.log("readding promo details");
    updateOrderCloserPromo(productSelection, cookieLabel_product_selection);
  }
    /*
      End promo popup logic
    */

  // Only advance if it doesn't exceed max steps
  if (stepIndex <= orderStepMax) {
    // Scroll to top
    var scrollOffsetTop =
      $("#order-info").prevAll(".wf-floating-address-check").offset().top -
      ($("#header").outerHeight() || 0);
    // console.log("scroll to top");
    // $([document.documentElement, document.body]).stop().animate({
    // $('html,body').stop().animate({
    //   scrollTop: scrollOffsetTop,
    // }, 400);
    window.scrollTo({ top: scrollOffsetTop, behavior: "smooth" });

    // Set Order Step
    orderStep = stepIndex;

    if (orderStep !== 1) {
      window.location.hash = "step-" + orderStep;
    }

    var backButtonMbl = orderStep - 1;
    if (backButtonMbl == 0) {
      backButtonMbl = 1;
    }
    $("#ecommerce-flow-nav .nav-go-back").attr("data-goto-step", backButtonMbl);

    if (orderStep == 1) {
      // $('#price-bubble-advance-button').removeClass('text-md-end');
      // $('.pricing-wrap').removeClass('slim');
      // $('.accordion.price-drawer').removeClass('slim');
      $(".selection-highlights").addClass("col-md-4");
      $(".selection-highlights").removeClass("col-md-6");
    } else {
      // $('#price-bubble-advance-button').addClass('text-md-end');
      // $('.pricing-wrap').addClass('slim');
      // $('.accordion.price-drawer').addClass('slim');
      $(".selection-highlights").removeClass("col-md-4");
      $(".selection-highlights").addClass("col-md-6");
    }

    // remove current indicator
    $("[data-order-step-indicator]").each(function () {
      $(this)
        .find("li")
        .each(function (index) {
          var eachIndex = index + 1;

          // console.log('Current EQ: '+eachIndex);

          $(this).removeClass("current");
          $(this).removeClass("complete");

          // Update complete indicator
          if (eachIndex < stepIndex) {
            $(this).addClass("complete");
            // console.log('Is Complete');
          }

          // Hide if not current
          if (eachIndex !== stepIndex) {
            $('[data-order-step="' + eachIndex + '"]').hide();
            // console.log('Not current');
          }

          // Set current
          if (eachIndex === stepIndex) {
            $('[data-order-step="' + eachIndex + '"]').show();
            $(this).addClass("current");
            // console.log('Is Current');
          }

          $("[data-order-step-progress]").attr(
            "data-order-step-progress",
            stepIndex
          );
        });
    });

    // Rest fees if returning to product selection
    if (stepIndex === 1) {
      $("#show-for-step-one").css({
        opacity: 1,
      });

      // Reset slider
      // try {
      //   $(".product-slider .fieldset-container").slick("setPosition");
      // } catch (err) {
      //   console.log(err);
      // }
    } else {
      $("#show-for-step-one").css({
        opacity: 0,
      });
    }

    // show/hide based on step
    $("[data-show-for-step]").each(function() {
      var showForStep = $(this).data('show-for-step');
      if (showForStep && showForStep.toString().trim() !== '') {
          if (parseInt(showForStep) === stepIndex) {
              $(this).removeClass('d-none');
          } else {
              $(this).addClass('d-none');
          }
      }
    });
    $(".wf-shopfiber-v3").attr("data-current-step", stepIndex);

    if (stepIndex !== 5) {
      $("#price-drawer-mobile.pre-checkout").removeClass("d-none");
      $('#price-drawer-content-label-mobile > button').hasClass('collapsed') ? null :  $('#price-drawer-content-label-mobile > button').click();
    }else{
      $("#price-drawer-mobile.pre-checkout").addClass('d-none');
    }

    if (stepIndex === 1 || stepIndex === 2 || stepIndex === 3) {
      $(".disclaimer.nofees").removeClass("hide");
      $(".disclaimer.fees").addClass("hide");
      $("[data-fees-row]").addClass("hide");
      $(".disclaimer.paperfees").addClass("hide");
      $("#ns-regulatory-fees").val(0);
      $("#ns-regulatory-fees").attr("data-price", 0);

      updatePrice();
    } else {
      if (localStorage.getItem("lumos_address_market") == "nc") {
        $(".disclaimer.paperfees").removeClass("hide");
      }

      updatePrice();
    }

    // setTimeout(function () {
    //   $("#pricing-sticky .price-bar-sticky").css({ top: "auto", bottom: 0 });
    //   // console.log('fire');
    // }, 500);
  } // endif
} // end orderToStep()

// add order closer promo details to order
function updateOrderCloserPromo(productSelection, cookieLabel_product_selection) {
  var existingFeatures = productSelection.product_feature_selection || [];
  // Determine the feature ID based on the site URL
  var $closer_feature_id = active_popup['closer_feature_id'];

  // server_environment == 'live' ? '4283' : '4306';

  // Check if the feature ID is already present in the existing features
  var isFeatureAlreadyAdded = existingFeatures.some(function(feature) {
    return feature.product_feature_id === $closer_feature_id;
  });
  var validFeatureIDs = '';
  if(typeof closer_popup_accepted_ids == Array){
    validFeatureIDs = closer_popup_accepted_ids.map(item => item.closer_popup_accepted_feature_id);}

  var productSelection = JSON.parse(
    localStorage.getItem(cookieLabel_product_selection)
  );
  // check again if our promo is applicable
  if( productSelection != null &&  productSelection.product_feature_selection.some((feature) =>
  validFeatureIDs.includes(feature.product_feature_id)
)){
    // Only add the feature if it is not already present
    if (!isFeatureAlreadyAdded) {
      var giftCardFeature = {
        product_feature_id: $closer_feature_id,
        product_feature_checked: true,
        product_feature_qty: 1,
        product_feature_name: 'Complimentary $' + active_popup['closer_gift_card_price'] + ' Gift Card',
        product_feature_price: 0,
        product_feature_type: 'other',
      };

      existingFeatures.push(giftCardFeature);

      // Update the product selection and save it in localStorage
      productSelection.product_feature_selection = existingFeatures;
      localStorage.setItem(
        cookieLabel_product_selection,
        JSON.stringify(productSelection)
      );
    }
    setTimeout(function() {
      if($('#product_selected_features').length && !$('#product_selected_features li').text().includes('$' + active_popup['closer_gift_card_price'] + ' Gift Card')) {
        updateFinalScreenProducts(1, '$' + active_popup['closer_gift_card_price'] + ' Gift Card');
      }
    }, 500);
  }
}


// Resubmit button
$('button[data-resubmit-order]').click(function() {
  submitOrderCaptureSF();
});

// sms opt-in for tidewater
$("#sms-opt-in-tidewater").change(function(){
  if($(this).prop('checked')) {
    $('#account_service_contact_mobile_phone').prop('required', true);
    // Add an astrisk to label
    if(!$('label[for="account_service_contact_mobile_phone"]').text().includes('*')) {
      $('label[for="account_service_contact_mobile_phone"]').text(
        $('label[for="account_service_contact_mobile_phone"]').text() + ' *'
      );
    }
  } else {
    $('#account_service_contact_mobile_phone').prop('required', false);
    // Remove astrisk from label
    if($('label[for="account_service_contact_mobile_phone"]').text().includes('*')) {
      $('label[for="account_service_contact_mobile_phone"]').text(
        $('label[for="account_service_contact_mobile_phone"]').text().replace(' *', '')
      );
    }
  }
});

// make mobile number same
$('#mobile-number-same').change(function() {
  if($(this).prop('checked')) {
    $('#account_service_contact_mobile_phone').val($('#account_service_contact_phone').val());
    $('#account_service_contact_mobile_phone').prop('readonly', true);
  } else {
    $('#account_service_contact_mobile_phone').val('');
    $('#account_service_contact_mobile_phone').prop('readonly', false);
  }
});

$('#account_service_contact_phone').on('keyup change', function() {
  if($('#mobile-number-same').prop('checked')) {
    $('#account_service_contact_mobile_phone').val($(this).val());
  } else {
    // do nothing
  }
})

function submitOrderCaptureSF() {
  var $ = jQuery;

  // Reset retry counters
  getScheduleRetries = 10;
  getTaxesRetries    = 10;
  sendPaymentRetries = 10;

  $('[data-timeout-dialog]').addClass('hide');
  $('[data-primary-dialog]').removeClass('hide');

  isProcessingOrder = true;

  // Reset Submission Frame
  $("#orderSubmitModal-sfapi .submission-indicator li, #orderSubmitModal-sfapi .mobile-step-indicator li").each(function () {
    $(this).removeClass("current");
    $(this).removeClass("error");
    $(this).removeClass("alert-ns");
    $(this).removeClass("step-active");
    $(this).removeClass("user-active");
    $(this).removeClass("complete");
  });

  // open modal
  $orderModal_SFAPI.modal("show");

  $("#submission-error-message-sfapi").addClass("hide");

  // Start Order Processing
  startOrderProcessSF();
}

function startOrderProcessSF() {
  var $ = jQuery;

  $("#orderSubmitModal-sfapi .submission-indicator li")
    .eq(0)
    .addClass("current");

  // Get Access Token
  ajaxCall(
    {
      action: "sf_get_token",
      stepLabel: "Step1.1-Error-sf_get_token",
    },
    function (result) {
      // console.log('Access Token:', result);
      envConsoleLog('Access Token:', result);
      if (result) {
        sendNSTimer("Step1.1-sf_get_token");

        var token = JSON.parse(result);
        // stash access token
        localStorage.setItem("lumos_sftoken", token.access_token);

        // Set token expiration
        var tokenExpiresMin = 85; // Expires in 85 minutes of the 90 minute token
        var tokenExpries = (1 / 24 / 60) * tokenExpiresMin
        Cookies.set('lumos_sftoken_timeout', tokenExpiresMin, { expires: tokenExpries });

        // Set repeating interval to check for token expiration
        checkTokenInterval = setInterval(function() {
          checkToken();
        }, 30000); // checks every 30 seconds



        // Start Countdown Timer
        startOrderTimer(tokenExpiresMin);

        createAccountSF();
      } else {
        sendNSError(
          "Step1.1-Error-sf_get_token-APIError: " + result
        );

        // $('#submission-error-message-sfapi [data-error-message]').text('');
        $("#orderSubmitModal-sfapi .submission-indicator li")
          .eq(0)
          .removeClass("current");
        $("#orderSubmitModal-sfapi .submission-indicator li")
          .eq(0)
          .addClass("error");
        $("#submission-error-message-sfapi").removeClass("hide");
        stopOrderTimer();
      }
    },
    function (request, status, error) {
      $("#orderSubmitModal-sfapi .submission-indicator li")
        .eq(0)
        .removeClass("current");
      $("#orderSubmitModal-sfapi .submission-indicator li")
        .eq(0)
        .addClass("error");
      $("#submission-error-message-sfapi").removeClass("hide");
      stopOrderTimer();
    },
    ajaxurl_lumos
  );
}

function startOrderTimer(tokenExpiresMin) {
  if($('#countdown-timer').length) {

    $('#countdown-timer').removeClass('hide');

    var endtime = new Date(new Date().getTime() + tokenExpiresMin*60000);
    countdownTimerInterval = setInterval(function() {

      var now = new Date().getTime();
      var distance = endtime - now

      var hours   = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)).toString();
      var minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60)).toString().padStart(2, '0');
      var seconds = Math.floor((distance % (1000 * 60)) / 1000).toString().padStart(2, '0');

      $('#countdown-timer').find('[data-hours]').text(hours);
      $('#countdown-timer').find('[data-minutes]').text(minutes);
      $('#countdown-timer').find('[data-seconds]').text(seconds);

      if (distance < 0) {
        stopOrderTimer();
      }

    }, 1000);
  }
}

function stopOrderTimer() {
  if($('#countdown-timer').length) {
    clearInterval(countdownTimerInterval);
    $('#countdown-timer').addClass('hide');
    $('#countdown-timer').find('[data-hours]').text('0');
    $('#countdown-timer').find('[data-minutes]').text('00');
    $('#countdown-timer').find('[data-seconds]').text('00');
  }
}

function checkToken() {
  // console.log('checkingToken');
  if(Cookies.get('lumos_sftoken_timeout')) {
    // token is still good, no action needed
  } else {
    // token has expired, display message

    // Clear check interval
    clearInterval(checkTokenInterval);

    // Hide primary dialog
    $('[data-primary-dialog]').addClass('hide');

    // Reset Submission Frame
    $("#orderSubmitModal-sfapi .submission-indicator li, #orderSubmitModal-sfapi .mobile-step-indicator li").each(function () {
      $(this).removeClass("current");
      $(this).removeClass("error");
      $(this).removeClass("alert-ns");
      $(this).removeClass("step-active");
      $(this).removeClass("user-active");
      $(this).removeClass("complete");
    });
    // Hide messaging and subelements
    $("#submission-error-message-sfapi").addClass("hide");
    $("#schedule-installation-date-sfapi").addClass("hide");
    $("#submitOrderCollapseButton-sfapi").click();

    $("#order-price-totals, .order-price-info").addClass("hide");
    $("#order-payment-sfapi").addClass("hide");

    // Show timeout message
    $('[data-timeout-dialog]').removeClass('hide');

    // hide Timer
    $('#countdown-timer').addClass('hide');
  }
}

function createAccountSF() {
  // Set Account

  // Opt-in Settings
  var smsOptIn = $("#sms-opt-in-tidewater").prop("checked") ? 1 : 0;
  var emailOptIn = $("#email-opt-in").prop("checked") ? 1 : 0;

  var transOrBillingCommPreference = "Email";
  var marketingCommPreference = "None";

  if (smsOptIn == 0 && emailOptIn == 0) {
    transOrBillingCommPreference = "Email";
    marketingCommPreference = "None";
  } else if (smsOptIn == 1 && emailOptIn == 0) {
    transOrBillingCommPreference = "SMS"; // Email & SMS
    marketingCommPreference = "SMS"; // Email & SMS
  } else if (smsOptIn == 0 && emailOptIn == 1) {
    transOrBillingCommPreference = "Email";
    marketingCommPreference = "Email Only";
  } else if (smsOptIn == 1 && emailOptIn == 1) {
    transOrBillingCommPreference = "SMS"; //Email & SMS
    marketingCommPreference = "Email & SMS";
  }

  var dataPayload = {
    "custFirstName": $('#account_service_first_name').val(),
    "custLastName": $('#account_service_last_name').val(),
    "phoneNumber":  $('#account_service_contact_phone').val().replace(/\D/g,''),
    "mobilePhone": $('#account_service_contact_mobile_phone').val().replace(/\D/g,''),
    "email": $('#account_service_contact_email').val(),
    "universalId": localStorage.getItem('lumos_address_universaladdress_id'),
    "pin": "",
    "accountPasscode": $('#account_service_contact_passcode').val(),
    "TransOrBillingCommPreference" : transOrBillingCommPreference,
    "MarketingCommPreference": marketingCommPreference
  };

  // console.log('Create Account Payload:', JSON.stringify(dataPayload));

  ajaxCall(
    {
      action: "sf_create_account",
      payload: dataPayload,
      token: localStorage.getItem("lumos_sftoken"),
      stepLabel: "Step1.2-Error-sf_create_account",
    },
    function (result) {
      // console.log('Create Account Response:', result);
      envConsoleLog('Create Account Response:', result);

      var isValidJSON = false;

      try {
        JSON.parse(result);
        isValidJSON = true;
      } catch (error) {
        isValidJSON = false;
      }

      if (result && isValidJSON) {

        sendNSTimer("Step1.2-sf_create_account");

        var resultObj = JSON.parse(result);
        var sfOrderID = "";
        if ("orderId" in resultObj) {
          sfOrderID = resultObj.orderId.replace(/["']/g, "");
        } else if ("OrderId" in resultObj) {
          sfOrderID = resultObj.OrderId.replace(/["']/g, "");
        }

        // console.log('Using Order ID:', sfOrderID);
        envConsoleLog('Using Order ID:', sfOrderID);

        if(resultObj.orderNumber !== null && resultObj.orderNumber !== undefined) {
          localStorage.setItem("lumos_sforderid", sfOrderID);
          localStorage.setItem("lumos_sfordernumber", resultObj.orderNumber.replace(/["']/g, ""));

          $('[data-processing-steps] [data-step="1"]').addClass("complete");
          addOffersSF();
        } else {

          sendNSError(
            "Step1.2-Error-sf_create_account-APIResultError:" + result
          );

          $("#orderSubmitModal-sfapi .submission-indicator li")
            .eq(0)
            .removeClass("current");
          $("#orderSubmitModal-sfapi .submission-indicator li")
            .eq(0)
            .addClass("error");
          $("#submission-error-message-sfapi").removeClass("hide");
          stopOrderTimer();
        }

      } else {

        sendNSError(
          "Step1.2-Error-sf_create_account-APIError:" + result
        );

        $("#orderSubmitModal-sfapi .submission-indicator li")
          .eq(0)
          .removeClass("current");
        $("#orderSubmitModal-sfapi .submission-indicator li")
          .eq(0)
          .addClass("error");
        $("#submission-error-message-sfapi").removeClass("hide");
        stopOrderTimer();
      }
    },
    function (request, status, error) {
      $("#orderSubmitModal-sfapi .submission-indicator li")
        .eq(0)
        .removeClass("current");
      $("#orderSubmitModal-sfapi .submission-indicator li")
        .eq(0)
        .addClass("error");
      $("#submission-error-message-sfapi").removeClass("hide");
      stopOrderTimer();
    },
    ajaxurl_lumos
  );
}

function addOffersSF() {
  // Add Offers

  var internetSpeed = 100,
    voiceQty = 0,
    voiceNonPub = false,
    wifiQty = 0,
    wifiExtQty = 0,
    promoCode = "",
    installationFee = true,
    experienceIQ = false,
    eightHourBatt = 0,
    twenty4HourBatt = 0;

  // if($("input[data-waive-installation-fee]:checked").length){
  //   installationFee = false;
  // }

  var feature_stash = $.parseJSON(
    localStorage.getItem(cookieLabel_product_selection)
  );

  for (var i = 0; i < feature_stash.product_feature_selection.length; i++) {
    var currSelection = feature_stash.product_feature_selection[i];

    if (currSelection.product_feature_type == "internet") {
      if (isNumeric(currSelection.product_feature_id)) {
        internetSpeed = Number(currSelection.product_feature_id);
      } else {
        promoCode = currSelection.product_feature_id;
      }
    }

    if (currSelection.product_feature_type == "wifi") {
      wifiQty = 1;
      // experienceIQ = true;
      if (currSelection.product_feature_id == "wifi_extension") {
        wifiExtQty = Number(currSelection.product_feature_qty);
      }
      if (currSelection.product_feature_id == "wifi_experienceiq") {
        experienceIQ = true;
      }
    }

    if (currSelection.product_feature_type == "voice") {
      if (currSelection.product_feature_id == "voice") {
        voiceQty = 1;
      }
      if (currSelection.product_feature_id == "voice_nonPublishedListing") {
        voiceNonPub = true;
      }
      if (currSelection.product_feature_id == "voice_battery_eight") {
        eightHourBatt = 1;
      }
      if (currSelection.product_feature_id == "voice_battery_twentyfour") {
        twenty4HourBatt = 1;
      }
    }
  }

  var dataPayload = {
    orderID: localStorage.getItem("lumos_sforderid"), // Salesforce Order ID obtained previously
    code: "RESID_BROAD", // string code, hardcoded
    speed: internetSpeed, // number, options are 100, 200, 500, 1000, 2000 and 5000
    voice: {
      quantity: voiceQty, // number, 0-1, determines if Voice has been selected
      addOns: {
        nonPublishedListing: voiceNonPub, // true/false
        // "8-Hour": 0, // number, 0-99
        // "24-Hour": 0 // number, 0-99
        eightHours: eightHourBatt, // or eightHours if you crave correct spelling
        twenty4Hours: twenty4HourBatt,
      },
    },
    wifi: {
      quantity: wifiQty, // number, 0-1, determines if WiFi has been selected
      addOns: {
        experienceIQ: experienceIQ, // true/false
        extension: wifiExtQty, // number, 0-4
      },
    },
    staticIP: 0, // number, goes from 0-3
    protectIQ: (internetSpeed !== 100 && internetSpeed !== 200), // Hardcoded to exclude from 100/200 plans
    installationFee: installationFee,
  };

  if (promoCode) {
    dataPayload.promotionCode = promoCode;
  }

  // console.log('Add Offers Payload:', JSON.stringify(dataPayload));
  envConsoleLog('Add Offers Payload:', JSON.stringify(dataPayload));

  ajaxCall(
    {
      action: "sf_add_offers",
      payload: JSON.stringify(dataPayload),
      token: localStorage.getItem("lumos_sftoken"),
      stepLabel: "Step1.3-Error-sf_add_offers",
    },
    function (result) {
      // console.log('Add Offers Response:', result);
      envConsoleLog('Add Offers Response:', result);

      var isValidJSON = false;

      try {
        JSON.parse(result);
        isValidJSON = true;
      } catch (error) {
        isValidJSON = false;
      }

      var resultObj = {};
      if(isValidJSON) {
        resultObj = JSON.parse(result);
      }

      if (result && isValidJSON && 'code' in resultObj) {

        if ('code' in resultObj && resultObj.code == "201") {
          sendNSTimer("Step1.3-sf_add_offers");
          getScheduledAppointmentSF();
        } else {
          sendNSError(
            "Step1.3-Error-sf_add_offers-APIError:" + result
          );
          // Error
          errorDisplaySF(0);
        }
      } else {
        sendNSError(
          "Step1.3-Error-sf_add_offers-APIError:" + result
        );
        // Error
        errorDisplaySF(0);
      }
    },
    function (request, status, error) {
      // Error
      errorDisplaySF(0);
    },
    ajaxurl_lumos
  );
}

function getScheduledAppointmentSF() {
  // Get Existing Scheduled Appointment

  $("#orderSubmitModal-sfapi .submission-indicator li")
    .eq(0)
    .removeClass("current");
  $("#orderSubmitModal-sfapi .submission-indicator li")
    .eq(0)
    .addClass("complete");
    $("#orderSubmitModal-sfapi .mobile-step-indicator li")
    .eq(0)
    .addClass("complete");
  $("#orderSubmitModal-sfapi .submission-indicator li")
    .eq(1)
    .addClass("current");

  var dataPayload = {
    orderID: localStorage.getItem("lumos_sforderid"),
  };

  $("#schedule-finding-dates-sfapi").removeClass("hide");

  ajaxCall(
    {
      action: "sf_get_scheduled_appointment",
      payload: dataPayload,
      token: localStorage.getItem("lumos_sftoken"),
      stepLabel: "Step2.1-Error-sf_get_scheduled_appointment",
    },
    function (result) {
      // console.log('Get Scheduled Appt Response:', result);
      envConsoleLog('Get Scheduled Appt Response:', result);
      var isValidJSON = false;

      try {
        JSON.parse(result);
        isValidJSON = true;
      } catch (error) {
        isValidJSON = false;
      }

      if (isValidJSON) {
        var resultObj = JSON.parse(result);
        if ("status" in resultObj || resultObj.TimeOfAppointment == null || resultObj.DateOfAppointment == null) {
          sendNSTimer("Step2.1-sf_get_scheduled_appointment");
        // if ("status" in resultObj) {
          // console.log('Get Schedule Error, wait and retry...');
          envConsoleLog('Get Schedule Error, wait and retry...');

          getScheduleRetries--;
          // console.log('Retries Left:', getScheduleRetries);
          envConsoleLog('Retries Left:', getScheduleRetries);

          if(getScheduleRetries >= 0) {
            sendNSTimer("Step2.1-sf_get_scheduled_appointment-RetriesLeft:" + getScheduleRetries);
            // try again in 4 second
            setTimeout(function () {
              getScheduledAppointmentSF();
            }, 4000);
          } else {
            sendNSError(
              "Step2.1-Error-sf_get_scheduled_appointment-OutOfRetries:" + result
            );
            // out of retries, show error
            errorDisplaySF(1);
          }
        } else {
          sendNSTimer("Step2.1-sf_get_scheduled_appointment");
          // preFetchTaxesSF();
          localStorage.setItem(
            "lumos_sfexistingappointmentid",
            resultObj.ServiceAppointmentId
          );

          default_TimeOfAppointment = resultObj.TimeOfAppointment;
          default_DateOfAppointment = resultObj.DateOfAppointment;

          getAvailableAppointmentSF();
        }
      } else {
        sendNSError(
          "Step2.1-Error-sf_get_scheduled_appointment-APIError: " + result
        );
        // Error
        errorDisplaySF(1);

        $("#schedule-finding-dates-sfapi").addClass("hide");
      }
    },
    function (request, status, error) {
      // Error
      errorDisplaySF(1);

      $("#schedule-finding-dates-sfapi").addClass("hide");
    },
    ajaxurl_lumos,
  );
}

function getAvailableAppointmentSF() {
  // Get Availabil Appointments
  var dataPayload = {
    orderID: localStorage.getItem("lumos_sforderid"),
    existingAppointmentID: localStorage.getItem(
      "lumos_sfexistingappointmentid"
    ),
  };

  ajaxCall(
    {
      action: "sf_get_available_appointments",
      payload: dataPayload,
      token: localStorage.getItem("lumos_sftoken"),
      stepLabel: "Step2.2-Error-sf_get_available_appointments",
    },
    function (result) {
      sendNSTimer("Step2.2-sf_get_available_appointments");

      // console.log('Get Available Appt Reponse:', result);
      envConsoleLog('Get Available Appt Reponse:', result);

      var isValidJSON = false;

      try {
        JSON.parse(result);
        isValidJSON = true;
      } catch (error) {
        isValidJSON = false;
      }

      if (isValidJSON) {
        var resultObj = JSON.parse(result);

        var appointments = resultObj.availableAppointments;

        var availableDates = [];

        $("#orderSubmitModal-sfapi .submission-indicator li")
          .eq(1)
          .removeClass("current");
        // $("#orderSubmitModal-sfapi .submission-indicator li")
        //   .eq(1)
        //   .addClass("alert-ns");
        $("#orderSubmitModal-sfapi .submission-indicator li")
          .eq(1)
          .addClass("step-active");

        $("#schedule-finding-dates-sfapi").addClass("hide");
        $("#schedule-installation-date-sfapi").addClass("hide");
        $("#submitOrderCollapseButton-sfapi").click();

        // Clear scheduling fields
        $("#ns-installation-date-sfapi").val("");
        $("#ns-installation-time-sfapi").val("");

        // Populate the dropdown with dates for the selected week
        var selectElement = $("#ns-installation-date-sfapi");
        selectElement.empty(); // Remove current options

        //available text
        selectElement.prepend(new Option("Available Dates", ""));

        var addedDates = []; // Array to store added dates

        for (var d = 0; d < appointments.length; d++) {
          var daysOfWeek = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
          var formatDate = new Date(appointments[d].appointmentDate);
          var formattedDate =
            (formatDate.getMonth() > 8
              ? formatDate.getMonth() + 1
              : "0" + (formatDate.getMonth() + 1)) +
            "/" +
            (formatDate.getDate() > 9
              ? formatDate.getDate()
              : "0" + formatDate.getDate()) +
            "/" +
            formatDate.getFullYear();

          // console.log(
          //   "formattedDate: " + formattedDate,
          //   formatDate,
          //   formatDate.getDay(),
          //   daysOfWeek[formatDate.getDay()]
          // );

          if (!Array.isArray(availableDates[formattedDate])) {
            availableDates[formattedDate] = [];
          }
          availableDates[formattedDate].push(appointments[d].appointmentTime);

          // Add an option to the select for this date, if it's not already added
          if (!addedDates.includes(formattedDate)) {
            selectElement.append(
              new Option(
                daysOfWeek[formatDate.getDay()] +
                  ", " +
                  formatDateToString(formatDate),
                formattedDate
              )
            );
            addedDates.push(formattedDate); // Add date to the addedDates array
          }
        }

        $("#schedule-installation-date-sfapi").removeClass("hide"); // unhide and then animate in to slide down from modal
        $("#submitOrderCollapseButton-sfapi").click();

        // console.log("Available Dates:", availableDates);
        envConsoleLog("Available Dates:", availableDates);

        // Set Available Times
        $("#ns-installation-date-sfapi").off("change"); // remove handler before reapplying
        $("#ns-installation-date-sfapi").change(function () {
          // Clear Available Times
          $("#ns-installation-time-sfapi").empty();
          $("#ns-installation-time-sfapi").append(
            new Option("Available Times", "")
          );

          // Clear schedule item in form
          $("#ns-schedule-item").val("");

          if ($(this).val() !== "") {
            $("#ns-installation-time-sfapi").parent().addClass("loading");
            $("#ns-installation-time-sfapi").prop("disabled", true);

            // console.log('date selected', $(this).val());
            // TODO: Get available times

            var selectedDate = $(this).val();
            // console.log("Selected Date/Time:", selectedDate,  );

            var cDateKey = selectedDate;

            if (availableDates[cDateKey]) {
              for (var t = 0; t < availableDates[cDateKey].length; t++) {
                $("#ns-installation-time-sfapi").append(
                  new Option(
                    availableDates[cDateKey][t],
                    availableDates[cDateKey][t]
                  )
                );
              }
            }

            $("#ns-installation-time-sfapi").parent().removeClass("loading");
            $("#ns-installation-time-sfapi").prop("disabled", false);
          } else {
            $("#ns-installation-time-sfapi").val("");
          }
        });

        // when the #ns-installation-date-sfapi is changed for the first time, remove .step-active and add .current to the next step
        $("#ns-installation-date-sfapi").one("change", function () {
          $("#orderSubmitModal-sfapi .submission-indicator li")
            .eq(1)
            .addClass("user-active");
        });
      } else {
        sendNSError(
          "Step2.2-Error-sf_get_available_appointments-APIError: " + result
        );

        // Error
        // $("#orderSubmitModal-sfapi .submission-indicator li").eq(1).removeClass('current')
        // $("#orderSubmitModal-sfapi .submission-indicator li").eq(1).addClass('error')
        // $('#submission-error-message-sfapi').removeClass('hide');

        $("#schedule-finding-dates-sfapi").addClass("hide");

        // Moving On
        var formatDate = new Date(default_DateOfAppointment);
        var formattedDate =
          (formatDate.getMonth() > 8
            ? formatDate.getMonth() + 1
            : "0" + (formatDate.getMonth() + 1)) +
          "/" +
          (formatDate.getDate() > 9
            ? formatDate.getDate()
            : "0" + formatDate.getDate()) +
          "/" +
          formatDate.getFullYear();

        setAvailableAppointmentSF(default_TimeOfAppointment, formattedDate);
        // getTaxesSF();
      }
    },
    function (request, status, error) {
      // Error
      $("#schedule-finding-dates-sfapi").addClass("hide");

      // Moving On
      var formatDate = new Date(default_DateOfAppointment);
      var formattedDate =
        (formatDate.getMonth() > 8
          ? formatDate.getMonth() + 1
          : "0" + (formatDate.getMonth() + 1)) +
        "/" +
        (formatDate.getDate() > 9
          ? formatDate.getDate()
          : "0" + formatDate.getDate()) +
        "/" +
        formatDate.getFullYear();

      setAvailableAppointmentSF(default_TimeOfAppointment, formattedDate);
    },
    ajaxurl_lumos,
  );
}

$("#ns-schedule-install-sfapi").submit(function (e) {
  e.preventDefault();

  var schedulingForm = document.querySelectorAll(
    "#ns-schedule-install-sfapi"
  )[0];

  if (
    !schedulingForm.checkValidity() ||
    $("form#ns-schedule-install .is-invalid").length
  ) {
    // Form Invalid
  } else {
    // Form Valid
    setAvailableAppointmentSF(
      $("#ns-installation-time-sfapi").val(),
      $("#ns-installation-date-sfapi").val()
    );
  }

  schedulingForm.classList.add("was-validated");
});

function setAvailableAppointmentSF(TimeOfAppointment, DateOfAppointment) {
  $('[data-processing-steps] [data-step="5"]').addClass("current");

  $("#orderSubmitModal-sfapi .submission-indicator li")
    .eq(1)
    .addClass("current");
  $("#orderSubmitModal-sfapi .submission-indicator li")
    .eq(1)
    .removeClass("alert-ns");
  $("#orderSubmitModal-sfapi .submission-indicator li")
    .eq(1)
    .addClass("step-active");

  $("#submitOrderCollapseButton-sfapi").click();
  // $("#schedule-installation-date-sfapi").addClass("hide");

  $("#orderSubmitModal-sfapi [data-scheduled-date]").text(
    DateOfAppointment + " at " + TimeOfAppointment
  );

  var dataPayload = {
    selectedDate: DateOfAppointment,
    selectedTime: TimeOfAppointment,
    orderId: localStorage.getItem("lumos_sforderid"),
    PreviousAppointmentId: localStorage.getItem(
      "lumos_sfexistingappointmentid"
    ),
  };

  ajaxCall(
    {
      action: "sf_set_available_appointment",
      payload: JSON.stringify(dataPayload),
      token: localStorage.getItem("lumos_sftoken"),
      stepLabel: "Step2.3-Error-sf_set_available_appointment",
    },
    function (result) {
      // console.log('Set Appt Response:', result);
      envConsoleLog('Set Appt Response:', result);

      var isValidJSON = false;

      try {
        JSON.parse(result);
        isValidJSON = true;
      } catch (error) {
        isValidJSON = false;
      }

      if (result && isValidJSON) {
        sendNSTimer("Step2.3-sf_set_available_appointment");
        pushGA4EcommData('scheudule_install');
        getTaxesSF();
      } else {
        sendNSError(
          "Step2.3-Error-sf_set_available_appointment-APIError:" + result
        );
        // Error
        errorDisplaySF(1);
      }
    },
    function (request, status, error) {
      // Error
      errorDisplaySF(1);
    },
    ajaxurl_lumos
  );
}

function getTaxesSF() {
  // console.log("get taxes");

  $("#orderSubmitModal-sfapi .submission-indicator li")
    .eq(1)
    .removeClass("current");
    $("#orderSubmitModal-sfapi .submission-indicator li")
    .eq(1)
    .removeClass("user-active");
  $("#orderSubmitModal-sfapi .submission-indicator li")
    .eq(1)
    .removeClass("step-active");
  $("#orderSubmitModal-sfapi .submission-indicator li")
    .eq(1)
    .addClass("complete");
  $("#orderSubmitModal-sfapi .mobile-step-indicator li")
    .eq(1)
    .addClass("complete");


  $("#orderSubmitModal-sfapi .submission-indicator li")
    .eq(2)
    .addClass("current");

  ajaxCall(
    {
      action: "sf_get_taxes",
      payload: {
        orderID: localStorage.getItem("lumos_sforderid"),
      },
      token: localStorage.getItem("lumos_sftoken"),
      stepLabel: "Step3.1-Error-sf_get_taxes",
    },
    function (result) {
      // console.log('Get Taxes Response:', result);
      envConsoleLog('Get Taxes Response:', result);

      var isValidJSON = false;

      try {
        JSON.parse(result);
        isValidJSON = true;
      } catch (error) {
        isValidJSON = false;
      }

      var resultObj = {};
      if(isValidJSON) {
        resultObj = JSON.parse(result);
      }

      if (result && isValidJSON) {
        if (
          ('errorCode' in resultObj && resultObj.errorCode == '409') || // Looking for the errorCode
          ('code' in resultObj && (resultObj.code == '409')) || // Looking for code (of any kind)
          (resultObj.length && resultObj[0].taxVerified !== true)
        ) {
          // console.log('Get Taxes Error, wait and retry...');
          envConsoleLog('Get Taxes Error, wait and retry...');

          getTaxesRetries--;
          // console.log('Retries Left:', getTaxesRetries);
          if(getTaxesRetries >= 0) {
            sendNSTimer("Step3.1-sf_get_taxes-RetriesLeft:" + getTaxesRetries);
            // try again in 4 seconds
            setTimeout(function () {
              getTaxesSF();
            }, 4000);
          } else {
            sendNSError(
              "Step3.1-Error-sf_get_taxes-OutOfRetries:" + result
            );
            // out of retries, show error
            errorDisplaySF(2);
          }

        } else {
          sendNSTimer("Step3.1-sf_get_taxes");

          var orderTotal = 0;
          var taxTotal = 0;

          // Clear price/tax rows
          $("#order-price-totals [data-products] tbody [data-price-row]:not(.hide), #order-price-totals [data-taxes] tbody [data-tax-row]:not(.hide)").each(function() {
            $(this).remove();
          });

          resultObj.forEach(function (value) {
            if (value.productName) {
              var $priceRow = $(
                "#order-price-totals [data-price-row].hide"
              ).clone();

              $priceRow.find("th").text(value.productName);
              $priceRow.find("td").text(value.Amount);
              $priceRow.removeClass("hide");

              $("#order-price-totals [data-products] tbody").append($priceRow);

              orderTotal += Number(value.Amount.replace(/[^0-9.-]+/g, ""));

              if (value.TaxInfo) {
                value.TaxInfo.forEach(function (value2) {
                  var $taxRow = $(
                    "#order-price-totals [data-tax-row].hide"
                  ).clone();

                  $taxRow
                    .find("th")
                    .text(value2.TaxDescription + " (" + value2.TaxLevel + ")");
                  $taxRow.find("td").text(value2.Amount);
                  $taxRow.removeClass("hide");

                  $("#order-price-totals [data-taxes] tbody").append($taxRow);

                  taxTotal += Number(value2.Amount.replace(/[^0-9.-]+/g, ""));
                  orderTotal += Number(value2.Amount.replace(/[^0-9.-]+/g, ""));
                });
              }
            }
          });

          // Hide if no taxes
          if (taxTotal <= 0) {
            $("#order-price-totals [data-taxes]").prev().addClass("hide");
            $("#order-price-totals [data-taxes]").addClass("hide");
          }

          // Fix wonky JS totaling
          orderTotal = Math.round(orderTotal * 100) / 100;

          $("#order-price-totals [data-total]").text(
            "$" + orderTotal.toFixed(2)
          );

          $("#order-price-totals, .order-price-info").removeClass("hide");
          $("#order-scheduled-date").removeClass("hide");

          initPaymentSF();
        }
      } else {
        sendNSError(
          "Step3.1-Error-sf_get_taxes-APIError:" + result
        );
        // error
        errorDisplaySF(2);
      }
    },
    function (request, status, error) {
      // error
      errorDisplaySF(2);
    },
    ajaxurl_lumos
  );
}

function initPaymentSF() {
  $("#orderSubmitModal-sfapi .submission-indicator li")
    .eq(2)
    .removeClass("current");
  $("#orderSubmitModal-sfapi .submission-indicator li")
    .eq(2)
    .addClass("alert-ns");

  $("#order-payment-sfapi").removeClass("hide");

  // Unregister handler for CC if it exists
  if (fundingAccountGatewayHandler_CC) {
    fundingAccountGatewayHandler_CC.then((handler) => {
      // console.log(handler);
      handler.unregister();
      // console.log("unregistered", handler);
      $("#payment-tabs [data-content-for]").empty();
    });
  }

  // Unregister handler for ACH if it exists
  if (fundingAccountGatewayHandler_ACH) {
    fundingAccountGatewayHandler_ACH.then((handler) => {
      // console.log(handler);
      handler.unregister();
      // console.log("unregistered", handler);
      $("#payment-tabs [data-content-for]").empty();
    });
  }

  // Init Credit Card Form as Default
  initPaymentSF_cc();
}

function initPaymentSF_cc() {
  $("#order-payment-sfapi .nav input").prop("disabled", true);

  // Unregister handler for ACH if it exists
  if (fundingAccountGatewayHandler_ACH) {
    fundingAccountGatewayHandler_ACH.then((handler) => {
      // console.log(handler);
      handler.unregister();
      // console.log("unregistered", handler);
      $("#payment-tabs [data-content-for]").empty();
    });
  }
  if (typeof aci === 'undefined') {
    console.error('ACI object is not defined. There may have been an issue loading speedpay.js.');
    $(".payment-selection").replaceWith(
      '<div><strong class="d-block">Our payment system is unavailable at this moment.</strong> Please try again later.</div>'
    );
  } else {

    ajaxCall(
      {
        customer_segment: localStorage.getItem("lumos_address_market"),
        stepLabel: "Step3.x-Error-get_creditcard_form",
      },
      function (response) {
        $('#payment-tabs [data-content-for="cc"]').append(response);

        $('#order-payment-sfapi input[type="submit"]').prop("disabled", true);

        // Set Payment Region
        $(
          '#order-payment-form-sfapi-cc [data-aci-speedpay="account-region-code"]'
        ).val(localStorage.getItem("lumos_address_state"));
        $(
          '#order-payment-form-sfapi-cc [data-aci-speedpay="account-postal-code"]'
        ).val(localStorage.getItem("lumos_address_zip"));

        var dataPayload = {
          action: "sf_init_payment",
          paymentMethod: "Card",
          stepLabel: "Step3.2-Error-sf_init_payment(CC)",
        };

        ajaxCall(
          dataPayload,
          function (result, testStatus, xhr) {
            sendNSTimer("Step3.2-sf_init_payment(cc)");
            let paymentInit = JSON.parse(result);
            // console.log(paymentInit);
            fundingAccountGatewayHandler_CC =
              aci.speedpay.fundingAccountGateway.init(paymentInit);
            fundingAccountGatewayHandler_CC.then((handler) => {
              $("#order-payment-sfapi .nav input").prop("disabled", false);
              $('#order-payment-sfapi input[type="submit"]').prop(
                "disabled",
                false
              );
            });

            $("#funding-account-id-cc").val(paymentInit.billerAccountId);

            $("#order-payment-form-sfapi-cc").on("submit", function (event) {
              event.preventDefault();
              event.stopPropagation();

              $('#order-payment-sfapi input[type="submit"]').prop(
                "disabled",
                true
              );

              // console.log("Submit Card", fundingAccountGatewayHandler_CC);
              // console.log("Submit Card...");
              envConsoleLog("Submit Card...");

              fundingAccountGatewayHandler_CC.then((handler) => {
                handler
                  .createToken()
                  .then((data) => {
                    // Send Card Data
                    // console.log(data);
                    envConsoleLog('Card Data:', data);
                    let formError = document.getElementById("form-error-cc");
                    formError.classList.add("hide");
                    pushGA4EcommData('payment_cc');
                    sendPaymentInformationSF(
                      data.token.id,
                      "CreditCard",
                      $("#funding-account-id-cc").val(),
                      data.token.truncatedCardNumber,
                      data.token.expirationDate
                    );
                  })
                  .catch((error) => {
                    // Display Error
                    // console.log(error);
                    envConsoleLog('Error:', error);
                    let formError = document.getElementById("form-error-cc");
                    formError.innerHTML = error.message.default;
                    formError.classList.remove("hide");
                    $('#order-payment-sfapi input[type="submit"]').prop(
                      "disabled",
                      false
                    );
                  });
              });

              return false;
            });
          },
          function (request, status, error) {
            // error
            errorDisplaySF(2);
          },
          ajaxurl_lumos,
        );
      },
      null,
      "/wp-content/themes/lumos-tidewater/parts/ecommtemplates/content-order-creditcard-form.php"
    );
  }
}

function initPaymentSF_ach() {
  $("#order-payment-sfapi .nav input").prop("disabled", true);

  // Unregister handler for CC if it exists
  if (fundingAccountGatewayHandler_CC) {
    fundingAccountGatewayHandler_CC.then((handler) => {
      // console.log(handler);
      handler.unregister();
      // console.log("unregistered", handler);
      $("#payment-tabs [data-content-for]").empty();
    });
  }
  if (typeof aci === 'undefined') {
    console.error('ACI object is not defined. There may have been an issue loading speedpay.js.');
    $(".payment-selection").replaceWith(
      '<div><strong class="d-block">Our payment system is unavailable at this moment.</strong> Please try again later.</div>'
    );
  } else {

    ajaxCall(
      {
        customer_segment: localStorage.getItem("lumos_address_market"),
        stepLabel: "Step3.x-Error-get_ach_form",
      },
      function (response) {
        $('#payment-tabs [data-content-for="ach"]').append(response);

        $('#order-payment-sfapi input[type="submit"]').prop("disabled", true);

        // Set Payment Region
        $(
          '#order-payment-form-sfapi-ach [data-aci-speedpay="account-region-code"]'
        ).val(localStorage.getItem("lumos_address_state"));
        $(
          '#order-payment-form-sfapi-ach [data-aci-speedpay="account-postal-code"]'
        ).val(localStorage.getItem("lumos_address_zip"));

        var dataPayload = {
          action: "sf_init_payment",
          paymentMethod: "ACH",
          stepLabel: "Step3.2-Error-sf_init_payment(ACH)",
        };

        ajaxCall(
          dataPayload,
          function (result, testStatus, xhr) {
            sendNSTimer("Step3.2-sf_init_payment(ACH)");
            let paymentInit = JSON.parse(result);
            // console.log(paymentInit);
            fundingAccountGatewayHandler_ACH =
              aci.speedpay.fundingAccountGateway.init(paymentInit);
            fundingAccountGatewayHandler_ACH.then((handler) => {
              $("#order-payment-sfapi .nav input").prop("disabled", false);
              $('#order-payment-sfapi input[type="submit"]').prop(
                "disabled",
                false
              );
            });

            $("#funding-account-id-ach").val(paymentInit.billerAccountId);

            $("#order-payment-form-sfapi-ach").on("submit", function (event) {
              event.preventDefault();
              event.stopPropagation();

              $('#order-payment-sfapi input[type="submit"]').prop(
                "disabled",
                true
              );

              // console.log("Submit ACH", fundingAccountGatewayHandler_ACH);
              // console.log("Submit ACH...");
              envConsoleLog("Submit ACH...");

              fundingAccountGatewayHandler_ACH.then((handler) => {
                handler
                  .createToken()
                  .then((data) => {
                    // Send Card Data
                    // console.log(data);
                    envConsoleLog('ACH Data:', data);
                    let formError = document.getElementById("form-error-ach");
                    formError.classList.add("hide");
                    pushGA4EcommData('payment_ach');
                    sendPaymentInformationSF(
                      data.token.id,
                      "ACH",
                      $("#funding-account-id-ach").val(),
                      data.token.truncatedDda,
                      null
                    );
                  })
                  .catch((error) => {
                    // Display Error
                    // console.log(error);
                    envConsoleLog('Error:', error);
                    let formError = document.getElementById("form-error-ach");
                    formError.innerHTML = error.message.default;
                    formError.classList.remove("hide");
                    $('#order-payment-sfapi input[type="submit"]').prop(
                      "disabled",
                      false
                    );
                  });
              });

              return false;
            });
          },
          function (request, status, error) {
            // error
            errorDisplaySF(2);
          },
          ajaxurl_lumos,
        );
      },
      null,
      "/wp-content/themes/lumos-tidewater/parts/ecommtemplates/content-order-ach-form.php",
    );
  }
}

function sendPaymentInformationSF(
  fundingToken,
  paymentMethod,
  fundingAccountId,
  lastfour,
  expiration
) {
  $("#order-price-totals, .order-price-info").addClass("hide");
  $("#order-scheduled-date").addClass("hide");
  $("#order-payment-sfapi").addClass("hide");

  $("#orderSubmitModal-sfapi .submission-indicator li")
    .eq(2)
    .removeClass("alert-ns");
  $("#orderSubmitModal-sfapi .submission-indicator li")
    .eq(2)
    .addClass("current");

  // console.log(
  //   fundingToken,
  //   paymentMethod,
  //   fundingAccountId,
  //   lastfour,
  //   expiration
  // );
  envConsoleLog(
    fundingToken,
    paymentMethod,
    fundingAccountId,
    lastfour,
    expiration
  );

  var dataPayload = {
    orderId: localStorage.getItem("lumos_sforderid"),
    fundingToken: fundingToken,
    fundingAccountId: fundingAccountId,
    paymentMethod: paymentMethod,
    last4Digits: lastfour,
    cardExpirationDate: expiration,
  };

  // console.log('Sending Pmt Payload...');
  // console.log('Send Pmt Payload:', dataPayload);

  ajaxCall(
    {
      action: "sf_send_payment_information",
      payload: JSON.stringify(dataPayload),
      token: localStorage.getItem("lumos_sftoken"),
      stepLabel: "Step3.3-Error-sf_send_payment_information",
    },
    function (result, testStatus, xhr) {
      // console.log('Send Pmt Response:', result);
      envConsoleLog('Send Pmt Response:', result);

      var isValidJSON = false;

      try {
        JSON.parse(result);
        isValidJSON = true;
      } catch (error) {
        isValidJSON = false;
      }

      var resultObj = {};
      if(isValidJSON) {
        resultObj = JSON.parse(result);
      }

      if (result && isValidJSON) {
        // OLD: Indicates taxes are still being calculated, retry payment in 4 seconds
        // NEW: Indicates payment error, unhide payment form and allow to try again
        if ('errorCode' in resultObj && resultObj.errorCode == 409) {
          sendNSError(
            "Step3.3-Error-sf_send_payment_information-APIError:" + result
          );

          // console.log('Payment Error, wait and retry...');
          //
          // sendPaymentRetries--;
          // console.log('Retries Left:', sendPaymentRetries);
          // if(sendPaymentRetries >= 0) {
          //   // try again in 4 seconds
          //   setTimeout(function() {
          //     sendPaymentInformationSF(fundingToken,paymentMethod,fundingAccountId,lastfour,expiration)
          //   }, 2000); // Wait 2 seconds
          // } else {
          //   // out of retries, show error
          //   errorDisplaySF(2);
          // }

          // console.log('Payment Error, return to payment form.');
          envConsoleLog('Payment Error, return to payment form.');

          // Unhide totals and payment entry
          $("#order-price-totals, .order-price-info").removeClass("hide");
          $("#order-payment-sfapi").removeClass("hide");

          var paymentErrorMessage = '<p class="m-0"><strong>We encountered an error processing your payment.</strong> Please confirm your payment information below and try again. <br><br>If you require further assistance, please contact customer support at <a href="tel:3368863600">336.886.3600</a>.</p>';

          // Display error message
          if($('#form-error-cc').length) {
            $('#form-error-cc').html(paymentErrorMessage);
            $('#form-error-cc').removeClass('hide');
          } else if($('#form-error-ach').length) {
            $('#form-error-ach').html(paymentErrorMessage);
            $('#form-error-ach').removeClass('hide');
          }

          // release payment submit button
          $('#order-payment-sfapi input[type="submit"]').prop(
            "disabled",
            false
          );

        } else if ('statusCode' in resultObj && resultObj.statusCode == 201) {
          sendNSTimer("Step3.3-sf_send_payment_information");
          // Set Order ID for confirmation screen
          // orderserviceid = resultObj.Summary.Order.replace(/\D/g, "");
          orderserviceid = localStorage.getItem("lumos_sfordernumber");
          // console.log('Order Complete!');
          envConsoleLog('Order Complete!');

          completeorderSF();
        } else {
          sendNSError(
            "Step3.3-Error-sf_send_payment_information-APIError:" + result
          );
          errorDisplaySF(2);
        }
      } else {
        sendNSError(
          "Step3.3-Error-sf_send_payment_information-APIError:" + result
        );
        // Error
        errorDisplaySF(2);
      }
    },
    function (request, status, error) {
      // Error
      errorDisplaySF(2);
    },
    ajaxurl_lumos
  );
}

// Displays an error on the provided step
function errorDisplaySF(step) {
  // Error
  $("#orderSubmitModal-sfapi .submission-indicator li")
    .eq(step)
    .removeClass("current");
  $("#orderSubmitModal-sfapi .submission-indicator li")
    .eq(step)
    .addClass("error");
  $("#submission-error-message-sfapi").removeClass("hide");
  stopOrderTimer();
}

function completeorderSF() {
  isProcessingOrder = false;

  $("#orderSubmitModal-sfapi .submission-indicator li")
    .eq(2)
    .removeClass("current");
  $("#orderSubmitModal-sfapi .submission-indicator li")
    .eq(2)
    .addClass("complete");
  $("#orderSubmitModal-sfapi .submission-indicator li")
    .eq(3)
    .addClass("complete");
    $("#orderSubmitModal-sfapi .mobile-step-indicator li")
    .eq(2)
    .addClass("complete");
    $("#orderSubmitModal-sfapi .mobile-step-indicator li")
    .eq(3)
    .addClass("complete");

  localStorage.removeItem("lumos_sftoken");
  localStorage.removeItem("lumos_sforderid");
  localStorage.removeItem("lumos_sfordernumber");
  localStorage.removeItem("lumos_sfexistingappointmentid");

  orderStreet = localStorage.getItem("lumos_address_street");
  orderCity = localStorage.getItem("lumos_address_city");
  orderState = localStorage.getItem("lumos_address_state");
  orderZIP = localStorage.getItem("lumos_address_zip");

  clearAddressSelection();

  finalizeOrder();
}

function submitOrderCapture() {
  var $ = jQuery;

  orderStreet = localStorage.getItem("lumos_address_street");
  orderCity = localStorage.getItem("lumos_address_city");
  orderState = localStorage.getItem("lumos_address_state");
  orderZIP = localStorage.getItem("lumos_address_zip");

  sendNSPopupConversion();

  isProcessingOrder = true;
  clearTimeout(closerTimer);
  closerTimer = null;
  $("#orderSubmitModal-nonapi [data-order-processing]").removeClass("hide");
  $("#orderSubmitModal-nonapi [data-order-error]").addClass("hide");

  $orderModal_NonAPI.modal("show");

  var submitFormAction = "nonapi_submit_order";

  // console.log(submitFormAction);

  var form_data = [],
    form_product_selections = "",
    form_product_total = 0,
    feature_stash = $.parseJSON(
      localStorage.getItem(cookieLabel_product_selection)
    );

  // console.log("Feature Stash: ", feature_stash.product_feature_selection);

  for (var i = 0; i < feature_stash.product_feature_selection.length; i++) {

    // if price is null set to 0
    if (feature_stash.product_feature_selection[i].product_feature_price === null) {
      feature_stash.product_feature_selection[i].product_feature_price = 0;
    }

    form_product_selections +=
      "[" +
      feature_stash.product_feature_selection[i].product_feature_qty +
      "] " +
      feature_stash.product_feature_selection[i].product_feature_name +
      " : $" +
      feature_stash.product_feature_selection[i].product_feature_price.toFixed(
        2
      ) +
      "\n";
    form_product_total +=
      feature_stash.product_feature_selection[i].product_feature_price;
  }

  // Add Telephone order notes
  if ($("#feature_30_1").prop("checked")) {
    form_product_selections += "\n";

    if ($("#transfer_number_yes").prop("checked")) {
      form_product_selections +=
        "Customer would like to transfer a number from another carrier. \n";
      form_product_selections +=
        "Phone Number: " +
        $("#transfer_number_phone").val() +
        "\nCarrier: " +
        $("#transfer_number_carrier").val() +
        "\nCurrent Provider Account Number: " +
        $("#transfer_number_account").val() +
        "\n";
    }

    if (
      $("#transfer_number_message").length &&
      $("#transfer_number_message").val().length
    ) {
      form_product_selections +=
        "\nCustomer Comments: " + $("#transfer_number_message").val() + "\n";
    }
  }

  if ($("#address_service_billing_diff").prop("checked")) {
    var billAddress =
      $("#address_service_billing_different_city").val() +
      " " +
      $("#address_service_billing_different_zip").val();

    if ($("#address_service_billing_physical").prop("checked")) {
      var aptNumber = "";
      if ($("#address_service_billing_different_apartment").val().length) {
        aptNumber = $("#address_service_billing_different_apartment").val();
      }
      billAddress =
        $("#address_service_billing_different_street_number").val() +
        " " +
        $("#address_service_billing_different_street_name").val() +
        " " +
        aptNumber +
        " " +
        billAddress;
    } else {
      billAddress =
        "PO Box " +
        $("#address_service_billing_different_pobox").val() +
        " " +
        billAddress;
    }

    form_product_selections +=
      "\nCustomer specified a different billing address: \n\n" +
      billAddress +
      "\n";
  }

  if ($("#transaction-sms-opt-in").prop("checked")) {
    form_product_selections +=
      "\n[✓]Opt-In: Customer would like to receive text messages for scheduling or service-related updates.\n";
    form_product_selections +=
      "Contact Phone: " + $("#account_service_contact_phone").val() + "\n";
  }
  if ($("#promotion-sms-opt-in").prop("checked")) {
    form_product_selections +=
      "\n[✓]Opt-In: Customer would like to receive text messages for marketing updates.\n";
    form_product_selections +=
      "Contact Phone: " + $("#account_service_contact_phone").val() + "\n";
  }
  form_product_selections +=
    "\nRequested Installation Date: " +
    $("#ns-installation-date-nonapi").val() +
    " - " +
    $("#ns-installation-time-nonapi").val() +
    "\n";

  if ($("#ns-installation-instructions-nonapi").val()) {
    form_product_selections +=
      "\nSpecial Instructions: " +
      $("#ns-installation-instructions-nonapi").val() +
      "\n";
  }

  if ($("#sms-carrier-select").val() == "Other") {
    form_product_selections +=
      "\nSMS Carrier: " +
      $("#sms-carrier-select").val() +
      " - " +
      $("#other-carrier").val() +
      "\n";
  } else {
    form_product_selections +=
      "\nSMS Carrier: " + $("#sms-carrier-select").val() + "\n";
  }
  form_product_selections +=
    "\nService PIN: " + $("#account_service_pin_va").val() + "\n";

    form_product_selections +=
      "\nCustomer would like to receive a paper bill: " + $("[data-paperless-bill-seletion]").prop("checked") + "\n";

  // console.log("Form Product Selections: ", form_product_selections);

  form_data = [
    {
      // Full Name
      id: "input_1",
      value:
        $("#account_service_first_name").val() +
        " " +
        $("#account_service_last_name").val(),
    },
    {
      // First Name
      id: "input_12",
      value: $("#account_service_first_name").val(),
    },
    {
      // Last Name
      id: "input_13",
      value: $("#account_service_last_name").val(),
    },
    {
      // Contact Number
      id: "input_2",
      value: $("#account_service_contact_phone").val(),
    },
    {
      // Email Address
      id: "input_4",
      value: $("#account_service_contact_email").val(),
    },
    {
      // Service Address
      id: "input_6",
      value: $("#account_service_geocoded_visible").val(),
    },
    {
      // Service Selections
      id: "input_10",
      value: form_product_selections,
    },
    {
      // Service Total
      id: "input_11",
      value: $('[data-total-price]').text(),
    },
    {
      // Referral Code
      id: "input_14",
      value: $("#account_service_agent_id").val(),
    },
  ];

  ajaxCall(
    {
      action: submitFormAction,
      form_data: JSON.stringify(form_data),
      stepLabel: "Step4-Error-submit_order_capture",
    },
    function (result) {
      // console.log(result);

      if (result == "true") {
        // GTM Submission
        // var gtmDLProducts = [];
        // var productSelections = $.parseJSON(localStorage.getItem(cookieLabel_product_selection));
        // for (var i = 0; i < productSelections.product_feature_selection.length; i++) {
        //   if (productSelections.product_feature_selection[i].product_feature_checked) {
        //     if(productSelections.product_feature_selection[i].product_feature_price !== 0) { // Exclude $0 products
        //       gtmDLProducts.push(
        //         {
        //           'name': productSelections.product_feature_selection[i].product_feature_name.replace(/^\s+|\s+$/g, '').replace(/(<([^>]+)>)/gi, ""),
        //           'sku': productSelections.product_feature_selection[i].product_feature_id,
        //           'price': productSelections.product_feature_selection[i].product_feature_price,
        //           'quantity': productSelections.product_feature_selection[i].product_feature_qty,
        //         }
        //       );
        //     }
        //   }
        // }
        //
        // var gtmDL = {
        //   'event': 'nsPurchase', // Residential - eCommerce - Order Captured
        //   'transactionId': new Date().toISOString(),
        //   'transactionTotal': parseFloat($('[data-total-price]').text()),
        //   'transactionTax': parseFloat($('[data-fee-total]').text()),
        //   'transactionProducts': gtmDLProducts
        // };
        //
        // // console.log('dataLayer Data:', gtmDL);
        // 
        // window.dataLayer.push(gtmDL);

        isProcessingOrder = false;
        setSalesforcePartialContact(true, 'add');
        setSalesforcePartialContact(true, 'update');

        clearAddressSelection();

        finalizeOrder();
      } else {
        // Show error state
        $("#orderSubmitModal-nonapi [data-order-processing]").addClass("hide");
        $("#orderSubmitModal-nonapi [data-order-error]").removeClass("hide");
      }
    },
  );
}

// **
// * Create an Account with supplied customer info
// **
function createAccount() {
  var $ = jQuery;

  // logNSEvent("ecomm - order processing - Creating Account (Processing Step 1)");

  isProcessingOrder = true;

  $("#orderSubmitModal .submission-indicator li, #orderSubmitModal .mobile-step-indicator li").each(function () {
    $(this).removeClass("current");
    $(this).removeClass("error");
    $(this).removeClass("alert-ns");
    $(this).removeClass("step-active");
    $(this).removeClass("user-active");
    $(this).removeClass("complete");
  });

  $("#termsconditions, #termsconditions-mobile").prop("disabled", true);
  $('.order-step[data-order-step="3"] button').prop("disabled", true);
  $(".close-reveal-modal").addClass("hide");

  $("#submission_message").text("");
  $("#submission_message").addClass("hide");

  $("#submission_error_message").addClass("hide");

  // open modal
  $orderModal.modal("show");

  $("#orderSubmitModal .progress-order").removeClass("error");

  // $('#submission_message').text('Step 1 of 3: Creating Your Account');

  $("#orderSubmitModal .submission-indicator li").eq(0).addClass("current");

  $("#orderSubmitModal .progress-order").attr("data-percent", "25");

  var statementDelivery = "Letters";
  if ($("input[data-paperless-bill-seletion]").prop("checked")) {
    statementDelivery = "Electronic";
  }

  var optIn = $("#transaction-sms-opt-in").prop("checked"); // SMS opt out currently being set for transactional opt in only
  var smsOptOutDate = null;

  // Only set optout if element is not checked
  if (!optIn) {
    // From Docs: string SmsOptOutDate - (yyyy-mm-dd hh:mm:ss) - If a date is set, the customer has opted out of SMS communication.
    smsOptOutDate = new Date().toISOString().replace("T", " ").slice(0, 19);
  }

  usernameCreated = $("#account_service_email_address").val();
  passwordCreated = $("#account_service_password").val();

  var accountAPIData = {
    action: "add_account",

    StatementDelivery: statementDelivery,

    username: $("#account_service_email_address").val(),
    password: $("#account_service_password").val(),

    security_pin: $("#account_service_pin").val(),
    security_question: $("#account_service_security_question").val(),
    security_answer: $("#account_service_security_answer").val(),

    name_full: $("#service_account_final").text(),
    name_prefix: "", //$('#account_service_prefix').val(),
    name_first: $("#account_service_first_name").val(),
    name_middle: "", //$('#account_service_middle_name').val(),
    name_last: $("#account_service_last_name").val(),
    name_suffix: "", //$('#account_service_suffix').val(),

    email_address: $("#account_service_contact_email").val(),

    // ssn: $('#address_service_ssn').val(),
    ssn: "",

    address_full: $("#account_service_geocoded").val(),
    address_house_number: localStorage.getItem("lumos_address_house_num"),
    address_apt_number: localStorage.getItem("lumos_address_apt_num"),
    address_po_box: "",

    address_street_id: localStorage.getItem("lumos_address_street_id"),
    address_city_id: localStorage.getItem("lumos_address_city_id"),
    address_state_id: localStorage.getItem("lumos_address_state_id"),
    address_zip: localStorage.getItem("lumos_address_zip"),

    // billing_address_full: ($('#account_service_geocoded').val() !== $('#service_billing_final').text()) ? $('#service_billing_final').text() : '',
    // billing_address_house_number: $('#address_service_billing_different_street_number').val(),
    // billing_address_apt_number: $('#address_service_billing_different_apartment').val(),
    // billing_address_po_box: $('#address_service_billing_different_pobox').val(),

    // billing_address_street_id: $('#address_service_billing_different_street_name_id').val(),
    // billing_address_city_id: $('#address_service_billing_different_city_id').val(),
    // billing_address_state_id: $('#address_service_billing_different_state_id').val(),
    // billing_address_zip: $('#address_service_billing_different_zip').val(),

    address_phone: $("#account_service_contact_phone").val(),
    address_phone_ext: "", //$('#account_service_contact_phone_ext').val(),
    address_phone_alt: "", //$('#account_service_alt_phone').val(),
    address_phone_alt_ext: "", //$('#account_service_alt_phone_ext').val(),

    service_address_id: localStorage.getItem("lumos_address_id"),

    sms_opt_out_date: smsOptOutDate,
  };

  // set billing address if possible
  if ($("#address_service_billing_diff").prop("checked")) {
    if (
      !$("#address_service_billing_different_street_name_id").val() ||
      $("#address_service_billing_different_street_name_id").val() == 0 ||
      !$("#address_service_billing_different_city_id").val() ||
      $("#address_service_billing_different_city_id").val() == 0 ||
      !$("#address_service_billing_different_state_id").val() ||
      $("#address_service_billing_different_state_id").val() == 0
    ) {
      // Set flag for missing location ids in the billing address
      sessionStorage.setItem("lumos_missing_billing_ids", 1);
    } else {
      // Remove flag for missing location ids
      if (sessionStorage.getItem("lumos_missing_billing_ids")) {
        sessionStorage.removeItem("lumos_missing_billing_ids");
      }
      accountAPIData.billing_address_full =
        $("#account_service_geocoded").val() !==
        $("#service_billing_final").text()
          ? $("#service_billing_final").text()
          : "";
      accountAPIData.billing_address_house_number = $(
        "#address_service_billing_different_street_number"
      ).val();
      accountAPIData.billing_address_apt_number = $(
        "#address_service_billing_different_apartment"
      ).val();
      accountAPIData.billing_address_po_box = $(
        "#address_service_billing_different_pobox"
      ).val();

      accountAPIData.billing_address_street_id = $(
        "#address_service_billing_different_street_name_id"
      ).val();
      accountAPIData.billing_address_city_id = $(
        "#address_service_billing_different_city_id"
      ).val();
      accountAPIData.billing_address_state_id = $(
        "#address_service_billing_different_state_id"
      ).val();

      accountAPIData.billing_address_zip = $(
        "#address_service_billing_different_zip"
      ).val();
    }
  }

  accountAPIData.stepLabel = "Step1.1-Error-add_account";

  ajaxCall(
    accountAPIData,
    function (result) {
      // NS GTM Timer End
      var response = $.parseJSON(result);

      // console.log('Success', response, result);
      // console.log(response.Status, response.Entity, response);

      if (response.Status === "success") {
        sendNSTimer("Step1.1-add_account");

        $("#orderSubmitModal .progress-order").attr("data-percent", "75");
        // $('#submission_message').text('Step 2 of 3: Submitting Your Order');

        // $('.submission-indicator li').eq(0).addClass('complete');
        // $('.submission-indicator li').eq(1).addClass('current');

        // createServiceRequest(response.Data.AccountID);

        var newAccountID = response.Data.AccountID;

        ajaxCall(
          {
            action: "ns_login",
            username: $("#account_service_email_address").val(),
            password: $("#account_service_password").val(),
          },
          function (result) {
            // NS GTM Timer End
            var response = $.parseJSON(result);
            if (response.Status === "success") {
              sendNSTimer("Step1.2-ns_login");

              $("#orderSubmitModal .submission-indicator li")
                .eq(0)
                .addClass("complete");
                $("#orderSubmitModal .mobile-step-indicator li")
                .eq(0)
                .addClass("complete");
              $("#orderSubmitModal .submission-indicator li")
                .eq(1)
                .addClass("current");

              // tokenExpiry = response.Data.Expires;
              // let tokenExpiryDate = new Date(tokenExpiry);
              // tokenExpiry = tokenExpiryDate.toISOString();
              var date = new Date();
              var timestamp = date.getTime();
              ns_ecomm_session_id_name = "ns_ecomm_session_id_" + timestamp;
              localStorage.setItem(
                ns_ecomm_session_id_name,
                response.Data.SessionId
              );

              // runCreditCheck(newAccountID);
              createServiceRequest(newAccountID);
            } else {
              sendNSError(
                "Step1.2 Error-ns_login-APIError: " +
                  response.Message
              );
              // stopNSTimer();

              // logNSEvent("ecomm - order processing - ERROR: Creating Account: Unable To Login New User (Processing Step 1)");
              $("#submission_error_message").html(
                "We encountered an error: <strong>" +
                  response.Message +
                  "</strong>. <br /> <br />Please contact our customer support at <strong>" + getSupportNumber() + "</strong>"
              );
              $("#submission_error_message").removeClass("hide");
            }
          },
          function (request, status, error) {

            $("#orderSubmitModal .submission-indicator li")
              .eq(0)
              .addClass("error");

            // $('#submission_message').html('We encountered an error. Please try again later or you may contact our customer support at <strong>866.542.5900</strong>');

            $("#submission_error_message").html(
              "We encountered an error. Please try again later or you may contact our customer support at <strong>" + getSupportNumber() + "</strong>"
            );
            $("#submission_error_message").removeClass("hide");

            $("#termsconditions, #termsconditions-mobile").prop("disabled", false);
            $('.order-step[data-order-step="3"] button').prop(
              "disabled",
              false
            );
            $(".close-reveal-modal").removeClass("hide");
          },
        );
      } else {
        sendNSError(
          "Step1.1-Error-add_account-APIError:" +
            response.Message
        );

        // stopNSTimer();

        // logNSEvent("ecomm - order processing - Error: Creating Account (Processing Step 1)");

        $("#orderSubmitModal .progress-order").attr("data-percent", "100");
        $("#orderSubmitModal .progress-order").addClass("error");

        $("#orderSubmitModal .submission-indicator li").eq(0).addClass("error");

        $("#termsconditions, #termsconditions-mobile").prop("disabled", false);
        $('.order-step[data-order-step="3"] button').prop("disabled", false);
        $(".close-reveal-modal").removeClass("hide");

        if (response.Message === "User exists") {
          // logNSEvent("ecomm - order processing - Error: Creating Account: Account Already Exists (Processing Step 1)");
          // $('#submission_message').html('Oops! It looks like that account already exists. <br /> Please contact our customer support at <strong>866.542.5900</strong>');
          $("#submission_error_message").html(
            "Oops! It looks like that account already exists. <br /> Please contact our customer support at <strong>" + getSupportNumber() + "</strong>"
          );
          $("#submission_error_message").removeClass("hide");
        } else {
          // logNSEvent("ecomm - order processing - Error: Creating Account: API Returned Error - "+response.Message+" (Processing Step 1)");
          // $('#submission_message').html('We encountered an error: <strong>' + response.Message + '</strong>. Please correct your information or you may contact our customer support at <strong>866.542.5900</strong>');
          // get the <a> element by looking for data-support-number attribute and get the appropriate phone number if new stack or old stack by checking local storage obj lumos_address_tech_stack == 'legacy'
          var supportNumber = getSupportNumber();
          $("#submission_error_message").html(
            "We encountered an error: <strong>" +
              response.Message +
              "</strong>. <br /> <br />Please contact our customer support at <strong>" + supportNumber + "</strong>"
          );
          $("#submission_error_message").removeClass("hide");
        }
      }

      // if(response.Status)
    },
    function (request, status, error) {

      $("#orderSubmitModal .submission-indicator li").eq(0).addClass("error");

      // $('#submission_message').html('We encountered an error. Please try again later or you may contact our customer support at <strong>866.542.5900</strong>');
      var supportNumber = getSupportNumber();

      $("#submission_error_message").html(
        "We encountered an error. Please try again later or you may contact our customer support at <strong>"+ supportNumber +"</strong>"
      );
      $("#submission_error_message").removeClass("hide");

      $("#termsconditions, #termsconditions-mobile").prop("disabled", false);
      $('.order-step[data-order-step="3"] button').prop("disabled", false);
      $(".close-reveal-modal").removeClass("hide");
    },
  );
}

// **
// * Once an account is created, create the service request
// **
function createServiceRequest(accountID) {
  var $ = jQuery;

  // logNSEvent("ecomm - order processing - Create Service Request (Processing Step 2)");

  $("#orderSubmitModal .submission-indicator li").eq(0).addClass("complete");
  $("#orderSubmitModal .mobile-step-indicator li").eq(0).addClass("complete");
  $("#orderSubmitModal .submission-indicator li").eq(0).removeClass("current");

  // $('.submission-indicator li').eq(1).addClass('complete');
  // $('.submission-indicator li').eq(1).removeClass('current');

  // $('.submission-indicator li').eq(2).addClass('current');

  $("#orderSubmitModal .submission-indicator li").eq(1).addClass("current");

  // console.log("Account ID Received: " + accountID);

  var feature_list = [],
    feature_stash = $.parseJSON(
      localStorage.getItem(cookieLabel_product_selection)
    );

  // console.log("Feature Stash: ", feature_stash.product_feature_selection);

  for (var i = 0; i < feature_stash.product_feature_selection.length; i++) {
    // console.log(feature_stash.product_feature_selection[i]);
    if (feature_stash.product_feature_selection[i].product_feature_checked) {
      var f_temp = {
        ItemID: 0,
        ParentItemID: null,
        ServiceID: null,
        LocationID: 0,
        ComponentID: null,
        CompnentCode: null,
        Component: null,
        Quantity: parseInt(
          feature_stash.product_feature_selection[i].product_feature_qty
        ),
        ActivationDate: null,
        DeactivationDate: null,
        Status: null,
        FeatureID: parseInt(
          feature_stash.product_feature_selection[i].product_feature_id
        ),
        ServiceItemAttributes: [],
        DefaultPrice: null,
        GroupID: null,
        PackageID: null,
      };

      feature_list.push(f_temp);
    }
  }

  // console.log("Feature list:", feature_list);

  var additionalInfo = "";

  if (
    sessionStorage.getItem("lumos_missing_billing_ids") &&
    sessionStorage.getItem("lumos_missing_billing_ids") == 1
  ) {
    var serviceBillingAddressFull = $("#service_billing_final").text();

    additionalInfo +=
      "NOTICE: Customer has requested a different billing address: " +
      serviceBillingAddressFull +
      " | ";
    sessionStorage.removeItem("lumos_missing_billing_ids");
  }

  // additionalInfo += 'Service Address: ' + localStorage.getItem('lumos_address_full_address') + ' | ';
  additionalInfo +=
    "Service Address: " +
    localStorage.getItem("lumos_address_street") +
    " " +
    localStorage.getItem("lumos_address_state") +
    ", " +
    localStorage.getItem("lumos_address_city") +
    " " +
    localStorage.getItem("lumos_address_zip") +
    " | ";

  // additionalInfo += 'Rent or Own Property: ' + $('[name="account_service_address_ownership"]:checked').val() + ' | ';

  // additionalInfo += 'Credit Check Results: $'+creditCheckAmount+' via '+creditCheckType+' | ';

  // additionalInfo += 'Contact Phone: ' + $('#account_service_contact_phone').val() + ' ' + $('#account_service_contact_phone_ext').val() + ' | ';
  additionalInfo +=
    "Contact Phone: " + $("#account_service_contact_phone").val() + " | ";

  // if ($('#account_service_alt_phone').val().length) {
  //   additionalInfo += 'Alternate Phone: ' + $('#account_service_alt_phone').val() + ' ' + $('#account_service_alt_phone_ext').val() + ' | ';
  // }

  additionalInfo +=
    "Contact Email: " + $("#account_service_contact_email").val() + " | ";

  // additionalInfo += 'Preferred Contact: ' + $('#account_service_best_contact').val() + ' | Best Time: ' + $('#account_service_best_time').val() + ' ';

  if ($("#transfer_number_yes").prop("checked")) {
    additionalInfo +=
      " | Customer would like to transfer a number from another carrier. ";
    additionalInfo +=
      " | Phone Number: " +
      $("#transfer_number_phone").val() +
      " | Carrier: " +
      $("#transfer_number_carrier").val() +
      " | Current Provider Account Number: " +
      $("#transfer_number_account").val() +
      " ";
  }

  if (
    $("#transfer_number_message").length &&
    $("#transfer_number_message").val().length
  ) {
    additionalInfo +=
      "| Customer Comments: " + $("#transfer_number_message").val() + " ";
  }

  // if($('#schedule-availability-firstavailable').prop('checked')) {
  //   additionalInfo += 'Preferred Installation Date: First Available ';
  // } else {
  //   additionalInfo += 'Preferred Installation Date:' + $('#schedule-availability-date-day').val() + ' ' + $('#schedule-availability-date-time').val() + ' ';
  // }

  // if( $('#schedule-availability-instructions').val().length ) {
  //   additionalInfo += 'Special Installation Instructions: ' + $('#schedule-availability-instructions').val();
  // }

  var transfer_phone = null;
  if (
    $("#transfer_number_phone").val().length &&
    $("#transfer_number_yes").prop("checked")
  ) {
    // console.log("Transfer Phone: ", $("#transfer_number_phone").val());
    var cleanPhoneNumber = $("#transfer_number_phone").val().replace(/\D/g, '');
    transfer_phone = parseInt(cleanPhoneNumber);
  }

  // console.log(transfer_phone, additionalInfo);
  //
  // console.log("Product ID", feature_stash.product_ns_id);

  var isInstallCharge = true;
  if ($("[data-show-install-fee]").hasClass("hide")) {
    isInstallCharge = false;
  }

  var serviceData = {
    action: "create_service",
    accountID: accountID,
    locationID: localStorage.getItem("lumos_location_id"),
    service_phone: transfer_phone,
    feature_list: JSON.stringify({
      featureParams: feature_list,
    }),
    // additionalInfo: additionalInfo,
    // productID: $('#order-info').attr('data-ns-product-id')
    productID: feature_stash.product_ns_id,
    deposit_amount: creditCheckDepositAmount,
    applyInstallCharge: isInstallCharge,
    sessionId: localStorage.getItem(ns_ecomm_session_id_name),
    stepLabel: "Step2.1-Error-create_service",
  };

  if ($("#account_service_agent_id").val()) {
    serviceData.AgentID = $("#account_service_agent_id").val();
  }

  if (
    feature_stash.product_ns_promotion_id &&
    feature_stash.product_ns_promotion_id.length
  ) {
    serviceData.ProductPromotion = feature_stash.product_ns_promotion_id;
  }

  ajaxCall(
    serviceData,
    function(response) {
      if (typeof response === "string") {
        response = JSON.parse(response);
        sendNSTimer("Step2.1-create_service:" + response.Message);
      }
      if (response.Status === "failure") {
        noService(response);
      }else{
        checkForService(accountID, additionalInfo);
      }
    },
    function(jqXHR, textStatus, errorThrown) {
      noService({'Message': errorThrown});
    }
  );
}

function checkForService(accountID, additionalInfo, serviceCheckCounter = 0) {

  var $ = jQuery;

  ajaxCall(
    {
      action: "ns_services",
      sessionId: localStorage.getItem(ns_ecomm_session_id_name),
      accountId: accountID,
      stepLabel: "Step2.1-Error-create_service",
    },
    function (result) {
      var newServiceCheckCounter = serviceCheckCounter + 1;

      // console.log("Service Status: " + result);

      // console.log("refreshId:", refreshId);
      var response = $.parseJSON(result);
      response.Data = response.Data[0];

      if (
        typeof response.Data === "object" &&
        response.Data.hasOwnProperty("ServiceID") &&
        response.Data.hasOwnProperty("ServiceOrderID") &&
        response.Data.ServiceID > 0 &&
        response.Data.ServiceOrderID > 0
      ) {
        // console.log(
        //   "service status: ",
        //   response.Data.ServiceID,
        //   response.Data.ServiceOrderID
        // );
        // console.log("service was found");
        gotService(result, additionalInfo);
      } else if (serviceCheckCounter > 20) {
        // console.log("service not found");
        noService(result);
      } else {
        // Run the Check Again after 8 seconds
        setTimeout(function () {
          sendNSTimer("Step2.1-check_for_service-RetriesLeft:" + getTaxesRetries);

          checkForService(accountID, additionalInfo, newServiceCheckCounter);
        }, 8000);
      }
    },
    function (request, status, error) {
      $("#orderSubmitModal .submission-indicator li")
        .eq(1)
        .removeClass("current");
      $("#orderSubmitModal .submission-indicator li").eq(1).addClass("error");

      $("#submission_message").html(
        "We encountered an error. Please try again later or you may contact our customer support at <strong>" + getSupportNumber() + "</strong>"
      );
      $("#submission_message").removeClass("hide");

      $("#termsconditions, #termsconditions-mobile").prop("disabled", false);
      $('.order-step[data-order-step="3"] button').prop("disabled", false);
      $(".close-reveal-modal").removeClass("hide");
    },
  );
}

function noService(result) {
  var $ = jQuery;

  // only run no service once
  if(serviceChecked) {
    return;
  }

  serviceChecked = true;

  sendNSError(
    "Step2.1-Error-create_service-APIError:" +
      result.Message
  );
  // stopNSTimer();

  // console.log("Nope", result);
  // logNSEvent("ecomm - order processing - Create Service Request: No Service Order Created - Error Shown");

  // $('.submission-indicator li').eq(0).addClass('error');
  // $('.submission-indicator li').eq(1).addClass('error');
  $("#orderSubmitModal .submission-indicator li").eq(1).removeClass("current");
  $("#orderSubmitModal .submission-indicator li").eq(1).addClass("error");

  $("#submission_message").html(
    "We encountered an error. Please try again later or you may contact our customer support at <strong>" + getSupportNumber() + "</strong>"
  );
  $("#submission_message").removeClass("hide");

  $("#termsconditions, #termsconditions-mobile").prop("disabled", false);
  $('.order-step[data-order-step="3"] button').prop("disabled", false);
  $(".close-reveal-modal").removeClass("hide");
}

function gotService(result, additionalInfo) {
  var $ = jQuery;

  // console.log(result);
  var response = $.parseJSON(result);
  if (Array.isArray(response.Data)) {
    response.Data = response.Data[0];
  }

  if (response.Status === "success") {
    // NS GTM Timer End
    sendNSTimer("Step2.1-create_service");

    setSalesforcePartialContact(true, 'add');
    setSalesforcePartialContact(true, 'update');

    sendNSPopupConversion();

    orderStreet = localStorage.getItem("lumos_address_street");
    orderCity = localStorage.getItem("lumos_address_city");
    orderState = localStorage.getItem("lumos_address_state");
    orderZIP = localStorage.getItem("lumos_address_zip");

    clearAddressSelection();

    var accountID = response.Data.AccountID,
      serviceID = response.Data.ServiceID,
      serviceOrderID = response.Data.ServiceOrderID;

    orderaccountid = accountID;
    orderserviceid = serviceOrderID;

    ajaxCall(
      {
        action: "set_service_comments",
        serviceOrderID: serviceOrderID,
        comment: additionalInfo,
        sessionId: localStorage.getItem(ns_ecomm_session_id_name),
        stepLabel: "Step2.2-Error-set_service_comments",
      },
      function (result) {
        // console.log(result);

        var response = $.parseJSON(result);

        // console.log(response);

        if (response.Status === "success") {
          // NS GTM Timer End
          sendNSTimer(
            "Step2.2-set_service_comments"
          );

          // runCreditCheck(accountID, serviceID, serviceOrderID);
          scheduleInstallation(serviceID, serviceOrderID, accountID);
        } else {
          sendNSError(
            "Step2.2-Error-set_service_comments-APIError: " +
              response.Message
          );
          // stopNSTimer();

          $("#orderSubmitModal .submission-indicator li")
            .eq(1)
            .addClass("error");

          $("#submission_message").html(
            "We encountered an error: <strong>" +
              response.Message +
              "</strong> <br /> Please contact our customer support at <strong>" + getSupportNumber() + "</strong> for further assistance."
          );
          $("#submission_message").removeClass("hide");

          // console.log(
          //   result,
          //   "ServiceOrderID: ",
          //   serviceOrderID,
          //   "Comments: ",
          //   additionalInfo
          // );
        }
      },
      function (request, status, error) {
        orderComplete();
      },
    );

    // console.log(response);

    // TODO: Redirect to Thank You
  } else {
    // hide service creation failure
    // $('#orderSubmitModal .progress-order').attr('data-percent','100');
    // $('#orderSubmitModal .progress-order').addClass('success');
    // $('#submission_message').text('Step 3 of 3: You\'re all set! ');

    // logNSEvent("ecomm - order processing - Create Service Request: API Error - No Service Order Created - Send to Order Complete");

    sendNSError(
      "Step2.1-Error-create_service-APIError: " +
        response.Message
    );

    orderComplete();

    // $('#orderSubmitModal .view-order').removeClass('hide');
    // $('#processing-message').text('Thank you! Your order has been received.');
    // $('#submission_message').text('We\'ll be contacting you via email shortly with details of your order. Welcome to the NorthState family!');
    // $('#order-processing-instructions').hide();

    // console.log(result, {
    //   featureParams: feature_list,
    // });
  }
}

// **
// * Once service request has been created, run credit check
// **
// function runCreditCheck(accountID, serviceID, serviceOrderID) {
function runCreditCheck(accountID, serviceID, serviceOrderID) {
  var $ = jQuery;

  // logNSEvent("ecomm - order processing - Run Credit Check (Processing Step 3)");

  $("#orderSubmitModal .submission-indicator li").eq(0).addClass("complete");
  $("#orderSubmitModal .mobile-step-indicator li").eq(0).addClass("complete");
  $("#orderSubmitModal .submission-indicator li").eq(0).removeClass("current");

  // $('.submission-indicator li').eq(1).addClass('complete');
  // $('.submission-indicator li').eq(1).removeClass('current');

  // $('.submission-indicator li').eq(1).addClass('current');

  $("#orderSubmitModal .submission-indicator li").eq(1).addClass("complete");
  $("#orderSubmitModal .mobile-step-indicator li").eq(1).addClass("complete");
  $("#orderSubmitModal .submission-indicator li").eq(1).removeClass("current");

  $("#orderSubmitModal .submission-indicator li").eq(2).addClass("current");

  $("#submission_message").html(
    "This step may take up to a few minutes to complete. <br /> Thank you for your patience."
  );
  $("#submission_message").removeClass("hide");

  // console.log(accountID, serviceID, serviceOrderID);

  ajaxCall(
    {
      action: "account_credit_check",
      accountId: accountID,
      sessionId: localStorage.getItem(ns_ecomm_session_id_name),
      stepLabel: "Step3.1-Error-account_credit_check",
    },
    function (result) {
      // NS GTM Timer End

      // console.log(result);

      var response;

      try {
        response = $.parseJSON(result);
      } catch (e) {
        sendNSError(
          "Step3.2-Error-set_service_comments-APICommError2"
        );

        // logNSEvent("ecomm - order processing - Error: Run Credit Check: Unable to run credit check via API (Processing Step 3)");

        $("#orderSubmitModal .submission-indicator li").eq(2).addClass("error");
        $("#orderSubmitModal .submission-indicator li")
          .eq(2)
          .removeClass("current");

        $("#submission_error_message").html(
          "We encountered an error with the credit checking service. Please try again later or you may contact our customer support at <strong>" + getSupportNumber() + "</strong>"
        );
        $("#submission_error_message").removeClass("hide");

        $("#termsconditions, #termsconditions-mobile").prop("disabled", false);
        $('.order-step[data-order-step="3"] button').prop("disabled", false);
        $("#submission_message").addClass("hide");
        $(".close-reveal-modal").removeClass("hide");
      }

      if (response.Status == "success") {
        sendNSTimer(
          "Step3.1-account_credit_check"
        );

        creditCheckAmount = response.Data.amount;
        creditCheckDepositAmount = response.Data.amount;
        creditCheckType = response.Data.type;

        if (response.Data.amount > 0) {
          // logNSEvent("ecomm - order processing - Run Credit Check: Type: " +response.Data.type+ ", Amount: " +response.Data.amount+ " (Processing Step 3)");

          // Do Deposit/Advance Payment
          // $('.submission-indicator li').eq(1).addClass('alert');
          // $('.submission-indicator li').eq(1).removeClass('current');
          $("#orderSubmitModal .submission-indicator li")
            .eq(2)
            .addClass("alert-ns");
          $("#orderSubmitModal .submission-indicator li")
            .eq(2)
            .removeClass("current");

          // Change language for apay
          if (response.Data.type == "deposit") {
            $("#submission_message").html(
              "A deposit of <strong>$" +
                parseFloat(response.Data.amount).toFixed(2) +
                "</strong> is required to continue processing your order."
            );
          } else {
            creditCheckDepositAmount = 0;
            $("#submission_message").html(
              "An advance payment of <strong>$" +
                parseFloat(response.Data.amount).toFixed(2) +
                "</strong> is required to continue processing your order."
            );
          }

          $("#submission_message").removeClass("hide");

          // Show Payment Sequence
          $("#credit-check-deposit-cancel").attr("data-account-id", accountID);
          $("#credit-check-deposit-cancel").attr("data-service-id", serviceID);

          $("#ns-credit-check-bank-routingnumber").attr(
            "data-account",
            accountID
          );

          $("#ns-credit-check-bank-amount").val(response.Data.amount);
          $("#ns-credit-check-cc-amount").val(response.Data.amount);

          $("#ns-credit-check-bank-accountid").val(accountID);
          $("#ns-credit-check-bank-serviceid").val(serviceID);
          $("#ns-credit-check-bank-serviceorderid").val(serviceOrderID);

          $("#ns-credit-check-cc-accountid").val(accountID);
          $("#ns-credit-check-cc-serviceid").val(serviceID);
          $("#ns-credit-check-cc-serviceorderid").val(serviceOrderID);

          $("#credit-check-deposit").removeClass("hide");
        } else {
          // Continue w/o deposit
          // console.log("No Deposit Required");
          // logNSEvent("ecomm - order processing - Run Credit Check: No Deposit Required (Processing Step 3)");

          var additionalInfo =
            "Credit Check Results: $" +
            creditCheckAmount +
            " via " +
            creditCheckType +
            "";

          ajaxCall(
            {
              action: "set_service_comments",
              serviceOrderID: serviceOrderID,
              comment: additionalInfo,
              sessionId: localStorage.getItem(ns_ecomm_session_id_name),
              stepLabel: "Step3.2-Error-set_service_comments",
            },
            function (result) {
              // console.log(result);

              var response = $.parseJSON(result);

              // console.log(response);

              if (response.Status === "success") {
                // NS GTM Timer End
                sendNSTimer(
                  "Step3.2-set_service_comments"
                );
                scheduleInstallation(serviceID, serviceOrderID, accountID);
              } else {
                sendNSError(
                  "Step3.2-Error-set_service_comments-APIError:" +
                    response.Message
                );

                $("#orderSubmitModal .submission-indicator li")
                  .eq(2)
                  .addClass("error");
                $("#orderSubmitModal .submission-indicator li")
                  .eq(2)
                  .removeClass("current");

                $("#submission_error_message").html(
                  "We encountered an error. " +
                    response.Message +
                    " Please try again later or you may contact our customer support at <strong>" + getSupportNumber() + "</strong>"
                );
                $("#submission_error_message").removeClass("hide");

                $("#termsconditions, #termsconditions-mobile").prop("disabled", false);
                $('.order-step[data-order-step="3"] button').prop(
                  "disabled",
                  false
                );
                $("#submission_message").addClass("hide");
                $(".close-reveal-modal").removeClass("hide");
              }
            },
            function (results) {

              $("#orderSubmitModal .submission-indicator li")
                .eq(2)
                .addClass("error");
              $("#orderSubmitModal .submission-indicator li")
                .eq(2)
                .removeClass("current");

              $("#submission_error_message").html(
                "We encountered an internal communications error. Please try again later or you may contact our customer support at <strong>" + getSupportNumber() + "</strong>"
              );
              $("#submission_error_message").removeClass("hide");

              $("#termsconditions, #termsconditions-mobile").prop("disabled", false);
              $('.order-step[data-order-step="3"] button').prop(
                "disabled",
                false
              );
              $(".close-reveal-modal").removeClass("hide");
            },
          );
        }
      } else {
        sendNSError(
          "Step3.1-Error-account_credit_check-APIError:" +
            response.Message
        );
        // stopNSTimer();

        // logNSEvent("ecomm - order processing - Error: Run Credit Check: API Returned Error - "+response.Message+" (Processing Step 3)");

        // $('.submission-indicator li').eq(1).addClass('error');
        // $('.submission-indicator li').eq(1).removeClass('current');

        $("#orderSubmitModal .submission-indicator li").eq(2).addClass("error");
        $("#orderSubmitModal .submission-indicator li")
          .eq(2)
          .removeClass("current");

        $("#submission_error_message").html(
          "We encountered an error. " +
            response.Message +
            " Please try again later or you may contact our customer support at <strong>" + getSupportNumber() + "</strong>"
        );
        $("#submission_error_message").removeClass("hide");

        $("#termsconditions, #termsconditions-mobile").prop("disabled", false);
        $('.order-step[data-order-step="3"] button').prop("disabled", false);
        $("#submission_message").addClass("hide");
        $(".close-reveal-modal").removeClass("hide");
      }
    },
    function (request, status, error) {
      $("#orderSubmitModal .submission-indicator li").eq(2).addClass("error");
      $("#orderSubmitModal .submission-indicator li")
        .eq(2)
        .removeClass("current");

      $("#submission_error_message").html(
        "We encountered an internal communications error. Please try again later or you may contact our customer support at <strong>" + getSupportNumber() + "</strong>"
      );
      $("#submission_error_message").removeClass("hide");

      $("#termsconditions, #termsconditions-mobile").prop("disabled", false);
      $('.order-step[data-order-step="3"] button').prop("disabled", false);
      $(".close-reveal-modal").removeClass("hide");
    },
  );
}

// **
// * Pending successful credit check, schedule installation
// **
function scheduleInstallation(serviceID, serviceOrderID, accountID) {
  var $ = jQuery;

  $("#submission_message").addClass("hide");

  $("#orderSubmitModal .submission-indicator li").eq(1).removeClass("current");
  $("#orderSubmitModal .submission-indicator li").eq(1).removeClass("alert-ns");
  $("#orderSubmitModal .submission-indicator li").eq(1).addClass("complete");
  $("#orderSubmitModal .mobile-step-indicator li").eq(1).addClass("complete");
  $("#orderSubmitModal .submission-indicator li").eq(2).addClass("current");


  $("#ns-schedule-install-service-id").val(serviceID);
  $("#ns-schedule-install-service-order-id").val(serviceOrderID);

  $("#ns-schedule-install-service-id-manual").val(serviceID);
  $("#ns-schedule-install-service-order-id-manual").val(serviceOrderID);
  $("#ns-schedule-install-account-id-manual").val(accountID);

  $("#schedule-finding-dates").removeClass("hide");

  $("#submitOrderCollapseButton").trigger("click");

  // checkAssign(serviceID);
  // Skip check assign
  getFacilitySplitterCheck(serviceID);
}

function getFacilitySplitterCheck(serviceID) {
  var $ = jQuery;

  // The current date
  var splitterStartDate = new Date().toISOString().split("T")[0];

  ajaxCall(
    {
      action: "facility_splitter_check_service",
      serviceID: serviceID,
      sessionId: localStorage.getItem(ns_ecomm_session_id_name),
      stepLabel: "Step4.1.1-Error-facility_splitter_check_service",
    },
    function (result) {
      // console.log(result);
      var response = $.parseJSON(result);

      if (response.Status == "success") {
        if (scheduleTries > 0) {
          sendNSTimer(
            "Step4.1.1-facility_splitter_check_service-Attempt: " +
              scheduleTries
          );
        } else {
          sendNSTimer(
            "Step4.1.1-facility_splitter_check_service"
          );
        }

        var responseDate = "";

        if (response.Data.ScheduleAfterDate !== null) {
          responseDate = response.Data.ScheduleAfterDate.split(" ")[0];

          // console.log("Schedule After Date: " + responseDate);

          if (splitterStartDate < responseDate) {
            // console.log(
            //   "Update Start Date from " +
            //     splitterStartDate +
            //     " to " +
            //     responseDate
            // );
            splitterStartDate = responseDate;
          }
        } else {
          // console.log("Schedule After Date was NULL");
        }
      } else {
        // NS GTM Timer End
        if (scheduleTries > 0) {
          sendNSError(
            "Step4.1.1-Error-facility_splitter_check_service-APIError:" +
              response.Message +
              "-Attempt:" +
              scheduleTries
          );
        } else {
          sendNSError(
            "Step4.1.1-Error-facility_splitter_check_service-APIError: " +
              response.Message
          );
        }
      }

      ajaxCall(
        {
          action: "first_date_available",
          serviceID: serviceID,
          sessionId: localStorage.getItem(ns_ecomm_session_id_name),
          stepLabel: "Step4.1.2-Error-first_date_available",
        },
        function (result) {
          var response = $.parseJSON(result);

          var responseDate = response.Data;
          // var dateArray = response.Data.split("-");
          // var year = parseInt(dateArray[0], 10);
          // var month = parseInt(dateArray[1], 10); // subtract 1 since months are zero-indexed in JS
          // var day = parseInt(dateArray[2], 10);
          // var initialStartDate = new Date(Date.UTC(year, month, day));

          // console.log(responseDate, responseDate + "T00:00:00");

          var initialStartDate = new Date(responseDate + "T00:00:00");

          // console.log(splitterStartDate, splitterStartDate + "T00:00:00");

          splitterStartDate = new Date(splitterStartDate + "T00:00:00");

          // console.log("Initial Start Date: " + initialStartDate);
          // console.log("Splitter Start Date: " + splitterStartDate);

          // Check to make sure the returned splitter start time isn't greater than the first date avail
          if (splitterStartDate.getTime() > initialStartDate.getTime()) {
            initialStartDate = splitterStartDate;
          }

          // initialStartDate.setHours(0, 0, 0, 0);
          var initialStartDateNextDay = getStartOfWeek(initialStartDate);
          initialStartDateNextDay.setDate(
            initialStartDateNextDay.getDate() + 1
          );

          var startDateWeekBegin = new Date(getStartOfWeek(initialStartDate));
          var weekRange = calculateWeekRange(initialStartDate);

          // initialStartDate.toISOString().split("T")[0];

          // console.log("Initial Week Start Date: " + startDateWeekBegin);

          getScheduleDateTime(
            serviceID,
            formatDateToString(startDateWeekBegin)
          );

          $("#week-display").text(
            "Week of " +
              formatDateToString(weekRange.startOfWeek) +
              " - " +
              formatDateToString(weekRange.endOfWeek)
          );

          // Hide the prev-week-button initially
          if (weekRange.startOfWeek <= initialStartDate) {
            $("#prev-week-button").hide();
          } else {
            $("#prev-week-button").show();
          }

          // Previous Week Clicked
          $("#prev-week-button").click(function () {
            if ($(this).hasClass("disabled")) {
              return;
            }
            refreshSession("Step4.3.0", function(){
              $("#prev-week-button, #next-week-button").addClass("disabled");

              $("#ns-installation-date").val("");
              $("#ns-installation-time").val("");

              // Subtract 7 days from current start of week to get previous week
              var newDate = new Date(weekRange.startOfWeek);
              newDate.setDate(newDate.getDate() - 7);
              newDate.setHours(0, 0, 0, 0);

              $("#ns-installation-date").parent().addClass("loading");

              // console.log("newDate: " + newDate);
              // console.log("startDateWeekBegin: " + startDateWeekBegin);

              if (newDate >= startDateWeekBegin) {
                weekRange.startOfWeek = new Date(newDate);
                var newEndDate = new Date(weekRange.endOfWeek);
                newEndDate.setDate(newEndDate.getDate() - 7);
                weekRange.endOfWeek = newEndDate;
                $("#week-display").text(
                  "Week of " +
                    formatDateToString(weekRange.startOfWeek) +
                    " - " +
                    formatDateToString(weekRange.endOfWeek)
                );
                // Reload the data
                // console.log("prev week" + weekRange.startOfWeek);
                getScheduleDateTime(
                  serviceID,
                  formatDateToString(weekRange.startOfWeek)
                );
              }

              // If startOfWeek is same or less than initialStartDate, hide the prev-week-button
              if (weekRange.startOfWeek <= initialStartDate) {
                $("#prev-week-button").hide();
              }
            });
          });

          $("#next-week-button").click(function () {
            if ($(this).hasClass("disabled")) {
              return;
            }
            refreshSession("Step4.3.0", function(){
              $("#prev-week-button, #next-week-button").addClass("disabled");

              $("#ns-installation-date").val("");

              $("#ns-installation-time").val("");

              // Add 7 days to current start of week to get next week
              var newDate = new Date(weekRange.startOfWeek);
              newDate.setDate(newDate.getDate() + 7);

              newDate.setHours(0, 0, 0, 0);

              $("#ns-installation-date").parent().addClass("loading");

              // console.log("newDate: " + newDate);
              weekRange.startOfWeek = new Date(newDate);
              var newEndDate = new Date(weekRange.endOfWeek);
              newEndDate.setDate(newEndDate.getDate() + 7);
              weekRange.endOfWeek = newEndDate;
              $("#week-display").text(
                "Week of " +
                  formatDateToString(weekRange.startOfWeek) +
                  " - " +
                  formatDateToString(weekRange.endOfWeek)
              );

              // Reload the data
              // console.log("next week" + weekRange.startOfWeek);
              getScheduleDateTime(
                serviceID,
                formatDateToString(weekRange.startOfWeek)
              );

              $("#prev-week-button").show();
            });
          });
        },
      );
    },
    function (request, status, error) {
      if (scheduleTries > 0) {
        sendNSError(
          "Step4.1.1-Error-facility_splitter_check_service-APICommError-Attempt:" +
            scheduleTries +
            ":" + request.responseText
        );
      }
      getScheduleDateTime(serviceID, startDate);
    },
  );
}

function refreshSession(stepInfo, callback){

  // restart timer for refresh session call
  startNSTimer();

  setTimeout(function() {
    // hit session endpoint to check if still valid, if not hit endopint to create new session

    let sessionId = localStorage.getItem(ns_ecomm_session_id_name);

    ajaxCall(
      {
        action: "ns_check_session",
        sessionId: sessionId,
        stepLabel: stepInfo + "-ns_check_session",
      },
       function(result) {
        let response = $.parseJSON(result);
        // let response = textStatus;
        if (response.Status !== "success" || (response.Data && response.Data.Username == null)) {

          startNSTimer(); // restart timer for ns_login call

          // ns_login endpoint
          ajaxCall(
            {
              action: "ns_login",
              username: usernameCreated,
              password: passwordCreated,
              stepLabel: stepInfo + "-ns_login",
            },
            function (result) {
              var response = $.parseJSON(result);
                if (response.Status === "success") {
                  sendNSTimer(stepInfo + "-ns_login");

                  var date = new Date();
                  var timestamp = date.getTime();
                  ns_ecomm_session_id_name = "ns_ecomm_session_id_" + timestamp;
                  localStorage.setItem(
                    ns_ecomm_session_id_name,
                    response.Data.SessionId
                  );
                } else {
                  sendNSError(
                    stepInfo + " Error-ns_login-APIError: " +
                      response.Message
                  );
                  // stopNSTimer();
                  $("#submission_error_message").html(
                    "We encountered an error: <strong>" +
                      response.Message +
                      "</strong>. <br /> <br />Please contact our customer support at <strong>" + getSupportNumber() + "</strong>"
                  );
                  $("#submission_error_message").removeClass("hide");
                }
            },
            null,
            "/wp-content/themes/lumos-tidewater/api_helper.php",
            false,
          );
        }else{
          sendNSTimer(stepInfo + "-ns_session_check");
        }
      },
      null,
      '/wp-content/themes/lumos-tidewater/api_helper.php',
      false,
    );

    callback();
  }, 100);
}

function getStartOfWeek(date) {
  var day = date.getDay(); // Get current day, counting from Sunday as 0
  var difference = date.getDate() - day; // Subtract the difference
  return new Date(date.setDate(difference)); // Return new date
}

// Calculate start and end of week based on a given date
function calculateWeekRange(date) {
  var startOfWeek = new Date(
    date.getFullYear(),
    date.getMonth(),
    date.getDate() - date.getDay()
  );
  startOfWeek.setHours(0, 0, 0, 0);
  var endOfWeek = new Date(startOfWeek);
  endOfWeek.setDate(endOfWeek.getDate() + 6);
  return { startOfWeek, endOfWeek };
}

// Convert Date to String in the format Month, DD, YYYY
function formatDateToString(date) {
  // var options = { year: "numeric", month: "long", day: "numeric" };
  // return date.toLocaleDateString(undefined, options);

  // var monthNames = [
  //   "January",
  //   "February",
  //   "March",
  //   "April",
  //   "May",
  //   "June",
  //   "July",
  //   "August",
  //   "September",
  //   "October",
  //   "November",
  //   "December",
  // ];

  var monthNames = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec",
  ];

  var day = date.getUTCDate();
  var monthIndex = date.getUTCMonth();
  var year = date.getUTCFullYear();

  return monthNames[monthIndex] + " " + day + ", " + year;
}

function getScheduleDateTime(serviceID, startDate) {
  var $ = jQuery;
  var weekRange = calculateWeekRange(new Date(startDate));

  ajaxCall(
    {
      action: "service_installation_schedule",
      serviceID: serviceID,
      startDate: startDate,
      sessionId: localStorage.getItem(ns_ecomm_session_id_name),
      stepLabel: "Step4.2-Error-service_installation_schedule",
    },
    function (result) {
      // console.log(result);

      var response = $.parseJSON(result);

      if (response.Status == "success") {
        // NS GTM Timer End
        if (scheduleTries > 0) {
          sendNSTimer(
            "Step4.2-service_installation_schedule-Attempt:" +
              scheduleTries
          );
        } else {
          sendNSTimer(
            "Step4.2-service_installation_schedule"
          );
        }

        $("#orderSubmitModal .submission-indicator li")
          .eq(2)
          .removeClass("current");

          $("#orderSubmitModal .mobile-step-indicator li").eq(2).removeClass("current");

        if (scheduleTries > 0) {
          console.log("Schedule Tries: " + scheduleTries);
          $("#orderSubmitModal .submission-indicator li")
            .eq(2)
            .addClass("error");
        } else {
          $("#orderSubmitModal .submission-indicator li")
            .eq(2)
            .addClass("step-active");
        }

        $("#schedule-installation-date").removeClass("hide");

        // var timeSlots = JSON.parse(result);

        var nowTemp = new Date();
        var now = new Date(
          nowTemp.getFullYear(),
          nowTemp.getMonth(),
          nowTemp.getDate(),
          0,
          0,
          0,
          0
        );

        var availableDates = [];

        // Clear scheduling fields
        $("#ns-installation-date").val("");
        $("#ns-installation-time").val("");

        // Populate the dropdown with dates for the selected week
        var selectElement = $("#ns-installation-date");
        selectElement.empty(); // Remove current options

        //available text
        selectElement.prepend(new Option("Available Dates", ""));

        var addedDates = []; // Array to store added dates

        // Clean up schedule data
        if('AutoAssignResult' in response.Data) {
          delete response.Data.AutoAssignResult;
        }
        if('EarlyJobCode' in response.Data) {
          delete response.Data.EarlyJobCode;
        }
        if('EarlyJobCodeSuffix' in response.Data) {
          delete response.Data.EarlyJobCodeSuffix;
        }
        if('HasSSPError' in response.Data) {
          delete response.Data.HasSSPError;
        }
        if('JobCodes' in response.Data) {
          delete response.Data.JobCodes;
        }

        for (var d = 0; d < countProperties(response.Data); d++) {
          if (
            typeof response.Data[d] !== "undefined" &&
            response.Data[d].TimeSlotType == "AVAILABLE"
          ) {
            var daysOfWeek = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
            var formatDate = new Date(
              response.Data[d].StartTime.split(" ")[0] + "T00:00:00"
            );
            var formattedDate =
              formatDate.getFullYear().toString() +
              formatDate.getMonth().toString() +
              formatDate.getDate().toString();

            // console.log(
            //   "formattedDate: " + formattedDate,
            //   formatDate,
            //   formatDate.getDay(),
            //   daysOfWeek[formatDate.getDay()]
            // );

            if (!Array.isArray(availableDates[formattedDate])) {
              availableDates[formattedDate] = [];
            }
            availableDates[formattedDate].push(response.Data[d]);

            // Add an option to the select for this date, if it's not already added
            if (!addedDates.includes(formattedDate)) {
              selectElement.append(
                new Option(
                  daysOfWeek[formatDate.getDay()] +
                    ", " +
                    formatDateToString(formatDate),
                  formatDate
                )
              );
              addedDates.push(formattedDate); // Add date to the addedDates array
            }
            // }
          }
        }

        // console.log("Available Dates", availableDates);

        // If no available dates, what do?
        if(availableDates.length) {

        }

        $("#prev-week-button, #next-week-button").removeClass("disabled");

        $("#ns-installation-date").parent().removeClass("loading");

        $("#schedule-finding-dates").addClass("hide");

        // Set Available Times
        $("#ns-installation-date").off("change"); // remove handler before reapplying
        $("#ns-installation-date").change(function () {
          // Clear Available Times
          $("#ns-installation-time").empty();
          $("#ns-installation-time").append(new Option("Available Times", ""));

          // Clear schedule item in form
          $("#ns-schedule-item").val("");

          if ($(this).val() !== "") {
            $("#ns-installation-time").parent().addClass("loading");
            $("#ns-installation-time").prop("disabled", true);

            // console.log('date selected', $(this).val());
            // TODO: Get available times

            var selectedDate = new Date($(this).val());
            // console.log("Selected Date: " + selectedDate);

            var cDateKey =
              selectedDate.getFullYear().toString() +
              selectedDate.getMonth().toString() +
              selectedDate.getDate().toString();

            if (availableDates[cDateKey]) {
              for (var t = 0; t < availableDates[cDateKey].length; t++) {
                // $("#ns-installation-time").append(
                //   '<option value="' +
                //     availableDates[cDateKey][t].ScheduleItems[0].TimeSlotID +
                //     '">' +
                //     availableDates[cDateKey][t].TimeSlotConfigDescription +
                //     "</option>"
                // );
                $("#ns-installation-time").append(
                  new Option(
                    availableDates[cDateKey][t].TimeSlotConfigDescription,
                    availableDates[cDateKey][t].ScheduleItems[0].TimeSlotID
                  )
                );
              }
            }

            $("#ns-installation-time").parent().removeClass("loading");
            $("#ns-installation-time").prop("disabled", false);
          } else {
            $("#ns-installation-time").val("");
          }
        });

        // Select Time
        $("#ns-installation-time").off("change"); // remove handler before reapplying
        $("#ns-installation-time").change(function () {
          var selectedDate = new Date($("#ns-installation-date").val());

          // console.log("Selected Time: " + selectedDate);

          var cDateKey =
            selectedDate.getFullYear().toString() +
            selectedDate.getMonth().toString() +
            selectedDate.getDate().toString();

          if (availableDates[cDateKey]) {
            // console.log(
            //   "selected time + schedule Item: " +
            //     JSON.stringify(
            //       availableDates[cDateKey][$(this).prop("selectedIndex") - 1]
            //         .ScheduleItems[0]
            //     )
            // );
            $("#ns-schedule-item").val(
              JSON.stringify(
                availableDates[cDateKey][$(this).prop("selectedIndex") - 1]
                  .ScheduleItems[0]
              )
            );
          }
        });

         // remove animation when user is active in step
         $("#ns-installation-date").one("change", function () {
          $("#orderSubmitModal .submission-indicator li")
            .eq(2)
            .addClass("user-active");
        });
      } else {
        // NS GTM Timer End
        if (scheduleTries > 0) {
          sendNSError(
            "Step4.2-Error-service_installation_schedule-APIError:" +
              response.Message +
              "-Attempt:" +
              scheduleTries
          );
        } else {
          sendNSError(
            "Step4.2-Error-service_installation_schedule-APIError:" +
              response.Message
          );
        }
        // stopNSTimer();
        // logNSEvent("ecomm - order processing - Error: Schedule Installation: API Message: " +response.Message+ " (Processing Step 4)");

        $("#orderSubmitModal .submission-indicator li").eq(2).addClass("error");

        $("#submission_error_message").html(
          "We encountered an error. " +
            response.Message +
            " Please try again later or you may contact our customer support at <strong>" + getSupportNumber() + "</strong>"
        );
        $("#submission_error_message").removeClass("hide");

        $('.order-step[data-order-step="3"] button').prop("disabled", false);
        $(".close-reveal-modal").removeClass("hide");
      }
    },
    function (request, status, error) {
      if (scheduleTries > 0) {
        sendNSError(
          "Step4.2-Error-service_installation_schedule-APICommError-Attempt:" +
            scheduleTries +
            ':' + request.responseText
        );
      }

      $("#orderSubmitModal .submission-indicator li").eq(2).addClass("error");
      // console.log(result);

      $("#submission_error_message").html(
        "We encountered an error. Please try again later or you may contact our customer support at <strong>" + getSupportNumber() + "</strong>"
      );
      $("#submission_error_message").removeClass("hide");

      // $('#termsconditions').prop('disabled', false);
      $('.order-step[data-order-step="2"] button').prop("disabled", false);
      $(".close-reveal-modal").removeClass("hide");
    },
  );
}

// **
// * Final Step. Order has completed.
// **
function orderComplete() {
  var $ = jQuery;

  // logNSEvent("ecomm - order processing - Order Complete! (Processing Step 5)");

  isProcessingOrder = false;

  // Delete API Session & Cookie
  ajaxCall(
    {
      action: "ns_session_delete",
      sessionId: localStorage.getItem(ns_ecomm_session_id_name),
      stepLabel: "Step5-Error-ns_session_delete",
    },
    function (result) {
      // console.log(result);

      localStorage.removeItem(ns_ecomm_session_id_name);

      $("#orderSubmitModal .submission-indicator li")
        .eq(0)
        .removeClass("current");
      $("#orderSubmitModal .submission-indicator li")
        .eq(1)
        .removeClass("current");
      $("#orderSubmitModal .submission-indicator li")
        .eq(2)
        .removeClass("current");
      // $('.submission-indicator li').eq(3).removeClass('current');
      // $('.submission-indicator li').eq(4).removeClass('current');
      //
      $("#orderSubmitModal .submission-indicator li")
        .eq(0)
        .addClass("complete");
      $("#orderSubmitModal .submission-indicator li")
        .eq(1)
        .addClass("complete");
      $("#orderSubmitModal .submission-indicator li")
        .eq(2)
        .addClass("complete");
        $("#orderSubmitModal .mobile-step-indicator li")
        .eq(0)
        .addClass("complete");
      $("#orderSubmitModal .mobile-step-indicator li")
        .eq(1)
        .addClass("complete");
      $("#orderSubmitModal .mobile-step-indicator li")
        .eq(2)
        .addClass("complete");
      // $('.submission-indicator li').eq(3).addClass('complete');
      // $('.submission-indicator li').eq(4).addClass('complete');
      //
      // $('#processing-message').text('Thank you! Your order has been received.');
      // $('#submission_message').text('We\'ll be contacting you via email shortly with details of your order. Welcome to the NorthState family!');
      //
      // $('#submission_message').removeClass('hide');
      // $('#order-processing-instructions').hide();
      //
      // $('#order-complete-button').removeClass('hide');

      $("#orderSubmitModal .submission-indicator li")
        .eq(3)
        .addClass("complete");
        $("#orderSubmitModal .mobile-step-indicator li")
        .eq(3)
        .addClass("complete");

      finalizeOrder();
    },
    function (request, status, error) {
      localStorage.removeItem(ns_ecomm_session_id_name);

      $("#orderSubmitModal .submission-indicator li")
        .eq(0)
        .removeClass("current");
      $("#orderSubmitModal .submission-indicator li")
        .eq(1)
        .removeClass("current");
      $("#orderSubmitModal .submission-indicator li")
        .eq(2)
        .removeClass("current");
      // $('.submission-indicator li').eq(3).removeClass('current');
      // $('.submission-indicator li').eq(4).removeClass('current');
      //
      $("#orderSubmitModal .submission-indicator li")
        .eq(0)
        .addClass("complete");
        $("#orderSubmitModal .mobile-step-indicator li")
        .eq(0)
        .addClass("complete");
      $("#orderSubmitModal .submission-indicator li")
        .eq(1)
        .addClass("complete");
        $("#orderSubmitModal .mobile-step-indicator li")
        .eq(1)
        .addClass("complete");
      $("#orderSubmitModal .submission-indicator li")
        .eq(2)
        .addClass("complete");
        $("#orderSubmitModal .mobile-step-indicator li")
        .eq(2)
        .addClass("complete");
      // $('.submission-indicator li').eq(3).addClass('complete');
      // $('.submission-indicator li').eq(4).addClass('complete');
      // $('.submission-indicator li').eq(4).addClass('finalOrderStepComplete');
      //
      // $('#processing-message').text('Thank you! Your order has been received.');
      // $('#submission_message').text('We\'ll be contacting you via email shortly with details of your order. Welcome to the NorthState family!');
      //
      // $('#submission_message').removeClass('hide');
      // $('#order-processing-instructions').hide();
      //
      // $('#order-complete-button').removeClass('hide');

      $("#orderSubmitModal .submission-indicator li")
        .eq(3)
        .addClass("complete");
        $("#orderSubmitModal .mobile-step-indicator li")
        .eq(3)
        .addClass("complete");

      finalizeOrder();
    },
  );
}

function finalizeOrder() {
  var $ = jQuery;

  var url = "/shop-fiber/order-complete/";
  var orderDetails = encodeURIComponent(
    $("#product_selected_features").html().replace(/•/g, "&#8226;")
  );

  var orderTotal = parseFloat($("[data-total-price]").text()),
    orderEmail = $("#account_service_email_address").val(),
    orderPhone = $("#account_service_contact_phone").val(),
    orderFirstName = $("#account_service_first_name").val(),
    orderLastName = $("#account_service_last_name").val(),
    orderAddressTechStack = localStorage.getItem('lumos_address_tech_stack'),
    orderCountry = "US",
    agentID = $("#account_service_agent_id").val(),
    hideserviceorderid = false;

  // Fire purchase event for GA4

  // Hide service order id if Legacy VA
  if(orderserviceid == -1) {
    orderserviceid = new Date().toISOString();
    hideserviceorderid = false;
  }

  // GTM DataLayer Event for Enhanced Ecomm
  
  window.dataLayer.push({
    'event': 'purchase',
    'order_value': Number(orderTotal),
    'order_id': orderserviceid,
    'enhanced_conversion_data': {
      "email": orderEmail,
      "phone_number": orderPhone,
      "first_name": orderFirstName,
      "last_name": orderLastName,
      "tech_stack": orderAddressTechStack,
      "street": orderStreet,
      "city": orderCity,
      "region": orderState,
      "postal_code": orderZIP,
      "country": orderCountry,
    },
    // 'clearlink_event_data': clearlinkEventState,
    'agent_id': agentID ?? '',
  });


  // log data layer details
  console.log('dataLayer:', window.dataLayer);

  var ga4DLProducts = [];
  var productSelections = JSON.parse(localStorage.getItem(cookieLabel_product_selection));

  for (var i = 0; i < productSelections.product_feature_selection.length; i++) {
    if (productSelections.product_feature_selection[i].product_feature_checked) {
      if (productSelections.product_feature_selection[i].product_feature_price !== 0) { // Exclude $0 products
        ga4DLProducts.push(
          {
            "item_id": productSelections.product_feature_selection[i].product_feature_id,
            "item_name": productSelections.product_feature_selection[i].product_feature_name.replace(/^\s+|\s+$/g, '').replace(/(<([^>]+)>)/gi, ""),
            "price": Number(productSelections.product_feature_selection[i].product_feature_price),
            "quantity": Number(productSelections.product_feature_selection[i].product_feature_qty),
            "item_category": orderState
          }
        );
      }
    }
  }

  // Send Event & Data for GA4
  var ga4EventData = {
    "transaction_id": orderserviceid,
    "affiliation": orderState,
    "value": Number(orderTotal),
    "tax": parseFloat($("[data-fee-total]").text()),
    "currency": "USD",
    "tech_stack": orderAddressTechStack,
    "items": ga4DLProducts,
    "enhanced_conversion_data": {
      "tech_stack": orderAddressTechStack,
      "street": orderStreet,
      "city": orderCity,
      "region": orderState,
      "postal_code": orderZIP,
      "country": orderCountry
    },
    // 'clearlink_event_data': clearlinkEventState,
    'agent_id': agentID ?? '',
  };
  // console.log('GA4 Event Data', ga4EventData);
  gtag('event', 'purchase', ga4EventData);

  var ga4DL = {
    "event": "purchase",
    "ecommerce": {
      "transaction_id": orderserviceid,
      "affiliation": orderState,
      "value": Number(orderTotal),
      "tax": Number(parseFloat($("[data-fee-total]").text())),
      "currency": "USD",
      "tech_stack": orderAddressTechStack,
      "items": ga4DLProducts,
      "enhanced_conversion_data": {
        "tech_stack": orderAddressTechStack,
        "street": orderStreet,
        "city": orderCity,
        "region": orderState,
        "postal_code": orderZIP,
        "country": orderCountry
      },
    },
    // 'clearlink_event_data': clearlinkEventState,
    'agent_id': agentID ?? '',
  };

  console.log('GA4DL:', ga4DL);

  // Push Legacy DataLayer GTM
  
  window.dataLayer.push(ga4DL);

  var orderCompleteForm =
    '<form action="' +
    url +
    '" method="post">' +
    '<input type="hidden" name="ordertotal" value="' +
    orderTotal +
    '" />' +
    '<input type="hidden" name="orderemail" value="' +
    orderEmail +
    '" />' +
    '<input type="hidden" name="orderphone" value="' +
    orderPhone +
    '" />' +
    '<input type="hidden" name="orderfirstname" value="' +
    orderFirstName +
    '" />' +
    '<input type="hidden" name="orderlastname" value="' +
    orderLastName +
    '" />' +
    '<input type="hidden" name="ordertechstack" value="' +
    orderAddressTechStack +
    '" />' +
    '<input type="hidden" name="orderstreet" value="' +
    orderStreet +
    '" />' +
    '<input type="hidden" name="ordercity" value="' +
    orderCity +
    '" />' +
    '<input type="hidden" name="orderstate" value="' +
    orderState +
    '" />' +
    '<input type="hidden" name="orderzip" value="' +
    orderZIP +
    '" />' +
    '<input type="hidden" name="ordercountry" value="' +
    orderCountry +
    '" />' +
    '<input type="hidden" name="agentid" value="' +
    agentID +
    '" />' +
    '<input type="hidden" name="orderitems" value="' +
    escape(localStorage.getItem(cookieLabel_product_selection)) +
    '" />' +
    '<input type="hidden" name="ordertax" value="' +
    parseFloat($("[data-fee-total]").text()) +
    '" />' +
    '<input type="hidden" name="orderdetails" value="' +
    orderDetails +
    '" />' +
    '<input type="hidden" name="orderaccountid" value="' +
    orderaccountid +
    '" />' +
    '<input type="hidden" name="orderserviceid" value="' +
    orderserviceid +
    '" />' +
    '<input type="hidden" name="hideserviceorderid" value="' +
    hideserviceorderid +
    '" />' +
    '<input type="hidden" name="ordermonthly" value="' +
    parseFloat($("[data-total-price]").text()) +
    '" />' +
    "</form>";

  // console.log(orderCompleteForm);

  var $orderCompleteObj = $(orderCompleteForm);
  $("body").append($orderCompleteObj);

  //remove on before unload confirmation popup to easily nav user off
  window.onbeforeunload = null;

  // Delay for a few seconds to allow finish animation to complete
  setTimeout(() => {
    $orderCompleteObj.submit();
  }, 3500);
}

// **
// * Cancel order action
// **
function cancelOrder() {
  var $ = jQuery;

  // logNSEvent("ecomm - order processing - Order Cancelled via Processing Screen Option");
  $("#processing-message").text("Your Order Has Been Cancelled");
  $("#order-processing-instructions").html(
    'Please contact customer support at <a href="tel:3368863600">336.886.3600</a> if you require further assistance.'
  );

  $(".progress-order").addClass("hide");
  $("#submission_error_message").addClass("hide");
  $("#submission_message").addClass("hide");
  $("#credit-check-deposit").addClass("hide");
  $("#order-cancel-button").addClass("hide");
  $("#credit-check-payment").addClass("hide");
  $("#schedule-installation-date").addClass("hide");

  $(".close-reveal-modal").addClass("hide");
  $(".view-order").addClass("hide");

  $("#order-cancel-button").removeClass("hide");
}

function clearAddressSelection() {
  var $ = jQuery;

  var addressLS = [
    "lumos_address_full_address",
    "lumos_address_place_id",
    "lumos_location_id",
    "lumos_address_id",
    "lumos_address_status",
    "lumos_address_check_decline",
    "lumos_address_city",
    "lumos_address_city_id",
    "lumos_address_state",
    "lumos_address_state_id",
    "lumos_address_street",
    "lumos_address_street_id",
    "lumos_address_zip",
    "lumos_address_house_num",
    "lumos_address_apt_num",
    "lumos_address_multigig",
    "lumos_address_market",
  ];

  for (var a = 0; a < addressLS.length; a++) {
    // console.log(addressCookies[a]);
    localStorage.removeItem(addressLS[a]);
  }
}

function pushGA4EcommData(event) {
  var ecommDataObj = {
    page_name: window.location.pathname,
    page_referer: document.referrer,
    value: Number($("[data-total-price]").text()),
    tax: $("#ns-regulatory-fees").val(),
    items: [],
  };

  $(
    '#order-info .order-step[data-order-step="1"] input, #order-info .order-step[data-order-step="1"] select, #order-info .order-step[data-order-step="2"] input, #order-info .order-step[data-order-step="2"] select, #order-info .order-step[data-order-step="3"] input, #order-info .order-step[data-order-step="3"] select'
  ).each(function () {
    // $('.product-select input:checked').each(function() {

    var product_feature_id = $(this).attr("data-product-feature-id"),
      product_feature_checked = false,
      product_feature_qty = 1,
      product_feature_name = "",
      product_feature_price = 0;

    if ($(this).is("select")) {
      product_feature_qty = parseInt($(this).val());
      if (product_feature_qty > 0) {
        product_feature_checked = true;
      }
    } else {
      product_feature_checked = $(this).prop("checked");
    }

    if ($(this).parents("label").find("[data-product-price]").length) {
      product_feature_price = $(this)
        .parents("label")
        .find("[data-product-price]")
        .text();
    }

    product_feature_name = $(this)
      .parents("label")
      .find(".feature-desc")
      .text()
      .replace(/^\s+|\s+$/g, "")
      .replace(/(<([^>]+)>)/gi, "");

    if (
      typeof $(this)
        .parents("label")
        .find(".feature-desc")
        .attr("data-legacy-name") !== "undefined" &&
      $(this).parents("label").find(".feature-desc").attr("data-legacy-name")
        .length
    ) {
      product_feature_name = $(this)
        .parents("label")
        .find(".feature-desc")
        .attr("data-legacy-name")
        .replace(/^\s+|\s+$/g, "")
        .replace(/(<([^>]+)>)/gi, "");
    }

    if (product_feature_id && !product_feature_id.startsWith("000")) {
      if (product_feature_checked) {
        ecommDataObj.items.push({
          item_id: product_feature_id,
          item_name: product_feature_name,
          price: Number(product_feature_price),
          quantity: product_feature_qty,
        });
      }
    }
  });

  var ga4Data = {
    street: localStorage.getItem("lumos_address_street"),
    city: localStorage.getItem("lumos_address_city"),
    state: localStorage.getItem("lumos_address_state"),
    tech_stack: localStorage.getItem("lumos_address_tech_stack"),
    postal_code: localStorage.getItem("lumos_address_zip"),
    country: "USA",
    page_name: ecommDataObj.page_name,
    page_referer: ecommDataObj.page_referrer,
    value: Number(ecommDataObj.value),
    tax: Number(ecommDataObj.tax),
    items: ecommDataObj.items,
  };
  // console.log('GA4 Push', event, ga4Data);
  // gtag('event', event, ga4Data);

  var ga4DL = {
    event: event,
    ga4Data,
  };

  console.log("GA4 Push", event, ga4DL);

  
  window.dataLayer.push(ga4DL);
}

$(document).ready(function () {
  // console.log("adjust cards to flash marge");
  // console.log($(".card.feature-label .flash-margin").length);
  if ($(".card.feature-label.flash-margin").length > 0) {
    $(".card.feature-label").addClass("flash-margin");
  }
});

// })(jQuery);

function setEqualShopCardHeight() {
  let max_height = 0;

  let anyHidden = Array.from(document.querySelectorAll(".speed-cards-carousel.fieldset-container .flash-sale-info")).some((el) => {
    return window.getComputedStyle(el).display === 'none';
  });
  if (anyHidden) {
    return;
  }
  document.querySelectorAll(".speed-cards-carousel.fieldset-container .flash-sale-info").forEach((el) => {
    el.style.height = "auto!important";
  });

  document.querySelectorAll(".speed-cards-carousel.fieldset-container .flash-sale-info").forEach((el) => {
    var height = el.offsetHeight;
    if (height > max_height) {
      max_height = height;
    }
  });

  document.querySelectorAll(".speed-cards-carousel.fieldset-container .flash-sale-info").forEach((el) => {
    el.style.height = max_height + "px!important";
  });

  if (window.innerWidth > 600) {
    document.querySelectorAll(".speed-cards-carousel.fieldset-container .card").forEach((card) => {
      card.style.paddingTop = max_height - 20 + "px";
    });
  }

  document
    .querySelectorAll(".wf-shopfiber-v3 .speed-cards-carousel.fieldset-container label.card input[type=radio]")
    .forEach((radio) => {
      radio.style.top = max_height - 20 + "px";
  });

  document.querySelectorAll(".speed-cards-carousel.fieldset-container .card").forEach((card) => {
    card.style.marginTop = max_height + "px";
  });
}

window.onload = function () {
  var hasFlashSale = false;

  $(".card").each(function () {
    var $thisCard = $(this);
    var $flashSaleInfo = $thisCard.find('.flash-sale-info');
    var $featuredFeatureCallout = $thisCard.find('.featured-feature-callout');

    if($flashSaleInfo.length > 0) {
      hasFlashSale = true;
    }
  });

  if (hasFlashSale) {
    setEqualShopCardHeight();
    window.addEventListener("resize", setEqualShopCardHeight);
  }
};

function lazyScroll() {
  // Select all elements with data-lazy-scroll-from attribute
  $('[data-lazy-scroll-from]').each(function() {
      var fromId = $(this).data('lazy-scroll-from');
      var targetCheckbox = $('[data-product-feature-id="' + fromId + '"]');
      // Add listener for smooth scroll to target selection
      if (targetCheckbox.length) {
          targetCheckbox.on('change', function() {
              if (this.checked) {
                  var targetOffsetTop = $('[data-lazy-scroll-from="' + fromId + '"]').offset().top;
                  if ($('#header').length) {
                      targetOffsetTop -= $('#header').outerHeight();
                  }
                  if ($('#wpadminbar').length) {
                      targetOffsetTop -= $('#wpadminbar').outerHeight();
                  }
                  $('html, body').animate({
                      scrollTop: targetOffsetTop
                  }, 'slow');
                }
          });
      }
  });
}

$(document).on('click', '#ga-submit-order, #ga-submit-order-2', function() {
  clearTimeout(closerTimer);
  closerTimer = null;
});
// function getSupportNumber that returns a string
function getSupportNumber() {
  var supportElementHtml = "";
  if (
    localStorage.getItem("lumos_address_tech_stack") &&
    localStorage.getItem("lumos_address_tech_stack") == "legacy"
  ) {
    supportElementHtml = $('a[data-support-number][data-old-stack]').prop('outerHTML');
  } else {
    supportElementHtml = $('a[data-support-number][data-new-stack]').prop('outerHTML');
  }
  return supportElementHtml;
}

function checkStack(){
  return localStorage.getItem("lumos_address_tech_stack")?.toLowerCase();
}

function debounce(func, wait) {
  var timeout;
  return function() {
    var context = this, args = arguments;
    clearTimeout(timeout);
    timeout = setTimeout(function() {
      timeout = null;
      func.apply(context, args);
    }, wait);
  };
}

/*
  * Function to make an AJAX call to the API Helper
  *
  * @param {object} data - The data to send to the API
  * @param {function} successCallback - The function to call on success
  * @param {function} errorCallback - The function to call on error after retries exhausted
  *
  * @return {void}
  *
*/
function ajaxCall(data, successCallback = null, errorCallback = null, url = "/wp-content/themes/lumos-tidewater/api_helper.php", async=true) {
  var ajaxRetries = 10;

  //  set steplabel to action or url if not provided
  data.stepLabel = data.stepLabel ? data.stepLabel : data.action ? data.action : url;

  startNSTimer(); //start timer here for all calls

  function makeRequest() {
    $.ajax(
      {
        url: url,
        method: "POST",
        contentType: "application/x-www-form-urlencoded",
        data: data,
        cache: false,
        async: async,
        success: function (result) {
          // Parse the result with provided logic
          // Do not send timer here, allow each function to handle success condition
          if(typeof successCallback === 'function') {
            successCallback(result);
          } else {
            console.error("Success callback not provided.");
          }
        },
        error: function (request, status, error) {
          if(ajaxRetries > 0) {
            // sendnserror with provided step label
            let stepLabel = data.stepLabel ? data.stepLabel : "";
            sendNSError(
              stepLabel + "-APICommError-RetriesLeft:" + ajaxRetries
            );
            makeRequest();
          }else{
            // Out of retries, send error and call provided error callback
            let errorInfo = "";
            if(request.responseText){
              errorInfo += request.responseText;
            }else{
              errorInfo += "Status: " + request.status + " " + request.statusText;
            }
            envConsoleLog("Error: " + error + " - Request: " + errorInfo);

            sendNSError(
              data.stepLabel + "-APICommError:" + errorInfo
            );
            if (typeof errorCallback === 'function') {
              errorCallback(request, status, error);
            } else {
              console.error("Error occurred, but no error handler provided.");
            }
          }
          ajaxRetries--;
        }
      }
    );
  }

  // Initial call
  makeRequest();
}

/*
*   Function to disable step buttons and prevent steps from changing
*
*/
function disableStepProgression(){
  $(".order-step button.next-step").attr("disabled", 'true');
  $("a[data-goto-step]").css("pointer-events", 'none');
}

function enableStepProgression(){
  $(".order-step button.next-step").removeAttr("disabled");
  $("a[data-goto-step]").css("pointer-events", 'all');
}


/*
  Push stored data to dataLayer, for data from other pages that needs to be on /shop
*/
function pushStoredFEACData() {
  const storedData = localStorage.getItem("readyToPushFEAC");

  if (storedData) {
    try {
      const feacData = JSON.parse(storedData);
      console.log("Pushing stored FEAC data:", feacData);

      // Push the entire stored object directly to the dataLayer
      window.dataLayer.push(feacData);

      console.log("GA4 Push", feacData); 

      localStorage.removeItem("readyToPushFEAC"); // Clear after successful push
    } catch (error) {
      console.error("Error parsing or pushing stored FEAC data:", error);
    }
  } else {
    console.log("No stored FEAC data found.");
  }
}